//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BaseApiClient {
    /**
     * Base class for all generated nswag clients.
     *
     * If something is changed in this file the clients will need to be re-generated using the nswag cli.
     *
     * The comment is placed inside the class as nswag will place it at the end of all generated api files if moved
     * above the class declaration.
     */

    /** The locale to set as the Accept-Language header */
    public locale: string | null = null;

    /** The authorization header to set */
    public authorization: string | null = null;

    /**
     * Transforms the request options right before sending the api request.
     */
    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const headers = new Headers(options.headers);

        if (this.locale) {
            headers.set('Accept-Language', this.locale);
        }

        if (this.authorization) {
            headers.set('Authorization', this.authorization);
        }

        return { ...options, headers };
    }
}

export class ApplicationNoticeApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get notices for a specific location.
    Cached for 10 minutes.
     * @param locationId The location to get notices for.
     * @param type (optional) The application notice type to retrieve, null to retrieve all notices.
     * @return OK
     */
    apiApplicationNoticeByLocationByLocationIdGet(locationId: string, type: ApplicationNoticeType | undefined, signal?: AbortSignal): Promise<ApplicationNoticeDto[]> {
        let url_ = this.baseUrl + "/api/application-notice/by-location/{locationId}?";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        if (type === null)
            throw new globalThis.Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiApplicationNoticeByLocationByLocationIdGet(_response);
        });
    }

    protected processApiApplicationNoticeByLocationByLocationIdGet(response: Response): Promise<ApplicationNoticeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationNoticeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationNoticeDto[]>(null as any);
    }
}

export class AreaApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve an area by id.
     * @param id The id of the area.
     * @return OK
     */
    apiAreaGetByIdGet(id: string, signal?: AbortSignal): Promise<AreaDto> {
        let url_ = this.baseUrl + "/api/Area/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiAreaGetByIdGet(_response);
        });
    }

    protected processApiAreaGetByIdGet(response: Response): Promise<AreaDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AreaDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaDto>(null as any);
    }

    /**
     * @return OK
     */
    apiAreaListByParentGet(parent: string, signal?: AbortSignal): Promise<AreaDto[]> {
        let url_ = this.baseUrl + "/api/Area/List/{parent}";
        if (parent === undefined || parent === null)
            throw new globalThis.Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiAreaListByParentGet(_response);
        });
    }

    protected processApiAreaListByParentGet(response: Response): Promise<AreaDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AreaDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AreaDto[]>(null as any);
    }
}

export class ChildClassApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieving childclasses for a specific playground with data needed for gui presentation.
     * @param playgroundId The playground Id
     * @return OK
     */
    apiChildClassByPlaygroundByPlaygroundIdGet(playgroundId: string, signal?: AbortSignal): Promise<ChildClassesAvailableModel[]> {
        let url_ = this.baseUrl + "/api/child-class/by-playground/{playgroundId}";
        if (playgroundId === undefined || playgroundId === null)
            throw new globalThis.Error("The parameter 'playgroundId' must be defined.");
        url_ = url_.replace("{playgroundId}", encodeURIComponent("" + playgroundId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassByPlaygroundByPlaygroundIdGet(_response);
        });
    }

    protected processApiChildClassByPlaygroundByPlaygroundIdGet(response: Response): Promise<ChildClassesAvailableModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChildClassesAvailableModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassesAvailableModel[]>(null as any);
    }

    /**
     * Get available t-shirt sizes.
     * @return OK
     */
    apiChildClassTShirtSizesGet(signal?: AbortSignal): Promise<string[]> {
        let url_ = this.baseUrl + "/api/child-class/t-shirt-sizes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassTShirtSizesGet(_response);
        });
    }

    protected processApiChildClassTShirtSizesGet(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ChildClassBookingApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new booking.
     * @param body (optional) The booking model.
     * @return OK
     */
    apiChildClassBookingPost(body: CreateChildClassBookingCommand | undefined, signal?: AbortSignal): Promise<CreateChildClassBookingResultDto> {
        let url_ = this.baseUrl + "/api/child-class/booking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassBookingPost(_response);
        });
    }

    protected processApiChildClassBookingPost(response: Response): Promise<CreateChildClassBookingResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateChildClassBookingResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateChildClassBookingResultDto>(null as any);
    }

    /**
     * Get the confirmation summary for a given booking.
     * @param bookingId The id of the booking.
     * @param orderReference The order reference for the booking.
     * @return OK
     */
    apiChildClassBookingByBookingIdConfirmationInformationByOrderReferenceGet(bookingId: string, orderReference: string, signal?: AbortSignal): Promise<ChildClassBookingConfirmationSummaryModel> {
        let url_ = this.baseUrl + "/api/child-class/booking/{bookingId}/confirmation-information/{orderReference}";
        if (bookingId === undefined || bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        if (orderReference === undefined || orderReference === null)
            throw new globalThis.Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassBookingByBookingIdConfirmationInformationByOrderReferenceGet(_response);
        });
    }

    protected processApiChildClassBookingByBookingIdConfirmationInformationByOrderReferenceGet(response: Response): Promise<ChildClassBookingConfirmationSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildClassBookingConfirmationSummaryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassBookingConfirmationSummaryModel>(null as any);
    }
}

export class ChildClassBookingPaymentApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a payment session for the given booking.
     * @param body (optional) The command model.
     * @return OK
     */
    apiChildClassPaymentPost(body: CreateChildClassBookingPaymentCommand | undefined, signal?: AbortSignal): Promise<ChildClassBookingPaymentModel> {
        let url_ = this.baseUrl + "/api/child-class/payment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassPaymentPost(_response);
        });
    }

    protected processApiChildClassPaymentPost(response: Response): Promise<ChildClassBookingPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildClassBookingPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassBookingPaymentModel>(null as any);
    }

    /**
     * Get receipts for a given booking.
     * @param bookingId The id of the booking to get the receipt for.
     * @return OK
     */
    apiChildClassByBookingIdReceiptsGet(bookingId: string, signal?: AbortSignal): Promise<ChildClassBookingReceiptModel[]> {
        let url_ = this.baseUrl + "/api/child-class/{bookingId}/receipts";
        if (bookingId === undefined || bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassByBookingIdReceiptsGet(_response);
        });
    }

    protected processApiChildClassByBookingIdReceiptsGet(response: Response): Promise<ChildClassBookingReceiptModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChildClassBookingReceiptModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassBookingReceiptModel[]>(null as any);
    }

    /**
     * Get the payment status for a specific booking.
     * @param bookingId (optional) The id of the booking to get payment status for.
     * @return OK
     */
    apiChildClassStatusGet(bookingId: string | undefined, signal?: AbortSignal): Promise<ChildClassBookingPaymentStatus> {
        let url_ = this.baseUrl + "/api/child-class/status?";
        if (bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' cannot be null.");
        else if (bookingId !== undefined)
            url_ += "bookingId=" + encodeURIComponent("" + bookingId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiChildClassStatusGet(_response);
        });
    }

    protected processApiChildClassStatusGet(response: Response): Promise<ChildClassBookingPaymentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            return throwException("Bad Request", status, _responseText, _headers);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("Not Found", status, _responseText, _headers);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            return throwException("Internal Server Error", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildClassBookingPaymentStatus>(null as any);
    }
}

export class CountryApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a country by id.
     * @param id The id of the country.
     * @return OK
     */
    apiCountryGetByIdGet(id: string, signal?: AbortSignal): Promise<CountryDto> {
        let url_ = this.baseUrl + "/api/Country/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiCountryGetByIdGet(_response);
        });
    }

    protected processApiCountryGetByIdGet(response: Response): Promise<CountryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto>(null as any);
    }

    /**
     * @param includeregions (optional) 
     * @return OK
     */
    apiCountryListGet(includeregions: boolean | undefined, signal?: AbortSignal): Promise<CountryDto[]> {
        let url_ = this.baseUrl + "/api/Country/List?";
        if (includeregions === null)
            throw new globalThis.Error("The parameter 'includeregions' cannot be null.");
        else if (includeregions !== undefined)
            url_ += "includeregions=" + encodeURIComponent("" + includeregions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiCountryListGet(_response);
        });
    }

    protected processApiCountryListGet(response: Response): Promise<CountryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto[]>(null as any);
    }

    /**
     * Retrieve phone metadata for a country.
     * @return OK
     */
    apiCountryMetadataGet(signal?: AbortSignal): Promise<CountryMetadataDto> {
        let url_ = this.baseUrl + "/api/Country/Metadata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiCountryMetadataGet(_response);
        });
    }

    protected processApiCountryMetadataGet(response: Response): Promise<CountryMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CountryMetadataDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryMetadataDto>(null as any);
    }

    /**
     * Retrieve a cached variant of the country list.
     * @param includeregions (optional) True if the regions should be included, false otherwise. Defaults to false.
     * @return OK
     */
    apiCountryFrontEndListGet(includeregions: boolean | undefined, signal?: AbortSignal): Promise<CountryDto[]> {
        let url_ = this.baseUrl + "/api/Country/FrontEndList?";
        if (includeregions === null)
            throw new globalThis.Error("The parameter 'includeregions' cannot be null.");
        else if (includeregions !== undefined)
            url_ += "includeregions=" + encodeURIComponent("" + includeregions) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiCountryFrontEndListGet(_response);
        });
    }

    protected processApiCountryFrontEndListGet(response: Response): Promise<CountryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CountryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountryDto[]>(null as any);
    }
}

export class GiftCardArticlesApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a gift card article.
     * @param id The id of the gift card article to retrieve.
     * @return OK
     */
    apiShopGiftCardsByIdGet(id: number, signal?: AbortSignal): Promise<SellableGiftCardArticleModel> {
        let url_ = this.baseUrl + "/api/shop/gift-cards/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardsByIdGet(_response);
        });
    }

    protected processApiShopGiftCardsByIdGet(response: Response): Promise<SellableGiftCardArticleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellableGiftCardArticleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellableGiftCardArticleModel>(null as any);
    }

    /**
     * Retrieve all available, active, gift card articles by country.
     * @param locationId The country to get the gift cards for.
     * @return OK
     */
    apiShopGiftCardsByLocationByLocationIdGet(locationId: string, signal?: AbortSignal): Promise<GiftCardArticleSummaryModel[]> {
        let url_ = this.baseUrl + "/api/shop/gift-cards/by-location/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardsByLocationByLocationIdGet(_response);
        });
    }

    protected processApiShopGiftCardsByLocationByLocationIdGet(response: Response): Promise<GiftCardArticleSummaryModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GiftCardArticleSummaryModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCardArticleSummaryModel[]>(null as any);
    }
}

export class GiftCardOrderApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get an order summary, without placing an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopGiftCardOrdersSummaryPost(body: GetGiftCardOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<GiftCardOrderSummaryModel> {
        let url_ = this.baseUrl + "/api/shop/gift-card/orders/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardOrdersSummaryPost(_response);
        });
    }

    protected processApiShopGiftCardOrdersSummaryPost(response: Response): Promise<GiftCardOrderSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftCardOrderSummaryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCardOrderSummaryModel>(null as any);
    }

    /**
     * Create a new order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopGiftCardOrdersPost(body: CreateGiftCardOrderCommand | undefined, signal?: AbortSignal): Promise<GiftCardOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/gift-card/orders";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardOrdersPost(_response);
        });
    }

    protected processApiShopGiftCardOrdersPost(response: Response): Promise<GiftCardOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GiftCardOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCardOrderPaymentModel>(null as any);
    }

    /**
     * Retrieve the payment status of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopGiftCardOrdersByOrderReferenceStatusGet(orderReference: string, signal?: AbortSignal): Promise<GiftCardOrderPaymentStatus> {
        let url_ = this.baseUrl + "/api/shop/gift-card/orders/{orderReference}/status";
        if (orderReference === undefined || orderReference === null)
            throw new globalThis.Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardOrdersByOrderReferenceStatusGet(_response);
        });
    }

    protected processApiShopGiftCardOrdersByOrderReferenceStatusGet(response: Response): Promise<GiftCardOrderPaymentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GiftCardOrderPaymentStatus>(null as any);
    }

    /**
     * Retrieve the tracking event of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopGiftCardOrdersByOrderReferenceTrackingEventGet(orderReference: string, signal?: AbortSignal): Promise<ShopPurchaseEvent> {
        let url_ = this.baseUrl + "/api/shop/gift-card/orders/{orderReference}/tracking-event";
        if (orderReference === undefined || orderReference === null)
            throw new globalThis.Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopGiftCardOrdersByOrderReferenceTrackingEventGet(_response);
        });
    }

    protected processApiShopGiftCardOrdersByOrderReferenceTrackingEventGet(response: Response): Promise<ShopPurchaseEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopPurchaseEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShopPurchaseEvent>(null as any);
    }
}

export class LocationApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get location by id.
     * @param id The id of the location.
     * @return OK
     */
    apiLocationGetLocationByIdGet(id: string, signal?: AbortSignal): Promise<LocationDto> {
        let url_ = this.baseUrl + "/api/Location/GetLocation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetLocationByIdGet(_response);
        });
    }

    protected processApiLocationGetLocationByIdGet(response: Response): Promise<LocationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto>(null as any);
    }

    /**
     * Delete a location by id.
     * @param id The id of the location.
     * @return OK
     */
    apiLocationDeleteLocationByIdDelete(id: string, signal?: AbortSignal): Promise<LocationDto> {
        let url_ = this.baseUrl + "/api/Location/DeleteLocation/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationDeleteLocationByIdDelete(_response);
        });
    }

    protected processApiLocationDeleteLocationByIdDelete(response: Response): Promise<LocationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto>(null as any);
    }

    /**
     * Retrieve the location tree list (Countries, regions, playgrounds etc.) given a specific scope.
     * @param scope (optional) The scope, if omitted all levels will be returned (except tables).
     * @return OK
     */
    apiLocationGetTreeGet(scope: LocationTreeLevels | undefined, signal?: AbortSignal): Promise<LocationTreeDto> {
        let url_ = this.baseUrl + "/api/Location/GetTree?";
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetTreeGet(_response);
        });
    }

    protected processApiLocationGetTreeGet(response: Response): Promise<LocationTreeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationTreeDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationTreeDto>(null as any);
    }

    /**
     * Get a list of all locations.
     * @return OK
     */
    apiLocationGetListGet(signal?: AbortSignal): Promise<LocationListDto> {
        let url_ = this.baseUrl + "/api/Location/GetList";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetListGet(_response);
        });
    }

    protected processApiLocationGetListGet(response: Response): Promise<LocationListDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LocationListDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationListDto>(null as any);
    }

    /**
     * Get a list of all locations for a given scope.
     * @param scope The scope to retrieve locations for.
     * @return OK
     */
    apiLocationGetListByScopeGet(scope: LocationTreeLevels, signal?: AbortSignal): Promise<LocationListItem[]> {
        let url_ = this.baseUrl + "/api/Location/GetList/{scope}";
        if (scope === undefined || scope === null)
            throw new globalThis.Error("The parameter 'scope' must be defined.");
        url_ = url_.replace("{scope}", encodeURIComponent("" + scope));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationGetListByScopeGet(_response);
        });
    }

    protected processApiLocationGetListByScopeGet(response: Response): Promise<LocationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationListItem[]>(null as any);
    }

    /**
     * Get a cached list of all locations for a given scope.
     * @param scope (optional) The scope to retrieve locations for.
     * @return OK
     */
    apiLocationFontEndGetListGet(scope: LocationTreeLevels | undefined, signal?: AbortSignal): Promise<LocationListItem[]> {
        let url_ = this.baseUrl + "/api/Location/FontEndGetList?";
        if (scope === null)
            throw new globalThis.Error("The parameter 'scope' cannot be null.");
        else if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationFontEndGetListGet(_response);
        });
    }

    protected processApiLocationFontEndGetListGet(response: Response): Promise<LocationListItem[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationListItem.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationListItem[]>(null as any);
    }

    /**
     * Search for a location.
     * @param query (optional) The search query.
     * @param loctype (optional) The location type.
     * @return OK
     */
    apiLocationSearchLocationGet(query: string | undefined, loctype: string | undefined, signal?: AbortSignal): Promise<LocationDto[]> {
        let url_ = this.baseUrl + "/api/Location/SearchLocation?";
        if (query === null)
            throw new globalThis.Error("The parameter 'query' cannot be null.");
        else if (query !== undefined)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        if (loctype === null)
            throw new globalThis.Error("The parameter 'loctype' cannot be null.");
        else if (loctype !== undefined)
            url_ += "loctype=" + encodeURIComponent("" + loctype) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiLocationSearchLocationGet(_response);
        });
    }

    protected processApiLocationSearchLocationGet(response: Response): Promise<LocationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LocationDto[]>(null as any);
    }
}

export class MediaApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Resize a Leo.Database.Entities.Media.MediaItemEntity.
     * @param mediaId The id of the media
     * @param version The version of the image to retrieve, used as a cache buster when an image is updated.
     * @param resizedOption The crop option
     * @param outputFormat The output format.
     * @param quality (optional) The output quality, 0-100 where 100 is the best quality.
     * @param width (optional) The output width, if left empty a default width (250px) will be used if height is also left empty (max 6000).
     * @param height (optional) The output height, if left empty a default height will be used (max 6000).
     * @param backgroundColor (optional) The background color as a hexidecimal 8 character string (RRGGBBAA) where AA is the alpha value, defaults to black.
     * @param focusX (optional) Horizontal offset, 0 = left, 0.5 = center, 1 = right
     * @param focusY (optional) Vertical offset, 0 = top, 0.5 = center, 1 = bottom.
     * @param preventUpScaling (optional) True to disable up-scaling, false otherwise.
     * @return OK
     */
    mediaResizeMediaByMediaIdByVersionByResizedOptionByOutputFormatGet(mediaId: string, version: number, resizedOption: ImageCropOptions, outputFormat: MediaType, quality: number | undefined, width: number | undefined, height: number | undefined, backgroundColor: string | undefined, focusX: number | undefined, focusY: number | undefined, preventUpScaling: boolean | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/media/ResizeMedia/{mediaId}/{version}/{resizedOption}/{outputFormat}?";
        if (mediaId === undefined || mediaId === null)
            throw new globalThis.Error("The parameter 'mediaId' must be defined.");
        url_ = url_.replace("{mediaId}", encodeURIComponent("" + mediaId));
        if (version === undefined || version === null)
            throw new globalThis.Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        if (resizedOption === undefined || resizedOption === null)
            throw new globalThis.Error("The parameter 'resizedOption' must be defined.");
        url_ = url_.replace("{resizedOption}", encodeURIComponent("" + resizedOption));
        if (outputFormat === undefined || outputFormat === null)
            throw new globalThis.Error("The parameter 'outputFormat' must be defined.");
        url_ = url_.replace("{outputFormat}", encodeURIComponent("" + outputFormat));
        if (quality === null)
            throw new globalThis.Error("The parameter 'quality' cannot be null.");
        else if (quality !== undefined)
            url_ += "quality=" + encodeURIComponent("" + quality) + "&";
        if (width === null)
            throw new globalThis.Error("The parameter 'width' cannot be null.");
        else if (width !== undefined)
            url_ += "width=" + encodeURIComponent("" + width) + "&";
        if (height === null)
            throw new globalThis.Error("The parameter 'height' cannot be null.");
        else if (height !== undefined)
            url_ += "height=" + encodeURIComponent("" + height) + "&";
        if (backgroundColor === null)
            throw new globalThis.Error("The parameter 'backgroundColor' cannot be null.");
        else if (backgroundColor !== undefined)
            url_ += "backgroundColor=" + encodeURIComponent("" + backgroundColor) + "&";
        if (focusX === null)
            throw new globalThis.Error("The parameter 'focusX' cannot be null.");
        else if (focusX !== undefined)
            url_ += "focusX=" + encodeURIComponent("" + focusX) + "&";
        if (focusY === null)
            throw new globalThis.Error("The parameter 'focusY' cannot be null.");
        else if (focusY !== undefined)
            url_ += "focusY=" + encodeURIComponent("" + focusY) + "&";
        if (preventUpScaling === null)
            throw new globalThis.Error("The parameter 'preventUpScaling' cannot be null.");
        else if (preventUpScaling !== undefined)
            url_ += "preventUpScaling=" + encodeURIComponent("" + preventUpScaling) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMediaResizeMediaByMediaIdByVersionByResizedOptionByOutputFormatGet(_response);
        });
    }

    protected processMediaResizeMediaByMediaIdByVersionByResizedOptionByOutputFormatGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OpeningHoursApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get opening hours for a location
     * @param location (optional) The location to fetch opening hours for
     * @param from (optional) From which date to fetch opening hours for
     * @param to (optional) To which date to fetch opening hours for
     * @return OK
     */
    apiOpeninghoursOverviewGet(location: string | undefined, from: Date | undefined, to: Date | undefined, signal?: AbortSignal): Promise<OpeningHoursDto[]> {
        let url_ = this.baseUrl + "/api/openinghours/overview?";
        if (location === null)
            throw new globalThis.Error("The parameter 'location' cannot be null.");
        else if (location !== undefined)
            url_ += "location=" + encodeURIComponent("" + location) + "&";
        if (from === null)
            throw new globalThis.Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            url_ += "from=" + encodeURIComponent(from ? "" + from.toISOString() : "") + "&";
        if (to === null)
            throw new globalThis.Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            url_ += "to=" + encodeURIComponent(to ? "" + to.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiOpeninghoursOverviewGet(_response);
        });
    }

    protected processApiOpeninghoursOverviewGet(response: Response): Promise<OpeningHoursDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpeningHoursDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpeningHoursDto[]>(null as any);
    }

    /**
     * Get opening hours for the upcoming week for a location
     * @param locationId (optional) The location id to fetch opening hours for
     * @return OK
     */
    apiOpeninghoursOverviewwpGet(locationId: string | undefined, signal?: AbortSignal): Promise<OpeningHoursDto[]> {
        let url_ = this.baseUrl + "/api/openinghours/overviewwp?";
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiOpeninghoursOverviewwpGet(_response);
        });
    }

    protected processApiOpeninghoursOverviewwpGet(response: Response): Promise<OpeningHoursDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OpeningHoursDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpeningHoursDto[]>(null as any);
    }
}

export class PartyBookingApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiPartyBookingGetByIdGet(id: string, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetByIdGet(_response);
        });
    }

    protected processApiPartyBookingGetByIdGet(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * Remind all guests that have yet to answer the invitation.
     * @param bookingId The party booking id.
     * @return OK
     */
    apiPartyBookingRemindPendingGuestsByBookingIdPost(bookingId: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/party/booking/RemindPendingGuests/{bookingId}";
        if (bookingId === undefined || bookingId === null)
            throw new globalThis.Error("The parameter 'bookingId' must be defined.");
        url_ = url_.replace("{bookingId}", encodeURIComponent("" + bookingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingRemindPendingGuestsByBookingIdPost(_response);
        });
    }

    protected processApiPartyBookingRemindPendingGuestsByBookingIdPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingRemindGuestPost(body: RemindGuestDto | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/party/booking/RemindGuest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingRemindGuestPost(_response);
        });
    }

    protected processApiPartyBookingRemindGuestPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Remind a specific guest.
     * @param body (optional) The remind model.
     * @return OK
     */
    apiPartyBookingSendPartyInvitesPost(body: RemindGuestDto | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/party/booking/SendPartyInvites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingSendPartyInvitesPost(_response);
        });
    }

    protected processApiPartyBookingSendPartyInvitesPost(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingMakeReservationPost(body: PartyReservationMakeRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/MakeReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingMakeReservationPost(_response);
        });
    }

    protected processApiPartyBookingMakeReservationPost(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingChangeReservationPut(body: PartyReservationChangeRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ChangeReservation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingChangeReservationPut(_response);
        });
    }

    protected processApiPartyBookingChangeReservationPut(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingChangeBackgroundPut(body: PartyBookingChangeBackgroundDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ChangeBackground";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingChangeBackgroundPut(_response);
        });
    }

    protected processApiPartyBookingChangeBackgroundPut(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingChangePut(body: PartyBookingChangeRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/Change";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingChangePut(_response);
        });
    }

    protected processApiPartyBookingChangePut(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingConfirmDateChangePut(body: PartyBookingChangeRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ConfirmDateChange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingConfirmDateChangePut(_response);
        });
    }

    protected processApiPartyBookingConfirmDateChangePut(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * Cancel a party booking.
     * @param body What party and why do we want to cancel.
     * @return No Content
     */
    apiPartyBookingCancelPut(body: CancelPartyBookingCommand, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/party/booking/Cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingCancelPut(_response);
        });
    }

    protected processApiPartyBookingCancelPut(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Set the booking articles for a booking.
     * @param confirmdirect (optional) Temporary parameter while changing confirmation flow
     * @param body (optional) The dto containing the requested changes.
     * @return OK
     */
    apiPartyBookingSetBookingArticlesPost(confirmdirect: boolean | undefined, body: BookingArticlesRequestDto | undefined, signal?: AbortSignal): Promise<BookingArticlesResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/SetBookingArticles?";
        if (confirmdirect === null)
            throw new globalThis.Error("The parameter 'confirmdirect' cannot be null.");
        else if (confirmdirect !== undefined)
            url_ += "confirmdirect=" + encodeURIComponent("" + confirmdirect) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingSetBookingArticlesPost(_response);
        });
    }

    protected processApiPartyBookingSetBookingArticlesPost(response: Response): Promise<BookingArticlesResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BookingArticlesResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BookingArticlesResponseDto>(null as any);
    }

    /**
     * Fetches information when the party booking opens up for new bookings.
     * @param playgroundId The playground id to fetch information for.
     * @return OK
     */
    apiPartyBookingOpeningInfoByPlaygroundIdGet(playgroundId: string, signal?: AbortSignal): Promise<PartyBookingOpeningInfoDto> {
        let url_ = this.baseUrl + "/api/party/booking/OpeningInfo/{playgroundId}";
        if (playgroundId === undefined || playgroundId === null)
            throw new globalThis.Error("The parameter 'playgroundId' must be defined.");
        url_ = url_.replace("{playgroundId}", encodeURIComponent("" + playgroundId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingOpeningInfoByPlaygroundIdGet(_response);
        });
    }

    protected processApiPartyBookingOpeningInfoByPlaygroundIdGet(response: Response): Promise<PartyBookingOpeningInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingOpeningInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingOpeningInfoDto>(null as any);
    }

    /**
     * @param playgroundid (optional) 
     * @param daysforward (optional) 
     * @param fromdate (optional) 
     * @param changebookingid (optional) 
     * @param showrealstatus (optional) 
     * @return OK
     */
    apiPartyBookingFindFreeDatesGet(playgroundid: string | undefined, daysforward: number | undefined, fromdate: string | undefined, changebookingid: string | undefined, showrealstatus: boolean | undefined, signal?: AbortSignal): Promise<FreeDatesCollectionDto> {
        let url_ = this.baseUrl + "/api/party/booking/FindFreeDates?";
        if (playgroundid === null)
            throw new globalThis.Error("The parameter 'playgroundid' cannot be null.");
        else if (playgroundid !== undefined)
            url_ += "playgroundid=" + encodeURIComponent("" + playgroundid) + "&";
        if (daysforward === null)
            throw new globalThis.Error("The parameter 'daysforward' cannot be null.");
        else if (daysforward !== undefined)
            url_ += "daysforward=" + encodeURIComponent("" + daysforward) + "&";
        if (fromdate === null)
            throw new globalThis.Error("The parameter 'fromdate' cannot be null.");
        else if (fromdate !== undefined)
            url_ += "fromdate=" + encodeURIComponent("" + fromdate) + "&";
        if (changebookingid === null)
            throw new globalThis.Error("The parameter 'changebookingid' cannot be null.");
        else if (changebookingid !== undefined)
            url_ += "changebookingid=" + encodeURIComponent("" + changebookingid) + "&";
        if (showrealstatus === null)
            throw new globalThis.Error("The parameter 'showrealstatus' cannot be null.");
        else if (showrealstatus !== undefined)
            url_ += "showrealstatus=" + encodeURIComponent("" + showrealstatus) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingFindFreeDatesGet(_response);
        });
    }

    protected processApiPartyBookingFindFreeDatesGet(response: Response): Promise<FreeDatesCollectionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FreeDatesCollectionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FreeDatesCollectionDto>(null as any);
    }

    /**
     * Retrieve configuration for party location
     * @param playgroundId (optional) The playground to retrieve the setting for
     * @return OK
     */
    apiPartyBookingPartyLocationConfigurationGet(playgroundId: string | undefined, signal?: AbortSignal): Promise<PartyLocationConfigurationDto> {
        let url_ = this.baseUrl + "/api/party/booking/PartyLocationConfiguration?";
        if (playgroundId === null)
            throw new globalThis.Error("The parameter 'playgroundId' cannot be null.");
        else if (playgroundId !== undefined)
            url_ += "playgroundId=" + encodeURIComponent("" + playgroundId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingPartyLocationConfigurationGet(_response);
        });
    }

    protected processApiPartyBookingPartyLocationConfigurationGet(response: Response): Promise<PartyLocationConfigurationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyLocationConfigurationDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyLocationConfigurationDto>(null as any);
    }

    /**
     * Get a list of distributions of play time for a party
     * @param playgroundid (optional) The playground to retrieve play times for
     * @param partyDate (optional) The date of the party
     * @param partyLengthMinutes (optional) The duration of the party in minutes (play time + party room)
     * @param timeSlotId (optional) The selected time slot for the party
     * @return OK
     */
    apiPartyBookingPlaytimesGet(playgroundid: string | undefined, partyDate: Date | undefined, partyLengthMinutes: number | undefined, timeSlotId: string | undefined, signal?: AbortSignal): Promise<PartyBookingPlayTime[]> {
        let url_ = this.baseUrl + "/api/party/booking/Playtimes?";
        if (playgroundid === null)
            throw new globalThis.Error("The parameter 'playgroundid' cannot be null.");
        else if (playgroundid !== undefined)
            url_ += "playgroundid=" + encodeURIComponent("" + playgroundid) + "&";
        if (partyDate === null)
            throw new globalThis.Error("The parameter 'partyDate' cannot be null.");
        else if (partyDate !== undefined)
            url_ += "partyDate=" + encodeURIComponent(partyDate ? "" + partyDate.toISOString() : "") + "&";
        if (partyLengthMinutes === null)
            throw new globalThis.Error("The parameter 'partyLengthMinutes' cannot be null.");
        else if (partyLengthMinutes !== undefined)
            url_ += "partyLengthMinutes=" + encodeURIComponent("" + partyLengthMinutes) + "&";
        if (timeSlotId === null)
            throw new globalThis.Error("The parameter 'timeSlotId' cannot be null.");
        else if (timeSlotId !== undefined)
            url_ += "timeSlotId=" + encodeURIComponent("" + timeSlotId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingPlaytimesGet(_response);
        });
    }

    protected processApiPartyBookingPlaytimesGet(response: Response): Promise<PartyBookingPlayTime[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartyBookingPlayTime.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingPlayTime[]>(null as any);
    }

    /**
     * Removes the invite and any associated guest specified by the invite id.
     * @param inviteid (optional) The guid of the invite to remove
     * @return OK
     */
    apiPartyBookingRemoveInviteDelete(inviteid: string | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/RemoveInvite?";
        if (inviteid === null)
            throw new globalThis.Error("The parameter 'inviteid' cannot be null.");
        else if (inviteid !== undefined)
            url_ += "inviteid=" + encodeURIComponent("" + inviteid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingRemoveInviteDelete(_response);
        });
    }

    protected processApiPartyBookingRemoveInviteDelete(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingCreateInvitePost(body: InviteCreateNewDto | undefined, signal?: AbortSignal): Promise<InviteDto> {
        let url_ = this.baseUrl + "/api/party/booking/CreateInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingCreateInvitePost(_response);
        });
    }

    protected processApiPartyBookingCreateInvitePost(response: Response): Promise<InviteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InviteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteDto>(null as any);
    }

    /**
     * Changes the number of guests for a booking.
     * @param confirmdirect (optional) Temporary parameter while changing confirmation flow
     * @param body (optional) The change number dto.
     * @return OK
     */
    apiPartyBookingChangeNumberOfGuestsPost(confirmdirect: boolean | undefined, body: ChangeNumberOfGuestsDto | undefined, signal?: AbortSignal): Promise<GuestDto[]> {
        let url_ = this.baseUrl + "/api/party/booking/ChangeNumberOfGuests?";
        if (confirmdirect === null)
            throw new globalThis.Error("The parameter 'confirmdirect' cannot be null.");
        else if (confirmdirect !== undefined)
            url_ += "confirmdirect=" + encodeURIComponent("" + confirmdirect) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingChangeNumberOfGuestsPost(_response);
        });
    }

    protected processApiPartyBookingChangeNumberOfGuestsPost(response: Response): Promise<GuestDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GuestDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuestDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingSaveGuestPost(body: GuestDto | undefined, signal?: AbortSignal): Promise<GuestDto> {
        let url_ = this.baseUrl + "/api/party/booking/SaveGuest";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingSaveGuestPost(_response);
        });
    }

    protected processApiPartyBookingSaveGuestPost(response: Response): Promise<GuestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuestDto>(null as any);
    }

    /**
     * @return OK
     */
    apiPartyBookingGetGuestByIdGet(id: string, signal?: AbortSignal): Promise<GuestDto> {
        let url_ = this.baseUrl + "/api/party/booking/GetGuest/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetGuestByIdGet(_response);
        });
    }

    protected processApiPartyBookingGetGuestByIdGet(response: Response): Promise<GuestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuestDto>(null as any);
    }

    /**
     * Returns all the available invitation backgrounds for a specific playground.
     * @param id The id of the playground.
     * @return OK
     */
    apiPartyBookingGetInvitationBackgroundsByIdGet(id: string, signal?: AbortSignal): Promise<InvitationBackgroundDto[]> {
        let url_ = this.baseUrl + "/api/party/booking/GetInvitationBackgrounds/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetInvitationBackgroundsByIdGet(_response);
        });
    }

    protected processApiPartyBookingGetInvitationBackgroundsByIdGet(response: Response): Promise<InvitationBackgroundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(InvitationBackgroundDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvitationBackgroundDto[]>(null as any);
    }

    /**
     * @param invitationid (optional) 
     * @param invitationkey (optional) 
     * @return OK
     */
    apiPartyBookingGetInviteGet(invitationid: string | undefined, invitationkey: string | undefined, signal?: AbortSignal): Promise<InviteDto> {
        let url_ = this.baseUrl + "/api/party/booking/GetInvite?";
        if (invitationid === null)
            throw new globalThis.Error("The parameter 'invitationid' cannot be null.");
        else if (invitationid !== undefined)
            url_ += "invitationid=" + encodeURIComponent("" + invitationid) + "&";
        if (invitationkey === null)
            throw new globalThis.Error("The parameter 'invitationkey' cannot be null.");
        else if (invitationkey !== undefined)
            url_ += "invitationkey=" + encodeURIComponent("" + invitationkey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetInviteGet(_response);
        });
    }

    protected processApiPartyBookingGetInviteGet(response: Response): Promise<InviteDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InviteDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingConfirmGuestAttendencePost(body: GuestAttendenceDto | undefined, signal?: AbortSignal): Promise<BoolResultDto> {
        let url_ = this.baseUrl + "/api/party/booking/ConfirmGuestAttendence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingConfirmGuestAttendencePost(_response);
        });
    }

    protected processApiPartyBookingConfirmGuestAttendencePost(response: Response): Promise<BoolResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoolResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoolResultDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingAnswerInvitePost(body: InviteAnswerDto | undefined, signal?: AbortSignal): Promise<GuestDto> {
        let url_ = this.baseUrl + "/api/party/booking/AnswerInvite";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingAnswerInvitePost(_response);
        });
    }

    protected processApiPartyBookingAnswerInvitePost(response: Response): Promise<GuestDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GuestDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GuestDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingConfirmBookingPost(body: PartyBookingConfirmRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ConfirmBooking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingConfirmBookingPost(_response);
        });
    }

    protected processApiPartyBookingConfirmBookingPost(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param body (optional) 
     * @return OK
     */
    apiPartyBookingConfirmBookingChangesPost(body: PartyBookingConfirmRequestDto | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/ConfirmBookingChanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingConfirmBookingChangesPost(_response);
        });
    }

    protected processApiPartyBookingConfirmBookingChangesPost(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * Cancels any pending booking changes on the booking.
     * @param id The id of the booking.
     * @return OK
     */
    apiPartyBookingCancelBookingChangesByIdDelete(id: string, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/CancelBookingChanges/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingCancelBookingChangesByIdDelete(_response);
        });
    }

    protected processApiPartyBookingCancelBookingChangesByIdDelete(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @param bookingid (optional) 
     * @return OK
     */
    apiPartyBookingSetOwnerPost(bookingid: string | null | undefined, signal?: AbortSignal): Promise<PartyBookingResponseDto> {
        let url_ = this.baseUrl + "/api/party/booking/SetOwner";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (bookingid !== null && bookingid !== undefined)
            content_.append("bookingid", bookingid.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingSetOwnerPost(_response);
        });
    }

    protected processApiPartyBookingSetOwnerPost(response: Response): Promise<PartyBookingResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyBookingResponseDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyBookingResponseDto>(null as any);
    }

    /**
     * @return OK
     */
    apiPartyBookingTestPutPut(signal?: AbortSignal): Promise<BoolResultDto> {
        let url_ = this.baseUrl + "/api/party/booking/TestPut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingTestPutPut(_response);
        });
    }

    protected processApiPartyBookingTestPutPut(response: Response): Promise<BoolResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoolResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoolResultDto>(null as any);
    }

    /**
     * @return OK
     */
    apiPartyBookingTestDeleteDelete(signal?: AbortSignal): Promise<BoolResultDto> {
        let url_ = this.baseUrl + "/api/party/booking/TestDelete";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingTestDeleteDelete(_response);
        });
    }

    protected processApiPartyBookingTestDeleteDelete(response: Response): Promise<BoolResultDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoolResultDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoolResultDto>(null as any);
    }

    /**
     * Returns whether the legacy party booking flow is disabled for the given country.
     * @param countryCode ISO 3166-2 country code (e.g. "SE").
     * @return OK
     */
    apiPartyBookingGetDisallowLegacyNewBookingsAndDateChangesByCountryCodeGet(countryCode: string, signal?: AbortSignal): Promise<boolean> {
        let url_ = this.baseUrl + "/api/party/booking/GetDisallowLegacyNewBookingsAndDateChanges/{countryCode}";
        if (countryCode === undefined || countryCode === null)
            throw new globalThis.Error("The parameter 'countryCode' must be defined.");
        url_ = url_.replace("{countryCode}", encodeURIComponent("" + countryCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyBookingGetDisallowLegacyNewBookingsAndDateChangesByCountryCodeGet(_response);
        });
    }

    protected processApiPartyBookingGetDisallowLegacyNewBookingsAndDateChangesByCountryCodeGet(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class PartyPackageApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @param locationId (optional) 
     * @param date (optional) 
     * @param bookingDate (optional) 
     * @return OK
     */
    apiPartyPackageGetByIdGet(id: string, locationId: string | undefined, date: string | undefined, bookingDate: string | undefined, signal?: AbortSignal): Promise<PartyPackageDto> {
        let url_ = this.baseUrl + "/api/party/package/Get/{id}?";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (bookingDate === null)
            throw new globalThis.Error("The parameter 'bookingDate' cannot be null.");
        else if (bookingDate !== undefined)
            url_ += "bookingDate=" + encodeURIComponent("" + bookingDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyPackageGetByIdGet(_response);
        });
    }

    protected processApiPartyPackageGetByIdGet(response: Response): Promise<PartyPackageDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PartyPackageDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyPackageDto>(null as any);
    }

    /**
     * @param locationId (optional) 
     * @param date (optional) 
     * @param bookingDate (optional) 
     * @return OK
     */
    apiPartyPackageListPackagesGet(locationId: string | undefined, date: string | undefined, bookingDate: string | undefined, signal?: AbortSignal): Promise<PartyPackageDto[]> {
        let url_ = this.baseUrl + "/api/party/package/ListPackages?";
        if (locationId === null)
            throw new globalThis.Error("The parameter 'locationId' cannot be null.");
        else if (locationId !== undefined)
            url_ += "locationId=" + encodeURIComponent("" + locationId) + "&";
        if (date === null)
            throw new globalThis.Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (bookingDate === null)
            throw new globalThis.Error("The parameter 'bookingDate' cannot be null.");
        else if (bookingDate !== undefined)
            url_ += "bookingDate=" + encodeURIComponent("" + bookingDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPartyPackageListPackagesGet(_response);
        });
    }

    protected processApiPartyPackageListPackagesGet(response: Response): Promise<PartyPackageDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PartyPackageDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PartyPackageDto[]>(null as any);
    }
}

export class PassArticlesApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a shop card article.
     * @param id The id of the article to retrieve.
     * @return OK
     */
    apiShopPassArticlesByIdGet(id: number, signal?: AbortSignal): Promise<SellablePassArticleModel> {
        let url_ = this.baseUrl + "/api/shop/pass-articles/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassArticlesByIdGet(_response);
        });
    }

    protected processApiShopPassArticlesByIdGet(response: Response): Promise<SellablePassArticleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellablePassArticleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellablePassArticleModel>(null as any);
    }

    /**
     * Retrieve all available, active, shop card articles by location.
    Result is cached for 10 minutes.
     * @param locationId The location to get the cards for.
     * @return OK
     */
    apiShopPassArticlesByLocationByLocationIdGet(locationId: string, signal?: AbortSignal): Promise<PassArticleSummaryDto[]> {
        let url_ = this.baseUrl + "/api/shop/pass-articles/by-location/{locationId}";
        if (locationId === undefined || locationId === null)
            throw new globalThis.Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassArticlesByLocationByLocationIdGet(_response);
        });
    }

    protected processApiShopPassArticlesByLocationByLocationIdGet(response: Response): Promise<PassArticleSummaryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PassArticleSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassArticleSummaryDto[]>(null as any);
    }

    /**
     * Retrieve information about children that are and are not selectable for the given article.
    The children are returned for the currently authenticated user.
     * @param id The id of the article to retrieve the children for.
     * @return OK
     */
    apiShopPassArticlesByIdChildSummariesGet(id: number, signal?: AbortSignal): Promise<PassArticleChildSummaryDto[]> {
        let url_ = this.baseUrl + "/api/shop/pass-articles/{id}/child-summaries";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassArticlesByIdChildSummariesGet(_response);
        });
    }

    protected processApiShopPassArticlesByIdChildSummariesGet(response: Response): Promise<PassArticleChildSummaryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PassArticleChildSummaryDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassArticleChildSummaryDto[]>(null as any);
    }
}

export class PassOrderApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopPassOrdersDirectPost(body: CreateDirectPassOrderCommand | undefined, signal?: AbortSignal): Promise<PassOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/direct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersDirectPost(_response);
        });
    }

    protected processApiShopPassOrdersDirectPost(response: Response): Promise<PassOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassOrderPaymentModel>(null as any);
    }

    /**
     * Create a new order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopPassOrdersRedeemPost(body: CreateRedeemPassOrderCommand | undefined, signal?: AbortSignal): Promise<PassOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/redeem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersRedeemPost(_response);
        });
    }

    protected processApiShopPassOrdersRedeemPost(response: Response): Promise<PassOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassOrderPaymentModel>(null as any);
    }

    /**
     * Get an order summary for a direct order, without placing an order.
    This endpoint should be called before creating an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopPassOrdersDirectSummaryPost(body: GetDirectPassOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<PassDirectOrderSummaryDto> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/direct/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersDirectSummaryPost(_response);
        });
    }

    protected processApiShopPassOrdersDirectSummaryPost(response: Response): Promise<PassDirectOrderSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassDirectOrderSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassDirectOrderSummaryDto>(null as any);
    }

    /**
     * Get an order summary for a redeem order, without placing an order.
    This endpoint should be called before creating an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopPassOrdersRedeemSummaryPost(body: GetRedeemPassOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<PassRedeemOrderSummaryDto> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/redeem/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersRedeemSummaryPost(_response);
        });
    }

    protected processApiShopPassOrdersRedeemSummaryPost(response: Response): Promise<PassRedeemOrderSummaryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassRedeemOrderSummaryDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassRedeemOrderSummaryDto>(null as any);
    }

    /**
     * Retrieve the payment status of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopPassOrdersByOrderReferenceStatusGet(orderReference: string, signal?: AbortSignal): Promise<PassOrderPaymentStatus> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/{orderReference}/status";
        if (orderReference === undefined || orderReference === null)
            throw new globalThis.Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersByOrderReferenceStatusGet(_response);
        });
    }

    protected processApiShopPassOrdersByOrderReferenceStatusGet(response: Response): Promise<PassOrderPaymentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassOrderPaymentStatus>(null as any);
    }

    /**
     * Retrieve the tracking event of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopPassOrdersByOrderReferenceTrackingEventGet(orderReference: string, signal?: AbortSignal): Promise<ShopPurchaseEvent> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/{orderReference}/tracking-event";
        if (orderReference === undefined || orderReference === null)
            throw new globalThis.Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersByOrderReferenceTrackingEventGet(_response);
        });
    }

    protected processApiShopPassOrdersByOrderReferenceTrackingEventGet(response: Response): Promise<ShopPurchaseEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopPurchaseEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShopPurchaseEvent>(null as any);
    }

    /**
     * Check if a photo can be uploaded for a direct pass order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopPassOrdersByOrderReferencePhotoUploadStatusGet(orderReference: string, signal?: AbortSignal): Promise<PassPhotoUploadStatusDto> {
        let url_ = this.baseUrl + "/api/shop/pass-orders/{orderReference}/photo-upload-status";
        if (orderReference === undefined || orderReference === null)
            throw new globalThis.Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopPassOrdersByOrderReferencePhotoUploadStatusGet(_response);
        });
    }

    protected processApiShopPassOrdersByOrderReferencePhotoUploadStatusGet(response: Response): Promise<PassPhotoUploadStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PassPhotoUploadStatusDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PassPhotoUploadStatusDto>(null as any);
    }
}

export class PlaygroundApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiPlaygroundGetByIdGet(id: string, signal?: AbortSignal): Promise<PlaygroundDto> {
        let url_ = this.baseUrl + "/api/playground/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPlaygroundGetByIdGet(_response);
        });
    }

    protected processApiPlaygroundGetByIdGet(response: Response): Promise<PlaygroundDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PlaygroundDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundDto>(null as any);
    }

    /**
     * @return OK
     */
    apiPlaygroundListByParentGet(parent: string, signal?: AbortSignal): Promise<PlaygroundDto[]> {
        let url_ = this.baseUrl + "/api/playground/List/{parent}";
        if (parent === undefined || parent === null)
            throw new globalThis.Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPlaygroundListByParentGet(_response);
        });
    }

    protected processApiPlaygroundListByParentGet(response: Response): Promise<PlaygroundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaygroundDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiPlaygroundListByCountryByCountryGet(country: string, signal?: AbortSignal): Promise<PlaygroundDto[]> {
        let url_ = this.baseUrl + "/api/playground/ListByCountry/{country}";
        if (country === undefined || country === null)
            throw new globalThis.Error("The parameter 'country' must be defined.");
        url_ = url_.replace("{country}", encodeURIComponent("" + country));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPlaygroundListByCountryByCountryGet(_response);
        });
    }

    protected processApiPlaygroundListByCountryByCountryGet(response: Response): Promise<PlaygroundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaygroundDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiPlaygroundListAllPlaygroundsGet(signal?: AbortSignal): Promise<PlaygroundDto[]> {
        let url_ = this.baseUrl + "/api/playground/ListAllPlaygrounds";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiPlaygroundListAllPlaygroundsGet(_response);
        });
    }

    protected processApiPlaygroundListAllPlaygroundsGet(response: Response): Promise<PlaygroundDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaygroundDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundDto[]>(null as any);
    }
}

export class RegionApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiRegionGetByIdGet(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Region/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRegionGetByIdGet(_response);
        });
    }

    protected processApiRegionGetByIdGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiRegionListByParentGet(parent: string, signal?: AbortSignal): Promise<RegionDto[]> {
        let url_ = this.baseUrl + "/api/Region/List/{parent}";
        if (parent === undefined || parent === null)
            throw new globalThis.Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRegionListByParentGet(_response);
        });
    }

    protected processApiRegionListByParentGet(response: Response): Promise<RegionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RegionDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RegionDto[]>(null as any);
    }
}

export class RoomApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiRoomGetByIdGet(id: string, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/Room/Get/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRoomGetByIdGet(_response);
        });
    }

    protected processApiRoomGetByIdGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    apiRoomListByPlaygroundByPlaygroundidGet(playgroundid: string, signal?: AbortSignal): Promise<RoomDto[]> {
        let url_ = this.baseUrl + "/api/Room/ListByPlayground/{playgroundid}";
        if (playgroundid === undefined || playgroundid === null)
            throw new globalThis.Error("The parameter 'playgroundid' must be defined.");
        url_ = url_.replace("{playgroundid}", encodeURIComponent("" + playgroundid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRoomListByPlaygroundByPlaygroundidGet(_response);
        });
    }

    protected processApiRoomListByPlaygroundByPlaygroundidGet(response: Response): Promise<RoomDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiRoomListByParentGet(parent: string, signal?: AbortSignal): Promise<RoomDto[]> {
        let url_ = this.baseUrl + "/api/Room/List/{parent}";
        if (parent === undefined || parent === null)
            throw new globalThis.Error("The parameter 'parent' must be defined.");
        url_ = url_.replace("{parent}", encodeURIComponent("" + parent));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRoomListByParentGet(_response);
        });
    }

    protected processApiRoomListByParentGet(response: Response): Promise<RoomDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomDto[]>(null as any);
    }

    /**
     * @return OK
     */
    apiRoomGetThemesGet(signal?: AbortSignal): Promise<RoomThemeDto[]> {
        let url_ = this.baseUrl + "/api/Room/GetThemes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiRoomGetThemesGet(_response);
        });
    }

    protected processApiRoomGetThemesGet(response: Response): Promise<RoomThemeDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoomThemeDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RoomThemeDto[]>(null as any);
    }
}

export class SerialTicketConnectAccountApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new session for connecting a serial ticket to account
     * @param body The connect parameters.
     * @return Created
     */
    apiConnectSerialTicketByNumberSessionPost(body: CreateConnectToAccountSessionCommand, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/connect-serial-ticket/by-number/session";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiConnectSerialTicketByNumberSessionPost(_response);
        });
    }

    protected processApiConnectSerialTicketByNumberSessionPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get information for connecting serial ticket to an account.
     * @param sessionId The id of the session.
     * @return OK
     */
    apiConnectSerialTicketBySessionBySessionIdGet(sessionId: string, signal?: AbortSignal): Promise<SerialTicketConnectToAccountInformationModel> {
        let url_ = this.baseUrl + "/api/connect-serial-ticket/by-session/{sessionId}";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiConnectSerialTicketBySessionBySessionIdGet(_response);
        });
    }

    protected processApiConnectSerialTicketBySessionBySessionIdGet(response: Response): Promise<SerialTicketConnectToAccountInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketConnectToAccountInformationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketConnectToAccountInformationModel>(null as any);
    }

    /**
     * Connect a serial ticket to an account
     * @param sessionId An active connect to account session id.
     * @return Created
     */
    apiConnectSerialTicketBySessionBySessionIdConnectPost(sessionId: string, signal?: AbortSignal): Promise<string> {
        let url_ = this.baseUrl + "/api/connect-serial-ticket/by-session/{sessionId}/connect";
        if (sessionId === undefined || sessionId === null)
            throw new globalThis.Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiConnectSerialTicketBySessionBySessionIdConnectPost(_response);
        });
    }

    protected processApiConnectSerialTicketBySessionBySessionIdConnectPost(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result201 = resultData201 !== undefined ? resultData201 : null as any;
    
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    /**
     * Get information for confirmation of connected serial ticket.
     * @param ticketId The id of the connected serial ticket.
     * @return OK
     */
    apiConnectSerialTicketByIdByTicketIdConfirmationGet(ticketId: string, signal?: AbortSignal): Promise<SerialTicketConnectToAccountInformationModel> {
        let url_ = this.baseUrl + "/api/connect-serial-ticket/by-id/{ticketId}/confirmation";
        if (ticketId === undefined || ticketId === null)
            throw new globalThis.Error("The parameter 'ticketId' must be defined.");
        url_ = url_.replace("{ticketId}", encodeURIComponent("" + ticketId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiConnectSerialTicketByIdByTicketIdConfirmationGet(_response);
        });
    }

    protected processApiConnectSerialTicketByIdByTicketIdConfirmationGet(response: Response): Promise<SerialTicketConnectToAccountInformationModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketConnectToAccountInformationModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketConnectToAccountInformationModel>(null as any);
    }
}

export class SerialTicketOrderApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Create a new direct order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopSerialTicketsOrderDirectPost(body: CreateSerialTicketDirectOrderCommand | undefined, signal?: AbortSignal): Promise<SerialTicketOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/direct";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderDirectPost(_response);
        });
    }

    protected processApiShopSerialTicketsOrderDirectPost(response: Response): Promise<SerialTicketOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketOrderPaymentModel>(null as any);
    }

    /**
     * Create a new redeem order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopSerialTicketsOrderRedeemPost(body: CreateSerialTicketRedeemOrderCommand | undefined, signal?: AbortSignal): Promise<SerialTicketOrderPaymentModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/redeem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderRedeemPost(_response);
        });
    }

    protected processApiShopSerialTicketsOrderRedeemPost(response: Response): Promise<SerialTicketOrderPaymentModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketOrderPaymentModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketOrderPaymentModel>(null as any);
    }

    /**
     * Get an order summary for a direct order, without placing an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopSerialTicketsOrderDirectSummaryPost(body: GetSerialTicketDirectOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<SerialTicketDirectOrderSummaryModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/direct/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderDirectSummaryPost(_response);
        });
    }

    protected processApiShopSerialTicketsOrderDirectSummaryPost(response: Response): Promise<SerialTicketDirectOrderSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketDirectOrderSummaryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketDirectOrderSummaryModel>(null as any);
    }

    /**
     * Get an order summary for a redeem order, without placing an order.
     * @param body (optional) The order model.
     * @return OK
     */
    apiShopSerialTicketsOrderRedeemSummaryPost(body: GetSerialTicketRedeemOrderSummaryQuery | undefined, signal?: AbortSignal): Promise<SerialTicketRedeemOrderSummaryModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/redeem/summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderRedeemSummaryPost(_response);
        });
    }

    protected processApiShopSerialTicketsOrderRedeemSummaryPost(response: Response): Promise<SerialTicketRedeemOrderSummaryModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SerialTicketRedeemOrderSummaryModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketRedeemOrderSummaryModel>(null as any);
    }

    /**
     * Retrieve the payment status of an order.
     * @param orderReference The order reference
     * @return OK
     */
    apiShopSerialTicketsOrderByOrderReferenceStatusGet(orderReference: string, signal?: AbortSignal): Promise<SerialTicketOrderPaymentStatus> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/{orderReference}/status";
        if (orderReference === undefined || orderReference === null)
            throw new globalThis.Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderByOrderReferenceStatusGet(_response);
        });
    }

    protected processApiShopSerialTicketsOrderByOrderReferenceStatusGet(response: Response): Promise<SerialTicketOrderPaymentStatus> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null as any;
    
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SerialTicketOrderPaymentStatus>(null as any);
    }

    /**
     * Retrieve the tracking event of an order.
     * @param orderReference The order reference.
     * @return OK
     */
    apiShopSerialTicketsOrderByOrderReferenceTrackingEventGet(orderReference: string, signal?: AbortSignal): Promise<ShopPurchaseEvent> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/order/{orderReference}/tracking-event";
        if (orderReference === undefined || orderReference === null)
            throw new globalThis.Error("The parameter 'orderReference' must be defined.");
        url_ = url_.replace("{orderReference}", encodeURIComponent("" + orderReference));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsOrderByOrderReferenceTrackingEventGet(_response);
        });
    }

    protected processApiShopSerialTicketsOrderByOrderReferenceTrackingEventGet(response: Response): Promise<ShopPurchaseEvent> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ShopPurchaseEvent.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShopPurchaseEvent>(null as any);
    }
}

export class ShopSerialTicketsApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a shop serial ticket article.
     * @param id The id of the article to retrieve.
     * @return OK
     */
    apiShopSerialTicketsByIdGet(id: number, signal?: AbortSignal): Promise<SellableSerialTicketArticleModel> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsByIdGet(_response);
        });
    }

    protected processApiShopSerialTicketsByIdGet(response: Response): Promise<SellableSerialTicketArticleModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SellableSerialTicketArticleModel.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellableSerialTicketArticleModel>(null as any);
    }

    /**
     * Retrieve all available, active, shop serial ticket articles by country.
     * @param countryId The country to get the serial tickets for.
     * @return OK
     */
    apiShopSerialTicketsByLocationByCountryIdGet(countryId: string, signal?: AbortSignal): Promise<SellableSerialTicketArticleModel[]> {
        let url_ = this.baseUrl + "/api/shop/serial-tickets/by-location/{countryId}";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiShopSerialTicketsByLocationByCountryIdGet(_response);
        });
    }

    protected processApiShopSerialTicketsByLocationByCountryIdGet(response: Response): Promise<SellableSerialTicketArticleModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SellableSerialTicketArticleModel.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SellableSerialTicketArticleModel[]>(null as any);
    }
}

export class SubscriptionApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Retrieve a subscription by id.
     * @param subscriptionId The id of the subscription to retrieve.
     * @return OK
     */
    apiSubscriptionBySubscriptionIdGet(subscriptionId: string, signal?: AbortSignal): Promise<PeriodSubscriptionDto> {
        let url_ = this.baseUrl + "/api/subscription/{subscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new globalThis.Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{subscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiSubscriptionBySubscriptionIdGet(_response);
        });
    }

    protected processApiSubscriptionBySubscriptionIdGet(response: Response): Promise<PeriodSubscriptionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PeriodSubscriptionDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = PeriodSubscriptionDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeriodSubscriptionDto>(null as any);
    }
}

export class TimeZoneApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Get a map of all Windows timezones to Iana timezones.
    This can be used for moment as moment handles Iana time-zones but can't handle windows timezones.
     * @return OK
     */
    apiTimeZoneGetWindowsToIanaTimeZonesWindowsToIanaTimezonesGet(signal?: AbortSignal): Promise<{ [key: string]: string; }> {
        let url_ = this.baseUrl + "/api/TimeZone/GetWindowsToIanaTimeZones/windows-to-iana-timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiTimeZoneGetWindowsToIanaTimeZonesWindowsToIanaTimezonesGet(_response);
        });
    }

    protected processApiTimeZoneGetWindowsToIanaTimeZonesWindowsToIanaTimezonesGet(response: Response): Promise<{ [key: string]: string; }> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (resultData200) {
                result200 = {} as any;
                for (let key in resultData200) {
                    if (resultData200.hasOwnProperty(key))
                        (result200 as any)![key] = resultData200[key] !== undefined ? resultData200[key] : null as any;
                }
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<{ [key: string]: string; }>(null as any);
    }

    /**
     * Get all playground timezones.
     * @return OK
     */
    apiTimeZoneGetPlaygroundTimeZonesPlaygroundTimezonesGet(signal?: AbortSignal): Promise<PlaygroundTimeZoneInformationDto[]> {
        let url_ = this.baseUrl + "/api/TimeZone/GetPlaygroundTimeZones/playground-timezones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiTimeZoneGetPlaygroundTimeZonesPlaygroundTimezonesGet(_response);
        });
    }

    protected processApiTimeZoneGetPlaygroundTimeZonesPlaygroundTimezonesGet(response: Response): Promise<PlaygroundTimeZoneInformationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PlaygroundTimeZoneInformationDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PlaygroundTimeZoneInformationDto[]>(null as any);
    }
}

export class UserApiClient extends BaseApiClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * @return OK
     */
    apiUserMeGet(signal?: AbortSignal): Promise<ApplicationUserDto> {
        let url_ = this.baseUrl + "/api/User/Me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserMeGet(_response);
        });
    }

    protected processApiUserMeGet(response: Response): Promise<ApplicationUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserDto>(null as any);
    }

    /**
     * Update the user profile.
     * @param body The new profile values.
     * @return OK
     */
    apiUserUpdateProfilePut(body: UpdateProfileModel, signal?: AbortSignal): Promise<ApplicationUserDto> {
        let url_ = this.baseUrl + "/api/User/UpdateProfile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserUpdateProfilePut(_response);
        });
    }

    protected processApiUserUpdateProfilePut(response: Response): Promise<ApplicationUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserDto>(null as any);
    }

    /**
     * Update the user playground.
     * @param body (optional) The new user playground.
     * @return OK
     */
    apiUserUpdateProfilePlaygroundPut(body: string | undefined, signal?: AbortSignal): Promise<ApplicationUserDto> {
        let url_ = this.baseUrl + "/api/User/UpdateProfilePlayground";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserUpdateProfilePlaygroundPut(_response);
        });
    }

    protected processApiUserUpdateProfilePlaygroundPut(response: Response): Promise<ApplicationUserDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplicationUserDto.fromJS(resultData200);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ErrorDto.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApplicationUserDto>(null as any);
    }

    /**
     * Create a new child.
     * @param body (optional) The child model.
     * @return OK
     */
    apiUserCreateAccountPost(body: CreateChildModel | undefined, signal?: AbortSignal): Promise<ChildDto> {
        let url_ = this.baseUrl + "/api/User/CreateAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserCreateAccountPost(_response);
        });
    }

    protected processApiUserCreateAccountPost(response: Response): Promise<ChildDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ChildDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildDto>(null as any);
    }

    /**
     * Get account information for the currently authenticated user.
     * @return OK
     */
    apiUserMyAccountsGet(signal?: AbortSignal): Promise<ChildDto[]> {
        let url_ = this.baseUrl + "/api/User/MyAccounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserMyAccountsGet(_response);
        });
    }

    protected processApiUserMyAccountsGet(response: Response): Promise<ChildDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChildDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 401) {
            return response.text().then((_responseText) => {
            let result401: any = null;
            let resultData401 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result401 = ErrorDto.fromJS(resultData401);
            return throwException("Unauthorized", status, _responseText, _headers, result401);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildDto[]>(null as any);
    }

    /**
     * Retrieve children for the currently authenticated user.
    The subscriptions for the children will be retrieved using the given country id.
     * @param countryId The country to get child subscriptions for.
     * @param validDate (optional) Optional date to match validity against, the subscriptions retrieved will be valid against this date. If no date is set the current date is used.
     * @return OK
     */
    apiUserGetChildrenByCountryByCountryIdGet(countryId: string, validDate: Date | undefined, signal?: AbortSignal): Promise<ChildDto[]> {
        let url_ = this.baseUrl + "/api/User/GetChildrenByCountry/{countryId}?";
        if (countryId === undefined || countryId === null)
            throw new globalThis.Error("The parameter 'countryId' must be defined.");
        url_ = url_.replace("{countryId}", encodeURIComponent("" + countryId));
        if (validDate === null)
            throw new globalThis.Error("The parameter 'validDate' cannot be null.");
        else if (validDate !== undefined)
            url_ += "validDate=" + encodeURIComponent(validDate ? "" + validDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGetChildrenByCountryByCountryIdGet(_response);
        });
    }

    protected processApiUserGetChildrenByCountryByCountryIdGet(response: Response): Promise<ChildDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ChildDto.fromJS(item));
            }
            else {
                result200 = null as any;
            }
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ErrorDto.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChildDto[]>(null as any);
    }

    /**
     * Get users registered between two dates.
     * @param startDate (optional) The start date of the period.
     * @param endDate (optional) The end date of the period.
     * @param culture (optional) The culture to filter the users by.
     * @return OK
     */
    apiUserGetUsersWithinDatesGet(startDate: Date | undefined, endDate: Date | undefined, culture: string | undefined, signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/User/GetUsersWithinDates?";
        if (startDate === null)
            throw new globalThis.Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (culture === null)
            throw new globalThis.Error("The parameter 'culture' cannot be null.");
        else if (culture !== undefined)
            url_ += "culture=" + encodeURIComponent("" + culture) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGetUsersWithinDatesGet(_response);
        });
    }

    protected processApiUserGetUsersWithinDatesGet(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    /**
     * Retrieve password requirements.
     * @return OK
     */
    apiUserGetPasswordOptionsPasswordOptionsGet(signal?: AbortSignal): Promise<PasswordOptions> {
        let url_ = this.baseUrl + "/api/User/GetPasswordOptions/password/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processApiUserGetPasswordOptionsPasswordOptionsGet(_response);
        });
    }

    protected processApiUserGetPasswordOptionsPasswordOptionsGet(response: Response): Promise<PasswordOptions> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PasswordOptions.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PasswordOptions>(null as any);
    }
}

/** An application notice that can be displayed in the entrance booking. */
export class ApplicationNoticeDto implements IApplicationNoticeDto {
    /** The id of the notice. */
    guid!: string;
    locationIds!: string[];
    startDate!: Date | null;
    endDate!: Date | null;
    name!: string;
    text!: string;
    type!: ApplicationNoticeType | null;
    disabled!: boolean;
    icon!: string;
    sortOrder!: number;

    constructor(data?: IApplicationNoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            if (Array.isArray(_data["locationIds"])) {
                this.locationIds = [] as any;
                for (let item of _data["locationIds"])
                    this.locationIds!.push(item);
            }
            else {
                this.locationIds = null as any;
            }
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.text = _data["text"] !== undefined ? _data["text"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.icon = _data["icon"] !== undefined ? _data["icon"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationNoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationNoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        if (Array.isArray(this.locationIds)) {
            data["locationIds"] = [];
            for (let item of this.locationIds)
                data["locationIds"].push(item);
        }
        data["startDate"] = this.startDate ? formatDate(this.startDate) : null as any;
        data["endDate"] = this.endDate ? formatDate(this.endDate) : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["text"] = this.text !== undefined ? this.text : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["icon"] = this.icon !== undefined ? this.icon : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        return data;
    }
}

/** An application notice that can be displayed in the entrance booking. */
export interface IApplicationNoticeDto {
    /** The id of the notice. */
    guid: string;
    locationIds: string[];
    startDate: Date | null;
    endDate: Date | null;
    name: string;
    text: string;
    type: ApplicationNoticeType | null;
    disabled: boolean;
    icon: string;
    sortOrder: number;
}

/** Response from the Leo.Application.ChildClasses.Commands.CreateChildClassBookingPayment.CreateChildClassBookingPaymentCommand with a Bambora payment session. */
export class ChildClassBookingPaymentModel implements IChildClassBookingPaymentModel {
    /** The order reference for the booking. */
    orderReference!: string;
    /** The unique payment session id token. */
    paymentToken!: string | null;
    /** The current payment status for the booking.
If this is set to Leo.Database.Entities.ChildClasses.ChildClassBookingPaymentStatus.Paid the Leo.Application.ChildClasses.Commands.CreateChildClassBookingPayment.ChildClassBookingPaymentModel.PaymentToken property will be left empty. */
    paymentStatus!: ChildClassBookingPaymentStatus;

    constructor(data?: IChildClassBookingPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : null as any;
            this.paymentToken = _data["paymentToken"] !== undefined ? _data["paymentToken"] : null as any;
            this.paymentStatus = _data["paymentStatus"] !== undefined ? _data["paymentStatus"] : null as any;
        }
    }

    static fromJS(data: any): ChildClassBookingPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassBookingPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : null as any;
        data["paymentToken"] = this.paymentToken !== undefined ? this.paymentToken : null as any;
        data["paymentStatus"] = this.paymentStatus !== undefined ? this.paymentStatus : null as any;
        return data;
    }
}

/** Response from the Leo.Application.ChildClasses.Commands.CreateChildClassBookingPayment.CreateChildClassBookingPaymentCommand with a Bambora payment session. */
export interface IChildClassBookingPaymentModel {
    /** The order reference for the booking. */
    orderReference: string;
    /** The unique payment session id token. */
    paymentToken: string | null;
    /** The current payment status for the booking.
If this is set to Leo.Database.Entities.ChildClasses.ChildClassBookingPaymentStatus.Paid the Leo.Application.ChildClasses.Commands.CreateChildClassBookingPayment.ChildClassBookingPaymentModel.PaymentToken property will be left empty. */
    paymentStatus: ChildClassBookingPaymentStatus;
}

/** Create a new payment session for a specific Leo.Database.Entities.ChildClasses.ChildClassBooking. */
export class CreateChildClassBookingPaymentCommand implements ICreateChildClassBookingPaymentCommand {
    /** The booking id. */
    bookingId!: string;

    constructor(data?: ICreateChildClassBookingPaymentCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"] !== undefined ? _data["bookingId"] : null as any;
        }
    }

    static fromJS(data: any): CreateChildClassBookingPaymentCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildClassBookingPaymentCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId !== undefined ? this.bookingId : null as any;
        return data;
    }
}

/** Create a new payment session for a specific Leo.Database.Entities.ChildClasses.ChildClassBooking. */
export interface ICreateChildClassBookingPaymentCommand {
    /** The booking id. */
    bookingId: string;
}

export class ChildClassAgeGroupModel implements IChildClassAgeGroupModel {
    id!: number;
    name!: string;
    minAge!: number;
    maxAge!: number;
    classStartTime!: string;
    classEndTime!: string;
    fullyBooked!: boolean;

    constructor(data?: IChildClassAgeGroupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.minAge = _data["minAge"] !== undefined ? _data["minAge"] : null as any;
            this.maxAge = _data["maxAge"] !== undefined ? _data["maxAge"] : null as any;
            this.classStartTime = _data["classStartTime"] !== undefined ? _data["classStartTime"] : null as any;
            this.classEndTime = _data["classEndTime"] !== undefined ? _data["classEndTime"] : null as any;
            this.fullyBooked = _data["fullyBooked"] !== undefined ? _data["fullyBooked"] : null as any;
        }
    }

    static fromJS(data: any): ChildClassAgeGroupModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassAgeGroupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["minAge"] = this.minAge !== undefined ? this.minAge : null as any;
        data["maxAge"] = this.maxAge !== undefined ? this.maxAge : null as any;
        data["classStartTime"] = this.classStartTime !== undefined ? this.classStartTime : null as any;
        data["classEndTime"] = this.classEndTime !== undefined ? this.classEndTime : null as any;
        data["fullyBooked"] = this.fullyBooked !== undefined ? this.fullyBooked : null as any;
        return data;
    }
}

export interface IChildClassAgeGroupModel {
    id: number;
    name: string;
    minAge: number;
    maxAge: number;
    classStartTime: string;
    classEndTime: string;
    fullyBooked: boolean;
}

/** Information about the currently active price. */
export class ChildClassAvailablePriceModel implements IChildClassAvailablePriceModel {
    /** The currently active price for the booking. */
    priceIncVat!: number;
    /** The date until the Leo.Application.ChildClasses.Queries.Models.ChildClassAvailablePriceModel.PriceIncVat is valid. */
    validToDate!: Date | null;
    /** The regular price that will be used after the Leo.Application.ChildClasses.Queries.Models.ChildClassAvailablePriceModel.ValidToDate has passed. */
    regularPriceIncVat!: number;

    constructor(data?: IChildClassAvailablePriceModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.priceIncVat = _data["priceIncVat"] !== undefined ? _data["priceIncVat"] : null as any;
            this.validToDate = _data["validToDate"] ? new Date(_data["validToDate"].toString()) : null as any;
            this.regularPriceIncVat = _data["regularPriceIncVat"] !== undefined ? _data["regularPriceIncVat"] : null as any;
        }
    }

    static fromJS(data: any): ChildClassAvailablePriceModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassAvailablePriceModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["priceIncVat"] = this.priceIncVat !== undefined ? this.priceIncVat : null as any;
        data["validToDate"] = this.validToDate ? formatDate(this.validToDate) : null as any;
        data["regularPriceIncVat"] = this.regularPriceIncVat !== undefined ? this.regularPriceIncVat : null as any;
        return data;
    }
}

/** Information about the currently active price. */
export interface IChildClassAvailablePriceModel {
    /** The currently active price for the booking. */
    priceIncVat: number;
    /** The date until the Leo.Application.ChildClasses.Queries.Models.ChildClassAvailablePriceModel.PriceIncVat is valid. */
    validToDate: Date | null;
    /** The regular price that will be used after the Leo.Application.ChildClasses.Queries.Models.ChildClassAvailablePriceModel.ValidToDate has passed. */
    regularPriceIncVat: number;
}

/** Summary information for a completed booking. */
export class ChildClassBookingConfirmationSummaryModel implements IChildClassBookingConfirmationSummaryModel {
    guid!: string;
    orderReference!: string;
    confirmationInformation!: string | null;
    /** True if the class is a trial class, false otherwise. */
    readonly isTrialClass!: boolean;
    /** The type of class booked. */
    classType!: ChildClassClassType;
    /** The url to the payment page. */
    linkPayment!: string | null;

    constructor(data?: IChildClassBookingConfirmationSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : null as any;
            this.confirmationInformation = _data["confirmationInformation"] !== undefined ? _data["confirmationInformation"] : null as any;
            (this as any).isTrialClass = _data["isTrialClass"] !== undefined ? _data["isTrialClass"] : null as any;
            this.classType = _data["classType"] !== undefined ? _data["classType"] : null as any;
            this.linkPayment = _data["linkPayment"] !== undefined ? _data["linkPayment"] : null as any;
        }
    }

    static fromJS(data: any): ChildClassBookingConfirmationSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassBookingConfirmationSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : null as any;
        data["confirmationInformation"] = this.confirmationInformation !== undefined ? this.confirmationInformation : null as any;
        data["isTrialClass"] = this.isTrialClass !== undefined ? this.isTrialClass : null as any;
        data["classType"] = this.classType !== undefined ? this.classType : null as any;
        data["linkPayment"] = this.linkPayment !== undefined ? this.linkPayment : null as any;
        return data;
    }
}

/** Summary information for a completed booking. */
export interface IChildClassBookingConfirmationSummaryModel {
    guid: string;
    orderReference: string;
    confirmationInformation: string | null;
    /** True if the class is a trial class, false otherwise. */
    isTrialClass: boolean;
    /** The type of class booked. */
    classType: ChildClassClassType;
    /** The url to the payment page. */
    linkPayment: string | null;
}

/** A receipt line for a Leo.Application.ChildClasses.Queries.Models.ChildClassBookingReceiptModel. */
export class ChildClassBookingReceiptLineModel implements IChildClassBookingReceiptLineModel {
    description!: string | null;
    quantity!: number;
    amount!: number;
    articleNo!: string | null;
    type!: ChildClassTransactionLineType;

    constructor(data?: IChildClassBookingReceiptLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.articleNo = _data["articleNo"] !== undefined ? _data["articleNo"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ChildClassBookingReceiptLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassBookingReceiptLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["articleNo"] = this.articleNo !== undefined ? this.articleNo : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

/** A receipt line for a Leo.Application.ChildClasses.Queries.Models.ChildClassBookingReceiptModel. */
export interface IChildClassBookingReceiptLineModel {
    description: string | null;
    quantity: number;
    amount: number;
    articleNo: string | null;
    type: ChildClassTransactionLineType;
}

/** A receipt for a Leo.Database.Entities.ChildClasses.ChildClassBooking. */
export class ChildClassBookingReceiptModel implements IChildClassBookingReceiptModel {
    /** The date of the transaction in the format "yyyy-MM-dd". */
    date!: Date;
    /** The id of the transaction for the receipt, if any. */
    transactionId!: string;
    /** The reference of the transaction for the receipt, if any. */
    transactionReference!: string | null;
    /** The order reference. */
    orderReference!: string;
    /** The id of the booking for the receipt. */
    bookingId!: string;
    /** The seller company name that is connected to the receipt. */
    companyName!: string;
    /** The seller company organization number that is connected to the receipt. */
    companyOrganizationNo!: string;
    /** The vat percentage. 25 = 25%. */
    vatPercent!: number;
    /** The total of the receipt, including VAT. */
    amount!: number;
    /** The amount of VAT for the receipt. */
    vatAmount!: number;
    /** The total amount for all the Leo.Application.ChildClasses.Queries.Models.ChildClassBookingReceiptModel.Lines. */
    readonly linesAmount!: number;
    /** The currency for the transaction. */
    currency!: string;
    /** The transaction type for the receipt.
E.g. Leo.Database.Entities.ChildClasses.ChildClassTransactionType.Credit or Leo.Database.Entities.ChildClasses.ChildClassTransactionType.Credit. */
    receiptType!: ChildClassTransactionType;
    /** All lines for the receipt. */
    lines!: ChildClassBookingReceiptLineModel[];

    constructor(data?: IChildClassBookingReceiptModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.transactionReference = _data["transactionReference"] !== undefined ? _data["transactionReference"] : null as any;
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : null as any;
            this.bookingId = _data["bookingId"] !== undefined ? _data["bookingId"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.companyOrganizationNo = _data["companyOrganizationNo"] !== undefined ? _data["companyOrganizationNo"] : null as any;
            this.vatPercent = _data["vatPercent"] !== undefined ? _data["vatPercent"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.vatAmount = _data["vatAmount"] !== undefined ? _data["vatAmount"] : null as any;
            (this as any).linesAmount = _data["linesAmount"] !== undefined ? _data["linesAmount"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.receiptType = _data["receiptType"] !== undefined ? _data["receiptType"] : null as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(ChildClassBookingReceiptLineModel.fromJS(item));
            }
            else {
                this.lines = null as any;
            }
        }
    }

    static fromJS(data: any): ChildClassBookingReceiptModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassBookingReceiptModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : null as any;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["transactionReference"] = this.transactionReference !== undefined ? this.transactionReference : null as any;
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : null as any;
        data["bookingId"] = this.bookingId !== undefined ? this.bookingId : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["companyOrganizationNo"] = this.companyOrganizationNo !== undefined ? this.companyOrganizationNo : null as any;
        data["vatPercent"] = this.vatPercent !== undefined ? this.vatPercent : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["vatAmount"] = this.vatAmount !== undefined ? this.vatAmount : null as any;
        data["linesAmount"] = this.linesAmount !== undefined ? this.linesAmount : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["receiptType"] = this.receiptType !== undefined ? this.receiptType : null as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** A receipt for a Leo.Database.Entities.ChildClasses.ChildClassBooking. */
export interface IChildClassBookingReceiptModel {
    /** The date of the transaction in the format "yyyy-MM-dd". */
    date: Date;
    /** The id of the transaction for the receipt, if any. */
    transactionId: string;
    /** The reference of the transaction for the receipt, if any. */
    transactionReference: string | null;
    /** The order reference. */
    orderReference: string;
    /** The id of the booking for the receipt. */
    bookingId: string;
    /** The seller company name that is connected to the receipt. */
    companyName: string;
    /** The seller company organization number that is connected to the receipt. */
    companyOrganizationNo: string;
    /** The vat percentage. 25 = 25%. */
    vatPercent: number;
    /** The total of the receipt, including VAT. */
    amount: number;
    /** The amount of VAT for the receipt. */
    vatAmount: number;
    /** The total amount for all the Leo.Application.ChildClasses.Queries.Models.ChildClassBookingReceiptModel.Lines. */
    linesAmount: number;
    /** The currency for the transaction. */
    currency: string;
    /** The transaction type for the receipt.
E.g. Leo.Database.Entities.ChildClasses.ChildClassTransactionType.Credit or Leo.Database.Entities.ChildClasses.ChildClassTransactionType.Credit. */
    receiptType: ChildClassTransactionType;
    /** All lines for the receipt. */
    lines: ChildClassBookingReceiptLineModel[];
}

/** Model for listing available child classes of a playground. */
export class ChildClassesAvailableModel implements IChildClassesAvailableModel {
    id!: number;
    classType!: ChildClassClassType;
    name!: string;
    playgroundId!: string;
    occasions!: number;
    /** Price information about the current and regular price. */
    price!: ChildClassAvailablePriceModel;
    firstOccasionDate!: Date;
    ageGroups!: ChildClassAgeGroupModel[];
    /** True if the class is a trial class, false if it's a regular one. */
    readonly isTrialClass!: boolean;
    /** True if the all the classes age groups are full. */
    fullyBooked!: boolean;

    constructor(data?: IChildClassesAvailableModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.price = new ChildClassAvailablePriceModel();
            this.ageGroups = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.classType = _data["classType"] !== undefined ? _data["classType"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.playgroundId = _data["playgroundId"] !== undefined ? _data["playgroundId"] : null as any;
            this.occasions = _data["occasions"] !== undefined ? _data["occasions"] : null as any;
            this.price = _data["price"] ? ChildClassAvailablePriceModel.fromJS(_data["price"]) : new ChildClassAvailablePriceModel();
            this.firstOccasionDate = _data["firstOccasionDate"] ? new Date(_data["firstOccasionDate"].toString()) : null as any;
            if (Array.isArray(_data["ageGroups"])) {
                this.ageGroups = [] as any;
                for (let item of _data["ageGroups"])
                    this.ageGroups!.push(ChildClassAgeGroupModel.fromJS(item));
            }
            else {
                this.ageGroups = null as any;
            }
            (this as any).isTrialClass = _data["isTrialClass"] !== undefined ? _data["isTrialClass"] : null as any;
            this.fullyBooked = _data["fullyBooked"] !== undefined ? _data["fullyBooked"] : null as any;
        }
    }

    static fromJS(data: any): ChildClassesAvailableModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChildClassesAvailableModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["classType"] = this.classType !== undefined ? this.classType : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["playgroundId"] = this.playgroundId !== undefined ? this.playgroundId : null as any;
        data["occasions"] = this.occasions !== undefined ? this.occasions : null as any;
        data["price"] = this.price ? this.price.toJSON() : null as any;
        data["firstOccasionDate"] = this.firstOccasionDate ? formatDate(this.firstOccasionDate) : null as any;
        if (Array.isArray(this.ageGroups)) {
            data["ageGroups"] = [];
            for (let item of this.ageGroups)
                data["ageGroups"].push(item ? item.toJSON() : null as any);
        }
        data["isTrialClass"] = this.isTrialClass !== undefined ? this.isTrialClass : null as any;
        data["fullyBooked"] = this.fullyBooked !== undefined ? this.fullyBooked : null as any;
        return data;
    }
}

/** Model for listing available child classes of a playground. */
export interface IChildClassesAvailableModel {
    id: number;
    classType: ChildClassClassType;
    name: string;
    playgroundId: string;
    occasions: number;
    /** Price information about the current and regular price. */
    price: ChildClassAvailablePriceModel;
    firstOccasionDate: Date;
    ageGroups: ChildClassAgeGroupModel[];
    /** True if the class is a trial class, false if it's a regular one. */
    isTrialClass: boolean;
    /** True if the all the classes age groups are full. */
    fullyBooked: boolean;
}

export enum LocationTreeLevels {
    Country = "Country",
    Region = "Region",
    Playground = "Playground",
    Area = "Area",
    Room = "Room",
    Table = "Table",
}

export class ChildDto implements IChildDto {
    guid!: string;
    firstname!: string | null;
    lastname!: string | null;
    userid!: string;
    /** Unused property, kept to avoid changes in old frontend code.
Will be removed when this DTO is removed. */
    otherinfo!: string | null;
    /** Unused property, kept to avoid changes in old frontend code.
Will be removed when this DTO is removed. */
    currency!: string | null;
    /** The birthdate in the format "YYYY-MM-DD". */
    birthdate!: string | null;
    membercardid!: string | null;
    memberid!: string | null;
    /** Set to a subscription currently active for the child.
If no active subscriptions are found this will be set to null. */
    subscription!: PeriodSubscriptionDto | null;

    constructor(data?: IChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.userid = _data["userid"] !== undefined ? _data["userid"] : null as any;
            this.otherinfo = _data["otherinfo"] !== undefined ? _data["otherinfo"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.birthdate = _data["birthdate"] !== undefined ? _data["birthdate"] : null as any;
            this.membercardid = _data["membercardid"] !== undefined ? _data["membercardid"] : null as any;
            this.memberid = _data["memberid"] !== undefined ? _data["memberid"] : null as any;
            this.subscription = _data["subscription"] ? PeriodSubscriptionDto.fromJS(_data["subscription"]) : null as any;
        }
    }

    static fromJS(data: any): ChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["firstname"] = this.firstname !== undefined ? this.firstname : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["userid"] = this.userid !== undefined ? this.userid : null as any;
        data["otherinfo"] = this.otherinfo !== undefined ? this.otherinfo : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["birthdate"] = this.birthdate !== undefined ? this.birthdate : null as any;
        data["membercardid"] = this.membercardid !== undefined ? this.membercardid : null as any;
        data["memberid"] = this.memberid !== undefined ? this.memberid : null as any;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : null as any;
        return data;
    }
}

export interface IChildDto {
    guid: string;
    firstname: string | null;
    lastname: string | null;
    userid: string;
    /** Unused property, kept to avoid changes in old frontend code.
Will be removed when this DTO is removed. */
    otherinfo: string | null;
    /** Unused property, kept to avoid changes in old frontend code.
Will be removed when this DTO is removed. */
    currency: string | null;
    /** The birthdate in the format "YYYY-MM-DD". */
    birthdate: string | null;
    membercardid: string | null;
    memberid: string | null;
    /** Set to a subscription currently active for the child.
If no active subscriptions are found this will be set to null. */
    subscription: PeriodSubscriptionDto | null;
}

export class DateCriteriaDto implements IDateCriteriaDto {
    name!: string | null;
    guid!: string;
    comparewith!: DateCriteriaComparable;
    condition!: CriteriaLessEqualMore;
    timevalue!: string | null;
    dayofweek!: string | null;
    datecriteriacollectionid!: string | null;

    constructor(data?: IDateCriteriaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.comparewith = _data["comparewith"] !== undefined ? _data["comparewith"] : null as any;
            this.condition = _data["condition"] !== undefined ? _data["condition"] : null as any;
            this.timevalue = _data["timevalue"] !== undefined ? _data["timevalue"] : null as any;
            this.dayofweek = _data["dayofweek"] !== undefined ? _data["dayofweek"] : null as any;
            this.datecriteriacollectionid = _data["datecriteriacollectionid"] !== undefined ? _data["datecriteriacollectionid"] : null as any;
        }
    }

    static fromJS(data: any): DateCriteriaDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateCriteriaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["comparewith"] = this.comparewith !== undefined ? this.comparewith : null as any;
        data["condition"] = this.condition !== undefined ? this.condition : null as any;
        data["timevalue"] = this.timevalue !== undefined ? this.timevalue : null as any;
        data["dayofweek"] = this.dayofweek !== undefined ? this.dayofweek : null as any;
        data["datecriteriacollectionid"] = this.datecriteriacollectionid !== undefined ? this.datecriteriacollectionid : null as any;
        return data;
    }
}

export interface IDateCriteriaDto {
    name: string | null;
    guid: string;
    comparewith: DateCriteriaComparable;
    condition: CriteriaLessEqualMore;
    timevalue: string | null;
    dayofweek: string | null;
    datecriteriacollectionid: string | null;
}

/** A DTO for exceptions. */
export class ErrorDto implements IErrorDto {
    /** The type of exception (type name). */
    exceptionType!: string | null;
    /** The error code, may be a number, guid or string. */
    code!: string | null;
    /** A set of property errors with the key being the property name.
If the error is for no specific property the key will be System.String.Empty. */
    errors!: { [key: string]: string[]; } | null;
    /** The HTTP response code that should be set for any HTTP response that is generated for the exception. */
    responsecode!: number;
    /** The error message. */
    message!: string | null;
    /** A set of reasons for the error. */
    reasons!: ErrorReasonDto[] | null;
    /** A stack trace for the exception, only set in development environment. */
    stackTrace!: string | null;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.exceptionType = _data["exceptionType"] !== undefined ? _data["exceptionType"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (this.errors as any)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : null as any;
                }
            }
            else {
                this.errors = null as any;
            }
            this.responsecode = _data["responsecode"] !== undefined ? _data["responsecode"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            if (Array.isArray(_data["reasons"])) {
                this.reasons = [] as any;
                for (let item of _data["reasons"])
                    this.reasons!.push(ErrorReasonDto.fromJS(item));
            }
            else {
                this.reasons = null as any;
            }
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : null as any;
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["exceptionType"] = this.exceptionType !== undefined ? this.exceptionType : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (data["errors"] as any)[key] = this.errors[key] !== undefined ? this.errors[key] : null as any;
            }
        }
        data["responsecode"] = this.responsecode !== undefined ? this.responsecode : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        if (Array.isArray(this.reasons)) {
            data["reasons"] = [];
            for (let item of this.reasons)
                data["reasons"].push(item ? item.toJSON() : null as any);
        }
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : null as any;
        return data;
    }
}

/** A DTO for exceptions. */
export interface IErrorDto {
    /** The type of exception (type name). */
    exceptionType: string | null;
    /** The error code, may be a number, guid or string. */
    code: string | null;
    /** A set of property errors with the key being the property name.
If the error is for no specific property the key will be System.String.Empty. */
    errors: { [key: string]: string[]; } | null;
    /** The HTTP response code that should be set for any HTTP response that is generated for the exception. */
    responsecode: number;
    /** The error message. */
    message: string | null;
    /** A set of reasons for the error. */
    reasons: ErrorReasonDto[] | null;
    /** A stack trace for the exception, only set in development environment. */
    stackTrace: string | null;
}

/** A reason for the exception. */
export class ErrorReasonDto implements IErrorReasonDto {
    /** The reason code. */
    code!: string | null;
    /** The reason message. */
    message!: string | null;

    constructor(data?: IErrorReasonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): ErrorReasonDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorReasonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }
}

/** A reason for the exception. */
export interface IErrorReasonDto {
    /** The reason code. */
    code: string | null;
    /** The reason message. */
    message: string | null;
}

export class LocationDto implements ILocationDto {
    locationid!: string | null;
    name!: string | null;
    type!: string | null;
    path!: string[] | null;

    constructor(data?: ILocationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationid = _data["locationid"] !== undefined ? _data["locationid"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
            else {
                this.path = null as any;
            }
        }
    }

    static fromJS(data: any): LocationDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationid"] = this.locationid !== undefined ? this.locationid : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        return data;
    }
}

export interface ILocationDto {
    locationid: string | null;
    name: string | null;
    type: string | null;
    path: string[] | null;
}

export class LocationListDto implements ILocationListDto {
    countries!: LocationListItem[] | null;
    regions!: LocationListItem[] | null;
    playgrounds!: LocationListItem[] | null;
    areas!: LocationListItem[] | null;
    rooms!: LocationListItem[] | null;
    tables!: LocationListItem[] | null;
    unknownparents!: LocationListItem[] | null;

    constructor(data?: ILocationListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(LocationListItem.fromJS(item));
            }
            else {
                this.countries = null as any;
            }
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(LocationListItem.fromJS(item));
            }
            else {
                this.regions = null as any;
            }
            if (Array.isArray(_data["playgrounds"])) {
                this.playgrounds = [] as any;
                for (let item of _data["playgrounds"])
                    this.playgrounds!.push(LocationListItem.fromJS(item));
            }
            else {
                this.playgrounds = null as any;
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(LocationListItem.fromJS(item));
            }
            else {
                this.areas = null as any;
            }
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(LocationListItem.fromJS(item));
            }
            else {
                this.rooms = null as any;
            }
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(LocationListItem.fromJS(item));
            }
            else {
                this.tables = null as any;
            }
            if (Array.isArray(_data["unknownparents"])) {
                this.unknownparents = [] as any;
                for (let item of _data["unknownparents"])
                    this.unknownparents!.push(LocationListItem.fromJS(item));
            }
            else {
                this.unknownparents = null as any;
            }
        }
    }

    static fromJS(data: any): LocationListDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.playgrounds)) {
            data["playgrounds"] = [];
            for (let item of this.playgrounds)
                data["playgrounds"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.unknownparents)) {
            data["unknownparents"] = [];
            for (let item of this.unknownparents)
                data["unknownparents"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ILocationListDto {
    countries: LocationListItem[] | null;
    regions: LocationListItem[] | null;
    playgrounds: LocationListItem[] | null;
    areas: LocationListItem[] | null;
    rooms: LocationListItem[] | null;
    tables: LocationListItem[] | null;
    unknownparents: LocationListItem[] | null;
}

export class LocationTreeDto implements ILocationTreeDto {
    items!: LocationListItem[] | null;

    constructor(data?: ILocationTreeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(LocationListItem.fromJS(item));
            }
            else {
                this.items = null as any;
            }
        }
    }

    static fromJS(data: any): LocationTreeDto {
        data = typeof data === 'object' ? data : {};
        let result = new LocationTreeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ILocationTreeDto {
    items: LocationListItem[] | null;
}

/** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
export class MediaItemDto implements IMediaItemDto {
    guid!: string;
    /** The version of the media */
    version!: number;
    /** The type of saved media. */
    mediaType!: MediaType;
    sizeInBytes!: number;
    width!: number;
    height!: number;

    constructor(data?: IMediaItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.version = _data["version"] !== undefined ? _data["version"] : null as any;
            this.mediaType = _data["mediaType"] !== undefined ? _data["mediaType"] : null as any;
            this.sizeInBytes = _data["sizeInBytes"] !== undefined ? _data["sizeInBytes"] : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
        }
    }

    static fromJS(data: any): MediaItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new MediaItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["version"] = this.version !== undefined ? this.version : null as any;
        data["mediaType"] = this.mediaType !== undefined ? this.mediaType : null as any;
        data["sizeInBytes"] = this.sizeInBytes !== undefined ? this.sizeInBytes : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        return data;
    }
}

/** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
export interface IMediaItemDto {
    guid: string;
    /** The version of the media */
    version: number;
    /** The type of saved media. */
    mediaType: MediaType;
    sizeInBytes: number;
    width: number;
    height: number;
}

/** The type of saved media. */
export enum MediaType {
    Jpeg = "Jpeg",
    Gif = "Gif",
    Png = "Png",
    Bmp = "Bmp",
    Tiff = "Tiff",
}

export enum SyncGiftCardByCardNumberCommandValidatorErrorCodes {
    InvalidCardNumber = "InvalidCardNumber",
}

/** Represents a opening and closing time. */
export class OpenHoursDto implements IOpenHoursDto {
    /** The opening time. */
    from!: string;
    /** The closing time. */
    to!: string;

    constructor(data?: IOpenHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.from = _data["from"] !== undefined ? _data["from"] : null as any;
            this.to = _data["to"] !== undefined ? _data["to"] : null as any;
        }
    }

    static fromJS(data: any): OpenHoursDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpenHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from !== undefined ? this.from : null as any;
        data["to"] = this.to !== undefined ? this.to : null as any;
        return data;
    }
}

/** Represents a opening and closing time. */
export interface IOpenHoursDto {
    /** The opening time. */
    from: string;
    /** The closing time. */
    to: string;
}

export class OpeningHoursDto implements IOpeningHoursDto {
    /** The date for this set of opening hours */
    date!: Date;
    /** The list of opening hours for this specific day */
    open!: OpenHoursDto[];
    /** Is closed this specific day */
    readonly isClosed!: boolean;
    /** A comment regarding the opening hours for this day */
    comment!: string | null;

    constructor(data?: IOpeningHoursDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.open = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            if (Array.isArray(_data["open"])) {
                this.open = [] as any;
                for (let item of _data["open"])
                    this.open!.push(OpenHoursDto.fromJS(item));
            }
            else {
                this.open = null as any;
            }
            (this as any).isClosed = _data["isClosed"] !== undefined ? _data["isClosed"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
        }
    }

    static fromJS(data: any): OpeningHoursDto {
        data = typeof data === 'object' ? data : {};
        let result = new OpeningHoursDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatDate(this.date) : null as any;
        if (Array.isArray(this.open)) {
            data["open"] = [];
            for (let item of this.open)
                data["open"].push(item ? item.toJSON() : null as any);
        }
        data["isClosed"] = this.isClosed !== undefined ? this.isClosed : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        return data;
    }
}

export interface IOpeningHoursDto {
    /** The date for this set of opening hours */
    date: Date;
    /** The list of opening hours for this specific day */
    open: OpenHoursDto[];
    /** Is closed this specific day */
    isClosed: boolean;
    /** A comment regarding the opening hours for this day */
    comment: string | null;
}

export enum SyncSerialTicketByCardNumberCommandValidatorErrorCodes {
    UserNotFound = "UserNotFound",
}

export enum SyncSerialTicketByIdCommandValidatorErrorCodes {
    SerialTicketNotFound = "SerialTicketNotFound",
}

/** Create a gift card order and retrieve a payment session to pay the order. */
export class CreateGiftCardOrderCommand implements ICreateGiftCardOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The email to send to. */
    recipientEmail!: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language!: string | null;

    constructor(data?: ICreateGiftCardOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.recipientEmail = _data["recipientEmail"] !== undefined ? _data["recipientEmail"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static fromJS(data: any): CreateGiftCardOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateGiftCardOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["recipientEmail"] = this.recipientEmail !== undefined ? this.recipientEmail : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        return data;
    }
}

/** Create a gift card order and retrieve a payment session to pay the order. */
export interface ICreateGiftCardOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The email to send to. */
    recipientEmail: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language: string | null;
}

/** Payment information for a gift card order. */
export class GiftCardOrderPaymentModel implements IGiftCardOrderPaymentModel {
    /** The order reference. */
    orderReference!: string;
    /** The payment session token. */
    paymentToken!: string;

    constructor(data?: IGiftCardOrderPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : null as any;
            this.paymentToken = _data["paymentToken"] !== undefined ? _data["paymentToken"] : null as any;
        }
    }

    static fromJS(data: any): GiftCardOrderPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardOrderPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : null as any;
        data["paymentToken"] = this.paymentToken !== undefined ? this.paymentToken : null as any;
        return data;
    }
}

/** Payment information for a gift card order. */
export interface IGiftCardOrderPaymentModel {
    /** The order reference. */
    orderReference: string;
    /** The payment session token. */
    paymentToken: string;
}

/** Get an order summary, before placing the order, for a shop gift card order. */
export class GetGiftCardOrderSummaryQuery implements IGetGiftCardOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;

    constructor(data?: IGetGiftCardOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
        }
    }

    static fromJS(data: any): GetGiftCardOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetGiftCardOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        return data;
    }
}

/** Get an order summary, before placing the order, for a shop gift card order. */
export interface IGetGiftCardOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
}

export class GiftCardArticleSummaryModel implements IGiftCardArticleSummaryModel {
    id!: number;
    name!: string;
    description!: string;
    price!: number;
    giftCardAmount!: number;
    /** The currency for the price. */
    currency!: string;
    sellablePeriodStartDate!: Date | null;
    sellablePeriodEndDate!: Date | null;
    cardActivationDate!: Date | null;
    countryId!: string;
    /** The name of the Leo.Application.Shop.GiftCards.Queries.Models.GiftCardArticleSummaryModel.CountryId. */
    countryName!: string;
    /** True if the article currently is actively sellable. */
    isActive!: boolean;
    /** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
    media!: MediaItemDto;

    constructor(data?: IGiftCardArticleSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.giftCardAmount = _data["giftCardAmount"] !== undefined ? _data["giftCardAmount"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.sellablePeriodStartDate = _data["sellablePeriodStartDate"] ? new Date(_data["sellablePeriodStartDate"].toString()) : null as any;
            this.sellablePeriodEndDate = _data["sellablePeriodEndDate"] ? new Date(_data["sellablePeriodEndDate"].toString()) : null as any;
            this.cardActivationDate = _data["cardActivationDate"] ? new Date(_data["cardActivationDate"].toString()) : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
        }
    }

    static fromJS(data: any): GiftCardArticleSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardArticleSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["giftCardAmount"] = this.giftCardAmount !== undefined ? this.giftCardAmount : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["sellablePeriodStartDate"] = this.sellablePeriodStartDate ? this.sellablePeriodStartDate.toISOString() : null as any;
        data["sellablePeriodEndDate"] = this.sellablePeriodEndDate ? this.sellablePeriodEndDate.toISOString() : null as any;
        data["cardActivationDate"] = this.cardActivationDate ? this.cardActivationDate.toISOString() : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["media"] = this.media ? this.media.toJSON() : null as any;
        return data;
    }
}

export interface IGiftCardArticleSummaryModel {
    id: number;
    name: string;
    description: string;
    price: number;
    giftCardAmount: number;
    /** The currency for the price. */
    currency: string;
    sellablePeriodStartDate: Date | null;
    sellablePeriodEndDate: Date | null;
    cardActivationDate: Date | null;
    countryId: string;
    /** The name of the Leo.Application.Shop.GiftCards.Queries.Models.GiftCardArticleSummaryModel.CountryId. */
    countryName: string;
    /** True if the article currently is actively sellable. */
    isActive: boolean;
    /** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
    media: MediaItemDto;
}

/** A single order line in the summary model. */
export class GiftCardOrderSummaryLineModel implements IGiftCardOrderSummaryLineModel {
    /** The id of the article for the line. */
    articleId!: number;
    /** The name of the article for the line. */
    articleName!: string;
    /** The quantity ordered. */
    quantity!: number;
    /** The total amount for the line, incl. VAT. */
    amount!: number;

    constructor(data?: IGiftCardOrderSummaryLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): GiftCardOrderSummaryLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardOrderSummaryLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

/** A single order line in the summary model. */
export interface IGiftCardOrderSummaryLineModel {
    /** The id of the article for the line. */
    articleId: number;
    /** The name of the article for the line. */
    articleName: string;
    /** The quantity ordered. */
    quantity: number;
    /** The total amount for the line, incl. VAT. */
    amount: number;
}

/** Gift card order summary mode. */
export class GiftCardOrderSummaryModel implements IGiftCardOrderSummaryModel {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The total price for the article. */
    price!: number;
    /** The currency for the price. */
    currency!: string;
    /** The start and end date of the card. */
    rules!: string;
    /** The total price of the order. */
    totalAmount!: number;
    /** The validity period. */
    period!: GiftCardValidPeriodModel;
    /** The order lines. */
    lines!: GiftCardOrderSummaryLineModel[];

    constructor(data?: IGiftCardOrderSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.period = new GiftCardValidPeriodModel();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : null as any;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
            this.period = _data["period"] ? GiftCardValidPeriodModel.fromJS(_data["period"]) : new GiftCardValidPeriodModel();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(GiftCardOrderSummaryLineModel.fromJS(item));
            }
            else {
                this.lines = null as any;
            }
        }
    }

    static fromJS(data: any): GiftCardOrderSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardOrderSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["rules"] = this.rules !== undefined ? this.rules : null as any;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        data["period"] = this.period ? this.period.toJSON() : null as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Gift card order summary mode. */
export interface IGiftCardOrderSummaryModel {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The total price for the article. */
    price: number;
    /** The currency for the price. */
    currency: string;
    /** The start and end date of the card. */
    rules: string;
    /** The total price of the order. */
    totalAmount: number;
    /** The validity period. */
    period: GiftCardValidPeriodModel;
    /** The order lines. */
    lines: GiftCardOrderSummaryLineModel[];
}

/** Properties for an articles valid period. */
export class GiftCardValidPeriodModel implements IGiftCardValidPeriodModel {
    /** The start of the period. */
    start!: Date;
    /** The end of the period. */
    end!: Date;

    constructor(data?: IGiftCardValidPeriodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : null as any;
        }
    }

    static fromJS(data: any): GiftCardValidPeriodModel {
        data = typeof data === 'object' ? data : {};
        let result = new GiftCardValidPeriodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        return data;
    }
}

/** Properties for an articles valid period. */
export interface IGiftCardValidPeriodModel {
    /** The start of the period. */
    start: Date;
    /** The end of the period. */
    end: Date;
}

export class SellableGiftCardArticleModel implements ISellableGiftCardArticleModel {
    id!: number;
    name!: string;
    description!: string;
    /** The price of the article, in the location currency. */
    price!: number;
    countryId!: string;
    /** The name of the country. */
    countryName!: string;
    rules!: string;
    /** The media item for the card. */
    media!: MediaItemDto;

    constructor(data?: ISellableGiftCardArticleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : null as any;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
        }
    }

    static fromJS(data: any): SellableGiftCardArticleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SellableGiftCardArticleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["rules"] = this.rules !== undefined ? this.rules : null as any;
        data["media"] = this.media ? this.media.toJSON() : null as any;
        return data;
    }
}

export interface ISellableGiftCardArticleModel {
    id: number;
    name: string;
    description: string;
    /** The price of the article, in the location currency. */
    price: number;
    countryId: string;
    /** The name of the country. */
    countryName: string;
    rules: string;
    /** The media item for the card. */
    media: MediaItemDto;
}

/** Create a shop order and retrieve a payment session to pay the order. */
export class CreateDirectPassOrderCommand implements ICreateDirectPassOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The child to purchase the article for. */
    childId!: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language!: string | null;

    constructor(data?: ICreateDirectPassOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static fromJS(data: any): CreateDirectPassOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateDirectPassOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["childId"] = this.childId !== undefined ? this.childId : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        return data;
    }
}

/** Create a shop order and retrieve a payment session to pay the order. */
export interface ICreateDirectPassOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The child to purchase the article for. */
    childId: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language: string | null;
}

/** Create a redeem shop order and retrieve a payment session to pay the order. */
export class CreateRedeemPassOrderCommand implements ICreateRedeemPassOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The email of the recipient. */
    recipientEmail!: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language!: string | null;

    constructor(data?: ICreateRedeemPassOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.recipientEmail = _data["recipientEmail"] !== undefined ? _data["recipientEmail"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static fromJS(data: any): CreateRedeemPassOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRedeemPassOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["recipientEmail"] = this.recipientEmail !== undefined ? this.recipientEmail : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        return data;
    }
}

/** Create a redeem shop order and retrieve a payment session to pay the order. */
export interface ICreateRedeemPassOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The email of the recipient. */
    recipientEmail: string;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language: string | null;
}

/** Payment information for a shop member card order. */
export class PassOrderPaymentModel implements IPassOrderPaymentModel {
    /** The order reference. */
    orderReference!: string;
    /** The payment session token. */
    paymentToken!: string;

    constructor(data?: IPassOrderPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : null as any;
            this.paymentToken = _data["paymentToken"] !== undefined ? _data["paymentToken"] : null as any;
        }
    }

    static fromJS(data: any): PassOrderPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new PassOrderPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : null as any;
        data["paymentToken"] = this.paymentToken !== undefined ? this.paymentToken : null as any;
        return data;
    }
}

/** Payment information for a shop member card order. */
export interface IPassOrderPaymentModel {
    /** The order reference. */
    orderReference: string;
    /** The payment session token. */
    paymentToken: string;
}

/** Get an order summary, before placing the order, for a shop pass order. */
export class GetDirectPassOrderSummaryQuery implements IGetDirectPassOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;
    /** The id of the child to retrieve the summary for. */
    childId!: string;

    constructor(data?: IGetDirectPassOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : null as any;
        }
    }

    static fromJS(data: any): GetDirectPassOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetDirectPassOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["childId"] = this.childId !== undefined ? this.childId : null as any;
        return data;
    }
}

/** Get an order summary, before placing the order, for a shop pass order. */
export interface IGetDirectPassOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
    /** The id of the child to retrieve the summary for. */
    childId: string;
}

/** Get a redeem summary, before performing the redeem for a pass order. */
export class GetRedeemPassOrderSummaryQuery implements IGetRedeemPassOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;

    constructor(data?: IGetRedeemPassOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
        }
    }

    static fromJS(data: any): GetRedeemPassOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetRedeemPassOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        return data;
    }
}

/** Get a redeem summary, before performing the redeem for a pass order. */
export interface IGetRedeemPassOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
}

/** Order summary mode. */
export class PassDirectOrderSummaryDto implements IPassDirectOrderSummaryDto {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The id of the child in the order. */
    childId!: string;
    /** The full name of the child. */
    childName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The playground id that the article will be assigned to after purchase. */
    playgroundId!: string | null;
    /** The name of the playground that the article will be assigned to after purchase. */
    playgroundName!: string | null;
    /** The total price, incl. VAT,  of the order. */
    totalAmount!: number;
    /** The currency for the price. */
    currency!: string;
    /** The start and end date of the card. */
    period!: PassPeriodDto;
    /** The order lines. */
    lines!: PassDirectOrderSummaryLineDto[];

    constructor(data?: IPassDirectOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.period = new PassPeriodDto();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : null as any;
            this.childName = _data["childName"] !== undefined ? _data["childName"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.playgroundId = _data["playgroundId"] !== undefined ? _data["playgroundId"] : null as any;
            this.playgroundName = _data["playgroundName"] !== undefined ? _data["playgroundName"] : null as any;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.period = _data["period"] ? PassPeriodDto.fromJS(_data["period"]) : new PassPeriodDto();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PassDirectOrderSummaryLineDto.fromJS(item));
            }
            else {
                this.lines = null as any;
            }
        }
    }

    static fromJS(data: any): PassDirectOrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassDirectOrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["childId"] = this.childId !== undefined ? this.childId : null as any;
        data["childName"] = this.childName !== undefined ? this.childName : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["playgroundId"] = this.playgroundId !== undefined ? this.playgroundId : null as any;
        data["playgroundName"] = this.playgroundName !== undefined ? this.playgroundName : null as any;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["period"] = this.period ? this.period.toJSON() : null as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Order summary mode. */
export interface IPassDirectOrderSummaryDto {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The id of the child in the order. */
    childId: string;
    /** The full name of the child. */
    childName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The playground id that the article will be assigned to after purchase. */
    playgroundId: string | null;
    /** The name of the playground that the article will be assigned to after purchase. */
    playgroundName: string | null;
    /** The total price, incl. VAT,  of the order. */
    totalAmount: number;
    /** The currency for the price. */
    currency: string;
    /** The start and end date of the card. */
    period: PassPeriodDto;
    /** The order lines. */
    lines: PassDirectOrderSummaryLineDto[];
}

/** A single order line in the summary model. */
export class PassDirectOrderSummaryLineDto implements IPassDirectOrderSummaryLineDto {
    /** The id of the article for the line. */
    articleId!: number;
    /** The name of the article for the line. */
    articleName!: string;
    /** The quantity ordered. */
    quantity!: number;
    /** The total amount for the line, incl. VAT. */
    amount!: number;
    /** The id of the child that the article will be purchased for. */
    childId!: string;
    /** The name of the child that the article will be purchased for. */
    childName!: string;

    constructor(data?: IPassDirectOrderSummaryLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : null as any;
            this.childName = _data["childName"] !== undefined ? _data["childName"] : null as any;
        }
    }

    static fromJS(data: any): PassDirectOrderSummaryLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassDirectOrderSummaryLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["childId"] = this.childId !== undefined ? this.childId : null as any;
        data["childName"] = this.childName !== undefined ? this.childName : null as any;
        return data;
    }
}

/** A single order line in the summary model. */
export interface IPassDirectOrderSummaryLineDto {
    /** The id of the article for the line. */
    articleId: number;
    /** The name of the article for the line. */
    articleName: string;
    /** The quantity ordered. */
    quantity: number;
    /** The total amount for the line, incl. VAT. */
    amount: number;
    /** The id of the child that the article will be purchased for. */
    childId: string;
    /** The name of the child that the article will be purchased for. */
    childName: string;
}

/** Properties for a Leo.Database.Enums.Shop.Passes.PassArticleType.Period card article. */
export class PassPeriodDto implements IPassPeriodDto {
    /** The start of the period. */
    start!: Date;
    /** The end of the period. */
    end!: Date;

    constructor(data?: IPassPeriodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : null as any;
        }
    }

    static fromJS(data: any): PassPeriodDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassPeriodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? formatDate(this.start) : null as any;
        data["end"] = this.end ? formatDate(this.end) : null as any;
        return data;
    }
}

/** Properties for a Leo.Database.Enums.Shop.Passes.PassArticleType.Period card article. */
export interface IPassPeriodDto {
    /** The start of the period. */
    start: Date;
    /** The end of the period. */
    end: Date;
}

/** Represents the status of a photo upload for a specific Leo.Database.Entities.Shop.Passes.PassArticleEntity. */
export class PassPhotoUploadStatusDto implements IPassPhotoUploadStatusDto {
    /** Indicates whether photo upload is available. */
    photoUploadAvailable!: boolean;
    /** Number of allowed bookings without image, if null there is no limitation set. */
    numberOfAllowedBookingsWithoutImage!: number | null;

    constructor(data?: IPassPhotoUploadStatusDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.photoUploadAvailable = _data["photoUploadAvailable"] !== undefined ? _data["photoUploadAvailable"] : null as any;
            this.numberOfAllowedBookingsWithoutImage = _data["numberOfAllowedBookingsWithoutImage"] !== undefined ? _data["numberOfAllowedBookingsWithoutImage"] : null as any;
        }
    }

    static fromJS(data: any): PassPhotoUploadStatusDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassPhotoUploadStatusDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["photoUploadAvailable"] = this.photoUploadAvailable !== undefined ? this.photoUploadAvailable : null as any;
        data["numberOfAllowedBookingsWithoutImage"] = this.numberOfAllowedBookingsWithoutImage !== undefined ? this.numberOfAllowedBookingsWithoutImage : null as any;
        return data;
    }
}

/** Represents the status of a photo upload for a specific Leo.Database.Entities.Shop.Passes.PassArticleEntity. */
export interface IPassPhotoUploadStatusDto {
    /** Indicates whether photo upload is available. */
    photoUploadAvailable: boolean;
    /** Number of allowed bookings without image, if null there is no limitation set. */
    numberOfAllowedBookingsWithoutImage: number | null;
}

/** Order summary mode. */
export class PassRedeemOrderSummaryDto implements IPassRedeemOrderSummaryDto {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The total price, incl. VAT,  of the order. */
    totalAmount!: number;
    /** The currency for the price. */
    currency!: string;
    /** The start and end date of the card, if any. */
    period!: PassPeriodDto | null;
    /** The order lines. */
    lines!: PassRedeemOrderSummaryLineDto[];

    constructor(data?: IPassRedeemOrderSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.period = _data["period"] ? PassPeriodDto.fromJS(_data["period"]) : null as any;
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(PassRedeemOrderSummaryLineDto.fromJS(item));
            }
            else {
                this.lines = null as any;
            }
        }
    }

    static fromJS(data: any): PassRedeemOrderSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassRedeemOrderSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["period"] = this.period ? this.period.toJSON() : null as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Order summary mode. */
export interface IPassRedeemOrderSummaryDto {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The total price, incl. VAT,  of the order. */
    totalAmount: number;
    /** The currency for the price. */
    currency: string;
    /** The start and end date of the card, if any. */
    period: PassPeriodDto | null;
    /** The order lines. */
    lines: PassRedeemOrderSummaryLineDto[];
}

/** A single order line in the summary model. */
export class PassRedeemOrderSummaryLineDto implements IPassRedeemOrderSummaryLineDto {
    /** The id of the article for the line. */
    articleId!: number;
    /** The name of the article for the line. */
    articleName!: string;
    /** The quantity ordered. */
    quantity!: number;
    /** The total amount for the line, incl. VAT. */
    amount!: number;

    constructor(data?: IPassRedeemOrderSummaryLineDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): PassRedeemOrderSummaryLineDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassRedeemOrderSummaryLineDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

/** A single order line in the summary model. */
export interface IPassRedeemOrderSummaryLineDto {
    /** The id of the article for the line. */
    articleId: number;
    /** The name of the article for the line. */
    articleName: string;
    /** The quantity ordered. */
    quantity: number;
    /** The total amount for the line, incl. VAT. */
    amount: number;
}

/** Create a new connect to account session. */
export class CreateConnectToAccountSessionCommand implements ICreateConnectToAccountSessionCommand {
    /** The card number of the serial ticket to connect to account. */
    cardNumber!: string;
    /** The card pin code. */
    pinCode!: string;

    constructor(data?: ICreateConnectToAccountSessionCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cardNumber = _data["cardNumber"] !== undefined ? _data["cardNumber"] : null as any;
            this.pinCode = _data["pinCode"] !== undefined ? _data["pinCode"] : null as any;
        }
    }

    static fromJS(data: any): CreateConnectToAccountSessionCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateConnectToAccountSessionCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cardNumber"] = this.cardNumber !== undefined ? this.cardNumber : null as any;
        data["pinCode"] = this.pinCode !== undefined ? this.pinCode : null as any;
        return data;
    }
}

/** Create a new connect to account session. */
export interface ICreateConnectToAccountSessionCommand {
    /** The card number of the serial ticket to connect to account. */
    cardNumber: string;
    /** The card pin code. */
    pinCode: string;
}

/** Create a shop order and retrieve a payment session to pay the order. */
export class CreateSerialTicketDirectOrderCommand implements ICreateSerialTicketDirectOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language!: string | null;

    constructor(data?: ICreateSerialTicketDirectOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static fromJS(data: any): CreateSerialTicketDirectOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSerialTicketDirectOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        return data;
    }
}

/** Create a shop order and retrieve a payment session to pay the order. */
export interface ICreateSerialTicketDirectOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The language to display the UI/payment window in, null to use the culture from the user. */
    language: string | null;
}

/** Create a shop redeem order and retrieve a payment sessioin to pay the order. */
export class CreateSerialTicketRedeemOrderCommand implements ICreateSerialTicketRedeemOrderCommand {
    /** The id of the article to purchase. */
    articleId!: number;
    /** The email address to send the receipt and redeem message to. */
    recipientEmail!: string;
    /** The language to display the UI/payment window in, null to use country default. */
    language!: string | null;

    constructor(data?: ICreateSerialTicketRedeemOrderCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.recipientEmail = _data["recipientEmail"] !== undefined ? _data["recipientEmail"] : null as any;
            this.language = _data["language"] !== undefined ? _data["language"] : null as any;
        }
    }

    static fromJS(data: any): CreateSerialTicketRedeemOrderCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateSerialTicketRedeemOrderCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["recipientEmail"] = this.recipientEmail !== undefined ? this.recipientEmail : null as any;
        data["language"] = this.language !== undefined ? this.language : null as any;
        return data;
    }
}

/** Create a shop redeem order and retrieve a payment sessioin to pay the order. */
export interface ICreateSerialTicketRedeemOrderCommand {
    /** The id of the article to purchase. */
    articleId: number;
    /** The email address to send the receipt and redeem message to. */
    recipientEmail: string;
    /** The language to display the UI/payment window in, null to use country default. */
    language: string | null;
}

/** Payment information for a shop serial ticket order. */
export class SerialTicketOrderPaymentModel implements ISerialTicketOrderPaymentModel {
    /** The order reference. */
    orderReference!: string;
    /** The payment session token. */
    paymentToken!: string;

    constructor(data?: ISerialTicketOrderPaymentModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : null as any;
            this.paymentToken = _data["paymentToken"] !== undefined ? _data["paymentToken"] : null as any;
        }
    }

    static fromJS(data: any): SerialTicketOrderPaymentModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketOrderPaymentModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : null as any;
        data["paymentToken"] = this.paymentToken !== undefined ? this.paymentToken : null as any;
        return data;
    }
}

/** Payment information for a shop serial ticket order. */
export interface ISerialTicketOrderPaymentModel {
    /** The order reference. */
    orderReference: string;
    /** The payment session token. */
    paymentToken: string;
}

/** Get an order summary, before placing the order, for a shop serial ticket direct order. */
export class GetSerialTicketDirectOrderSummaryQuery implements IGetSerialTicketDirectOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;

    constructor(data?: IGetSerialTicketDirectOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
        }
    }

    static fromJS(data: any): GetSerialTicketDirectOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSerialTicketDirectOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        return data;
    }
}

/** Get an order summary, before placing the order, for a shop serial ticket direct order. */
export interface IGetSerialTicketDirectOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
}

/** Get an order summary, before placing the order, for a shop serial ticket redeem order. */
export class GetSerialTicketRedeemOrderSummaryQuery implements IGetSerialTicketRedeemOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId!: number;

    constructor(data?: IGetSerialTicketRedeemOrderSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
        }
    }

    static fromJS(data: any): GetSerialTicketRedeemOrderSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new GetSerialTicketRedeemOrderSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        return data;
    }
}

/** Get an order summary, before placing the order, for a shop serial ticket redeem order. */
export interface IGetSerialTicketRedeemOrderSummaryQuery {
    /** The id of the article to retrieve the summary for. */
    articleId: number;
}

/** A sellable shop serial ticket article. */
export class SellableSerialTicketArticleModel implements ISellableSerialTicketArticleModel {
    id!: number;
    name!: string;
    description!: string;
    price!: number;
    /** The currency for the price. */
    currency!: string;
    countryId!: string;
    /** The name of the country. */
    countryName!: string;
    ticketActivationDate!: Date | null;
    validityDurationType!: DurationType2;
    validityDuration!: number;
    rules!: string;
    /** The media item for the serial ticket. */
    media!: MediaItemDto;
    inactiveReason!: SerialTicketArticleInactiveReason | null;

    constructor(data?: ISellableSerialTicketArticleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.countryId = _data["countryId"] !== undefined ? _data["countryId"] : null as any;
            this.countryName = _data["countryName"] !== undefined ? _data["countryName"] : null as any;
            this.ticketActivationDate = _data["ticketActivationDate"] ? new Date(_data["ticketActivationDate"].toString()) : null as any;
            this.validityDurationType = _data["validityDurationType"] !== undefined ? _data["validityDurationType"] : null as any;
            this.validityDuration = _data["validityDuration"] !== undefined ? _data["validityDuration"] : null as any;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : null as any;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
            this.inactiveReason = _data["inactiveReason"] !== undefined ? _data["inactiveReason"] : null as any;
        }
    }

    static fromJS(data: any): SellableSerialTicketArticleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SellableSerialTicketArticleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["countryId"] = this.countryId !== undefined ? this.countryId : null as any;
        data["countryName"] = this.countryName !== undefined ? this.countryName : null as any;
        data["ticketActivationDate"] = this.ticketActivationDate ? this.ticketActivationDate.toISOString() : null as any;
        data["validityDurationType"] = this.validityDurationType !== undefined ? this.validityDurationType : null as any;
        data["validityDuration"] = this.validityDuration !== undefined ? this.validityDuration : null as any;
        data["rules"] = this.rules !== undefined ? this.rules : null as any;
        data["media"] = this.media ? this.media.toJSON() : null as any;
        data["inactiveReason"] = this.inactiveReason !== undefined ? this.inactiveReason : null as any;
        return data;
    }
}

/** A sellable shop serial ticket article. */
export interface ISellableSerialTicketArticleModel {
    id: number;
    name: string;
    description: string;
    price: number;
    /** The currency for the price. */
    currency: string;
    countryId: string;
    /** The name of the country. */
    countryName: string;
    ticketActivationDate: Date | null;
    validityDurationType: DurationType2;
    validityDuration: number;
    rules: string;
    /** The media item for the serial ticket. */
    media: MediaItemDto;
    inactiveReason: SerialTicketArticleInactiveReason | null;
}

/** Connect serial ticket to account information. */
export class SerialTicketConnectToAccountInformationModel implements ISerialTicketConnectToAccountInformationModel {
    /** The name of the ticket article. */
    articleName!: string;
    /** The name of the users preferred playground. */
    playgroundName!: string | null;
    /** The date the ticket is valid from. */
    validFrom!: Date;
    /** The date the ticket is valid to. */
    validTo!: Date;
    /** The name of the company that sold the ticket. */
    companyName!: string;
    /** The number of entrances included in the ticket. */
    numberOfEntrances!: number;
    /** The email address of the current user. */
    accountEmail!: string | null;
    /** The article rules. */
    rules!: string;

    constructor(data?: ISerialTicketConnectToAccountInformationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.playgroundName = _data["playgroundName"] !== undefined ? _data["playgroundName"] : null as any;
            this.validFrom = _data["validFrom"] ? new Date(_data["validFrom"].toString()) : null as any;
            this.validTo = _data["validTo"] ? new Date(_data["validTo"].toString()) : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.numberOfEntrances = _data["numberOfEntrances"] !== undefined ? _data["numberOfEntrances"] : null as any;
            this.accountEmail = _data["accountEmail"] !== undefined ? _data["accountEmail"] : null as any;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : null as any;
        }
    }

    static fromJS(data: any): SerialTicketConnectToAccountInformationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketConnectToAccountInformationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["playgroundName"] = this.playgroundName !== undefined ? this.playgroundName : null as any;
        data["validFrom"] = this.validFrom ? formatDate(this.validFrom) : null as any;
        data["validTo"] = this.validTo ? formatDate(this.validTo) : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["numberOfEntrances"] = this.numberOfEntrances !== undefined ? this.numberOfEntrances : null as any;
        data["accountEmail"] = this.accountEmail !== undefined ? this.accountEmail : null as any;
        data["rules"] = this.rules !== undefined ? this.rules : null as any;
        return data;
    }
}

/** Connect serial ticket to account information. */
export interface ISerialTicketConnectToAccountInformationModel {
    /** The name of the ticket article. */
    articleName: string;
    /** The name of the users preferred playground. */
    playgroundName: string | null;
    /** The date the ticket is valid from. */
    validFrom: Date;
    /** The date the ticket is valid to. */
    validTo: Date;
    /** The name of the company that sold the ticket. */
    companyName: string;
    /** The number of entrances included in the ticket. */
    numberOfEntrances: number;
    /** The email address of the current user. */
    accountEmail: string | null;
    /** The article rules. */
    rules: string;
}

/** Direct order summary model. */
export class SerialTicketDirectOrderSummaryModel implements ISerialTicketDirectOrderSummaryModel {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The playground id that the article will be assigned to after the purchase. */
    playgroundId!: string | null;
    /** The name of the playground that the article will be assigned to after the purchase. */
    playgroundName!: string | null;
    /** The total price of the order. */
    totalAmount!: number;
    /** The currency for the price. */
    currency!: string;
    /** The rules of the article. */
    rules!: string;
    /** The number of entrances the serial ticket will provide. */
    numberOfEntrances!: number;
    /** The start and end date of the serial ticket. */
    period!: SerialTicketValidPeriodModel;
    /** The order lines. */
    lines!: SerialTicketOrderSummaryLineModel[];

    constructor(data?: ISerialTicketDirectOrderSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.period = new SerialTicketValidPeriodModel();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.playgroundId = _data["playgroundId"] !== undefined ? _data["playgroundId"] : null as any;
            this.playgroundName = _data["playgroundName"] !== undefined ? _data["playgroundName"] : null as any;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : null as any;
            this.numberOfEntrances = _data["numberOfEntrances"] !== undefined ? _data["numberOfEntrances"] : null as any;
            this.period = _data["period"] ? SerialTicketValidPeriodModel.fromJS(_data["period"]) : new SerialTicketValidPeriodModel();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SerialTicketOrderSummaryLineModel.fromJS(item));
            }
            else {
                this.lines = null as any;
            }
        }
    }

    static fromJS(data: any): SerialTicketDirectOrderSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketDirectOrderSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["playgroundId"] = this.playgroundId !== undefined ? this.playgroundId : null as any;
        data["playgroundName"] = this.playgroundName !== undefined ? this.playgroundName : null as any;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["rules"] = this.rules !== undefined ? this.rules : null as any;
        data["numberOfEntrances"] = this.numberOfEntrances !== undefined ? this.numberOfEntrances : null as any;
        data["period"] = this.period ? this.period.toJSON() : null as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Direct order summary model. */
export interface ISerialTicketDirectOrderSummaryModel {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The playground id that the article will be assigned to after the purchase. */
    playgroundId: string | null;
    /** The name of the playground that the article will be assigned to after the purchase. */
    playgroundName: string | null;
    /** The total price of the order. */
    totalAmount: number;
    /** The currency for the price. */
    currency: string;
    /** The rules of the article. */
    rules: string;
    /** The number of entrances the serial ticket will provide. */
    numberOfEntrances: number;
    /** The start and end date of the serial ticket. */
    period: SerialTicketValidPeriodModel;
    /** The order lines. */
    lines: SerialTicketOrderSummaryLineModel[];
}

/** A single order line in the summary model. */
export class SerialTicketOrderSummaryLineModel implements ISerialTicketOrderSummaryLineModel {
    /** The id of the article for the line. */
    articleId!: number;
    /** The name of the article for the line. */
    articleName!: string;
    /** The quantity ordered. */
    quantity!: number;
    /** The total amount for the line. */
    amount!: number;

    constructor(data?: ISerialTicketOrderSummaryLineModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
        }
    }

    static fromJS(data: any): SerialTicketOrderSummaryLineModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketOrderSummaryLineModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        return data;
    }
}

/** A single order line in the summary model. */
export interface ISerialTicketOrderSummaryLineModel {
    /** The id of the article for the line. */
    articleId: number;
    /** The name of the article for the line. */
    articleName: string;
    /** The quantity ordered. */
    quantity: number;
    /** The total amount for the line. */
    amount: number;
}

/** Redeem order summary model. */
export class SerialTicketRedeemOrderSummaryModel implements ISerialTicketRedeemOrderSummaryModel {
    /** The article id in the order. */
    articleId!: number;
    /** The name of the article in the order. */
    articleName!: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName!: string;
    /** The total price of the order. */
    totalAmount!: number;
    /** The currency for the price. */
    currency!: string;
    /** The rules of the article. */
    rules!: string;
    /** The number of entrances the serial ticket will provide. */
    numberOfEntrances!: number;
    /** The start and end date of the serial ticket. */
    period!: SerialTicketValidPeriodModel;
    /** The order lines. */
    lines!: SerialTicketOrderSummaryLineModel[];

    constructor(data?: ISerialTicketRedeemOrderSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.period = new SerialTicketValidPeriodModel();
            this.lines = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articleId = _data["articleId"] !== undefined ? _data["articleId"] : null as any;
            this.articleName = _data["articleName"] !== undefined ? _data["articleName"] : null as any;
            this.companyName = _data["companyName"] !== undefined ? _data["companyName"] : null as any;
            this.totalAmount = _data["totalAmount"] !== undefined ? _data["totalAmount"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : null as any;
            this.numberOfEntrances = _data["numberOfEntrances"] !== undefined ? _data["numberOfEntrances"] : null as any;
            this.period = _data["period"] ? SerialTicketValidPeriodModel.fromJS(_data["period"]) : new SerialTicketValidPeriodModel();
            if (Array.isArray(_data["lines"])) {
                this.lines = [] as any;
                for (let item of _data["lines"])
                    this.lines!.push(SerialTicketOrderSummaryLineModel.fromJS(item));
            }
            else {
                this.lines = null as any;
            }
        }
    }

    static fromJS(data: any): SerialTicketRedeemOrderSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketRedeemOrderSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articleId"] = this.articleId !== undefined ? this.articleId : null as any;
        data["articleName"] = this.articleName !== undefined ? this.articleName : null as any;
        data["companyName"] = this.companyName !== undefined ? this.companyName : null as any;
        data["totalAmount"] = this.totalAmount !== undefined ? this.totalAmount : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["rules"] = this.rules !== undefined ? this.rules : null as any;
        data["numberOfEntrances"] = this.numberOfEntrances !== undefined ? this.numberOfEntrances : null as any;
        data["period"] = this.period ? this.period.toJSON() : null as any;
        if (Array.isArray(this.lines)) {
            data["lines"] = [];
            for (let item of this.lines)
                data["lines"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** Redeem order summary model. */
export interface ISerialTicketRedeemOrderSummaryModel {
    /** The article id in the order. */
    articleId: number;
    /** The name of the article in the order. */
    articleName: string;
    /** The name of the company, e.g. "Leo's Lekland". */
    companyName: string;
    /** The total price of the order. */
    totalAmount: number;
    /** The currency for the price. */
    currency: string;
    /** The rules of the article. */
    rules: string;
    /** The number of entrances the serial ticket will provide. */
    numberOfEntrances: number;
    /** The start and end date of the serial ticket. */
    period: SerialTicketValidPeriodModel;
    /** The order lines. */
    lines: SerialTicketOrderSummaryLineModel[];
}

/** Properties for an articles valid period. */
export class SerialTicketValidPeriodModel implements ISerialTicketValidPeriodModel {
    /** The start of the period. */
    start!: Date;
    /** The end of the period. */
    end!: Date;

    constructor(data?: ISerialTicketValidPeriodModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? new Date(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SerialTicketValidPeriodModel {
        data = typeof data === 'object' ? data : {};
        let result = new SerialTicketValidPeriodModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        return data;
    }
}

/** Properties for an articles valid period. */
export interface ISerialTicketValidPeriodModel {
    /** The start of the period. */
    start: Date;
    /** The end of the period. */
    end: Date;
}

/** A subscription for a child. */
export class PeriodSubscriptionDto implements IPeriodSubscriptionDto {
    /** The id of the subscription. */
    guid!: string;
    /** The name of the subscription, e.g. "Annual". */
    name!: string;
    /** The validity period for the subscription. */
    period!: PassPeriodDto;
    /** Information about the child that the subscription is for. */
    child!: PeriodSubscriptionPeriodSubscriptionChildDto;
    /** The current state of the subscription. */
    state!: PeriodSubscriptionState;
    /** The code for the QR code generator. */
    code!: string;
    /** True if a photo can be uploaded for the pass. */
    canUploadPhoto!: boolean;

    constructor(data?: IPeriodSubscriptionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.period = new PassPeriodDto();
            this.child = new PeriodSubscriptionPeriodSubscriptionChildDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.period = _data["period"] ? PassPeriodDto.fromJS(_data["period"]) : new PassPeriodDto();
            this.child = _data["child"] ? PeriodSubscriptionPeriodSubscriptionChildDto.fromJS(_data["child"]) : new PeriodSubscriptionPeriodSubscriptionChildDto();
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.canUploadPhoto = _data["canUploadPhoto"] !== undefined ? _data["canUploadPhoto"] : null as any;
        }
    }

    static fromJS(data: any): PeriodSubscriptionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodSubscriptionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["period"] = this.period ? this.period.toJSON() : null as any;
        data["child"] = this.child ? this.child.toJSON() : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["canUploadPhoto"] = this.canUploadPhoto !== undefined ? this.canUploadPhoto : null as any;
        return data;
    }
}

/** A subscription for a child. */
export interface IPeriodSubscriptionDto {
    /** The id of the subscription. */
    guid: string;
    /** The name of the subscription, e.g. "Annual". */
    name: string;
    /** The validity period for the subscription. */
    period: PassPeriodDto;
    /** Information about the child that the subscription is for. */
    child: PeriodSubscriptionPeriodSubscriptionChildDto;
    /** The current state of the subscription. */
    state: PeriodSubscriptionState;
    /** The code for the QR code generator. */
    code: string;
    /** True if a photo can be uploaded for the pass. */
    canUploadPhoto: boolean;
}

/** Child information for a Leo.Application.Subscriptions.Queries.Models.PeriodSubscriptionDto. */
export class PeriodSubscriptionPeriodSubscriptionChildDto implements IPeriodSubscriptionPeriodSubscriptionChildDto {
    /** The id of the child. */
    guid!: string;
    /** The first name of the child. */
    firstName!: string;
    /** The last name of the child, may be null. */
    lastName!: string | null;

    constructor(data?: IPeriodSubscriptionPeriodSubscriptionChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static fromJS(data: any): PeriodSubscriptionPeriodSubscriptionChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new PeriodSubscriptionPeriodSubscriptionChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        return data;
    }
}

/** Child information for a Leo.Application.Subscriptions.Queries.Models.PeriodSubscriptionDto. */
export interface IPeriodSubscriptionPeriodSubscriptionChildDto {
    /** The id of the child. */
    guid: string;
    /** The first name of the child. */
    firstName: string;
    /** The last name of the child, may be null. */
    lastName: string | null;
}

/** The different states that a Leo.Application.Subscriptions.Queries.Models.PeriodSubscriptionDto can be in. */
export enum PeriodSubscriptionState {
    Active = "Active",
    Upcoming = "Upcoming",
    Expired = "Expired",
}

/** Create a new child class booking. */
export class CreateChildClassBookingCommand implements ICreateChildClassBookingCommand {
    childClassAgeGroupId!: number;
    email!: string;
    parentFirstName!: string;
    parentLastName!: string;
    /** The phone number, without the country code. */
    phone!: string;
    /** The phone country code. */
    phoneCountryCode!: number;
    /** GDPR If the users disallow notifications on emails and sms for newsletters, offers.
IMPORTANT: Will be ignored if the currently authenticated user is an administrator, if the user exists the setting will be kept
unchanged and if the user is not registered since earlier the value "true" will be used. */
    gdprDisallowInformation!: boolean;
    /** GDPR If the users allow notifications on emails and sms for newsletters from partners, offers.
IMPORTANT: Will be ignored if the currently authenticated user is an administrator, if the user exists the setting will be kept */
    gdprAllowPartnerInformation!: boolean;
    childFirstName!: string;
    childLastName!: string;
    childBirthdate!: Date;
    allergies!: string | null;
    otherInformation!: string | null;
    tshirtSize!: string | null;

    constructor(data?: ICreateChildClassBookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.childClassAgeGroupId = _data["childClassAgeGroupId"] !== undefined ? _data["childClassAgeGroupId"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.parentFirstName = _data["parentFirstName"] !== undefined ? _data["parentFirstName"] : null as any;
            this.parentLastName = _data["parentLastName"] !== undefined ? _data["parentLastName"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.phoneCountryCode = _data["phoneCountryCode"] !== undefined ? _data["phoneCountryCode"] : null as any;
            this.gdprDisallowInformation = _data["gdprDisallowInformation"] !== undefined ? _data["gdprDisallowInformation"] : null as any;
            this.gdprAllowPartnerInformation = _data["gdprAllowPartnerInformation"] !== undefined ? _data["gdprAllowPartnerInformation"] : null as any;
            this.childFirstName = _data["childFirstName"] !== undefined ? _data["childFirstName"] : null as any;
            this.childLastName = _data["childLastName"] !== undefined ? _data["childLastName"] : null as any;
            this.childBirthdate = _data["childBirthdate"] ? new Date(_data["childBirthdate"].toString()) : null as any;
            this.allergies = _data["allergies"] !== undefined ? _data["allergies"] : null as any;
            this.otherInformation = _data["otherInformation"] !== undefined ? _data["otherInformation"] : null as any;
            this.tshirtSize = _data["tshirtSize"] !== undefined ? _data["tshirtSize"] : null as any;
        }
    }

    static fromJS(data: any): CreateChildClassBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildClassBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["childClassAgeGroupId"] = this.childClassAgeGroupId !== undefined ? this.childClassAgeGroupId : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["parentFirstName"] = this.parentFirstName !== undefined ? this.parentFirstName : null as any;
        data["parentLastName"] = this.parentLastName !== undefined ? this.parentLastName : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["phoneCountryCode"] = this.phoneCountryCode !== undefined ? this.phoneCountryCode : null as any;
        data["gdprDisallowInformation"] = this.gdprDisallowInformation !== undefined ? this.gdprDisallowInformation : null as any;
        data["gdprAllowPartnerInformation"] = this.gdprAllowPartnerInformation !== undefined ? this.gdprAllowPartnerInformation : null as any;
        data["childFirstName"] = this.childFirstName !== undefined ? this.childFirstName : null as any;
        data["childLastName"] = this.childLastName !== undefined ? this.childLastName : null as any;
        data["childBirthdate"] = this.childBirthdate ? this.childBirthdate.toISOString() : null as any;
        data["allergies"] = this.allergies !== undefined ? this.allergies : null as any;
        data["otherInformation"] = this.otherInformation !== undefined ? this.otherInformation : null as any;
        data["tshirtSize"] = this.tshirtSize !== undefined ? this.tshirtSize : null as any;
        return data;
    }
}

/** Create a new child class booking. */
export interface ICreateChildClassBookingCommand {
    childClassAgeGroupId: number;
    email: string;
    parentFirstName: string;
    parentLastName: string;
    /** The phone number, without the country code. */
    phone: string;
    /** The phone country code. */
    phoneCountryCode: number;
    /** GDPR If the users disallow notifications on emails and sms for newsletters, offers.
IMPORTANT: Will be ignored if the currently authenticated user is an administrator, if the user exists the setting will be kept
unchanged and if the user is not registered since earlier the value "true" will be used. */
    gdprDisallowInformation: boolean;
    /** GDPR If the users allow notifications on emails and sms for newsletters from partners, offers.
IMPORTANT: Will be ignored if the currently authenticated user is an administrator, if the user exists the setting will be kept */
    gdprAllowPartnerInformation: boolean;
    childFirstName: string;
    childLastName: string;
    childBirthdate: Date;
    allergies: string | null;
    otherInformation: string | null;
    tshirtSize: string | null;
}

/** Response after creating a new booking. */
export class CreateChildClassBookingResultDto implements ICreateChildClassBookingResultDto {
    guid!: string;
    orderReference!: string;

    constructor(data?: ICreateChildClassBookingResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.orderReference = _data["orderReference"] !== undefined ? _data["orderReference"] : null as any;
        }
    }

    static fromJS(data: any): CreateChildClassBookingResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildClassBookingResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["orderReference"] = this.orderReference !== undefined ? this.orderReference : null as any;
        return data;
    }
}

/** Response after creating a new booking. */
export interface ICreateChildClassBookingResultDto {
    guid: string;
    orderReference: string;
}

/** Possible crop options when resizing an image. */
export enum ImageCropOptions {
    Cover = "Cover",
    Contain = "Contain",
    Resize = "Resize",
    Fill = "Fill",
}

/** Party location configuration values. */
export class PartyLocationConfigurationDto implements IPartyLocationConfigurationDto {
    partyEnableChoosePlayTime!: boolean;
    partyLengthMinutes!: number | null;

    constructor(data?: IPartyLocationConfigurationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partyEnableChoosePlayTime = _data["partyEnableChoosePlayTime"] !== undefined ? _data["partyEnableChoosePlayTime"] : null as any;
            this.partyLengthMinutes = _data["partyLengthMinutes"] !== undefined ? _data["partyLengthMinutes"] : null as any;
        }
    }

    static fromJS(data: any): PartyLocationConfigurationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyLocationConfigurationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partyEnableChoosePlayTime"] = this.partyEnableChoosePlayTime !== undefined ? this.partyEnableChoosePlayTime : null as any;
        data["partyLengthMinutes"] = this.partyLengthMinutes !== undefined ? this.partyLengthMinutes : null as any;
        return data;
    }
}

/** Party location configuration values. */
export interface IPartyLocationConfigurationDto {
    partyEnableChoosePlayTime: boolean;
    partyLengthMinutes: number | null;
}

export enum ChangeEntranceBookingV2CommandValidatorErrorCodes {
    NotChangeable = "NotChangeable",
}

/** A command request for cancelling a party booking. */
export class CancelPartyBookingCommand implements ICancelPartyBookingCommand {
    /** The id of the booking to cancel */
    guid!: string;
    /** The message to send to the booker after cancellation. */
    bookerMessage!: string | null;
    /** The message to send to the guests after cancellation. */
    guestMessage!: string | null;
    /** The reason for the cancellation. */
    reason!: string | null;

    constructor(data?: ICancelPartyBookingCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.bookerMessage = _data["bookerMessage"] !== undefined ? _data["bookerMessage"] : null as any;
            this.guestMessage = _data["guestMessage"] !== undefined ? _data["guestMessage"] : null as any;
            this.reason = _data["reason"] !== undefined ? _data["reason"] : null as any;
        }
    }

    static fromJS(data: any): CancelPartyBookingCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CancelPartyBookingCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["bookerMessage"] = this.bookerMessage !== undefined ? this.bookerMessage : null as any;
        data["guestMessage"] = this.guestMessage !== undefined ? this.guestMessage : null as any;
        data["reason"] = this.reason !== undefined ? this.reason : null as any;
        return data;
    }
}

/** A command request for cancelling a party booking. */
export interface ICancelPartyBookingCommand {
    /** The id of the booking to cancel */
    guid: string;
    /** The message to send to the booker after cancellation. */
    bookerMessage: string | null;
    /** The message to send to the guests after cancellation. */
    guestMessage: string | null;
    /** The reason for the cancellation. */
    reason: string | null;
}

/** The type of a time interval */
export enum IntervalType {
    Play = "Play",
    Party = "Party",
}

/** One alternative for play and party time distribution */
export class PartyBookingPlayTime implements IPartyBookingPlayTime {
    /** A list of play and party times */
    timeIntervals!: TimeInterval[];
    /** The arrival time for the party if this play time is chosen */
    readonly arrivalTime!: string;
    /** True if this distribution of play and party times are within the opening hours of the playground */
    available!: boolean;

    constructor(data?: IPartyBookingPlayTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timeIntervals"])) {
                this.timeIntervals = [] as any;
                for (let item of _data["timeIntervals"])
                    this.timeIntervals!.push(TimeInterval.fromJS(item));
            }
            else {
                this.timeIntervals = null as any;
            }
            (this as any).arrivalTime = _data["arrivalTime"] !== undefined ? _data["arrivalTime"] : null as any;
            this.available = _data["available"] !== undefined ? _data["available"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingPlayTime {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingPlayTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timeIntervals)) {
            data["timeIntervals"] = [];
            for (let item of this.timeIntervals)
                data["timeIntervals"].push(item ? item.toJSON() : null as any);
        }
        data["arrivalTime"] = this.arrivalTime !== undefined ? this.arrivalTime : null as any;
        data["available"] = this.available !== undefined ? this.available : null as any;
        return data;
    }
}

/** One alternative for play and party time distribution */
export interface IPartyBookingPlayTime {
    /** A list of play and party times */
    timeIntervals: TimeInterval[];
    /** The arrival time for the party if this play time is chosen */
    arrivalTime: string;
    /** True if this distribution of play and party times are within the opening hours of the playground */
    available: boolean;
}

/** One interval of time that is either play time or party time */
export class TimeInterval implements ITimeInterval {
    /** The start time of the interval */
    start!: string;
    /** The end time of the interval */
    end!: string;
    /** The type of the interval */
    type!: IntervalType;
    readonly displayStart!: string;
    readonly displayEnd!: string;

    constructor(data?: ITimeInterval) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] !== undefined ? _data["start"] : null as any;
            this.end = _data["end"] !== undefined ? _data["end"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            (this as any).displayStart = _data["displayStart"] !== undefined ? _data["displayStart"] : null as any;
            (this as any).displayEnd = _data["displayEnd"] !== undefined ? _data["displayEnd"] : null as any;
        }
    }

    static fromJS(data: any): TimeInterval {
        data = typeof data === 'object' ? data : {};
        let result = new TimeInterval();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start !== undefined ? this.start : null as any;
        data["end"] = this.end !== undefined ? this.end : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["displayStart"] = this.displayStart !== undefined ? this.displayStart : null as any;
        data["displayEnd"] = this.displayEnd !== undefined ? this.displayEnd : null as any;
        return data;
    }
}

/** One interval of time that is either play time or party time */
export interface ITimeInterval {
    /** The start time of the interval */
    start: string;
    /** The end time of the interval */
    end: string;
    /** The type of the interval */
    type: IntervalType;
    displayStart: string;
    displayEnd: string;
}

/** A purchase event that can be tracked in Google Analytics. */
export class ShopPurchaseEvent implements IShopPurchaseEvent {
    /** The event name. */
    event!: string;
    /** The event affiliation. */
    readonly transactionAffiliation!: string;
    /** The order reference. */
    transactionId!: string;
    /** The order total, including tax. */
    transactionTotal!: number;
    /** The currency of the transaction. */
    transactionCurrency!: string;
    /** The products for the order. */
    transactionProducts!: ShopPurchaseEventProduct[];

    constructor(data?: IShopPurchaseEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.transactionProducts = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.event = _data["event"] !== undefined ? _data["event"] : null as any;
            (this as any).transactionAffiliation = _data["transactionAffiliation"] !== undefined ? _data["transactionAffiliation"] : null as any;
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.transactionTotal = _data["transactionTotal"] !== undefined ? _data["transactionTotal"] : null as any;
            this.transactionCurrency = _data["transactionCurrency"] !== undefined ? _data["transactionCurrency"] : null as any;
            if (Array.isArray(_data["transactionProducts"])) {
                this.transactionProducts = [] as any;
                for (let item of _data["transactionProducts"])
                    this.transactionProducts!.push(ShopPurchaseEventProduct.fromJS(item));
            }
            else {
                this.transactionProducts = null as any;
            }
        }
    }

    static fromJS(data: any): ShopPurchaseEvent {
        data = typeof data === 'object' ? data : {};
        let result = new ShopPurchaseEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event !== undefined ? this.event : null as any;
        data["transactionAffiliation"] = this.transactionAffiliation !== undefined ? this.transactionAffiliation : null as any;
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["transactionTotal"] = this.transactionTotal !== undefined ? this.transactionTotal : null as any;
        data["transactionCurrency"] = this.transactionCurrency !== undefined ? this.transactionCurrency : null as any;
        if (Array.isArray(this.transactionProducts)) {
            data["transactionProducts"] = [];
            for (let item of this.transactionProducts)
                data["transactionProducts"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

/** A purchase event that can be tracked in Google Analytics. */
export interface IShopPurchaseEvent {
    /** The event name. */
    event: string;
    /** The event affiliation. */
    transactionAffiliation: string;
    /** The order reference. */
    transactionId: string;
    /** The order total, including tax. */
    transactionTotal: number;
    /** The currency of the transaction. */
    transactionCurrency: string;
    /** The products for the order. */
    transactionProducts: ShopPurchaseEventProduct[];
}

/** A product row for Leo.BackendApi.Areas.Api.Models.Analytics.ShopPurchaseEvent. */
export class ShopPurchaseEventProduct implements IShopPurchaseEventProduct {
    /** The name of the product. */
    name!: string;
    /** The article number/sku for the product. */
    sku!: string;
    /** The category for the product. */
    category!: string;
    /** The total price for the row. */
    price!: number;
    /** The quantity for the product. */
    quantity!: number;

    constructor(data?: IShopPurchaseEventProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.sku = _data["sku"] !== undefined ? _data["sku"] : null as any;
            this.category = _data["category"] !== undefined ? _data["category"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.quantity = _data["quantity"] !== undefined ? _data["quantity"] : null as any;
        }
    }

    static fromJS(data: any): ShopPurchaseEventProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ShopPurchaseEventProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["sku"] = this.sku !== undefined ? this.sku : null as any;
        data["category"] = this.category !== undefined ? this.category : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["quantity"] = this.quantity !== undefined ? this.quantity : null as any;
        return data;
    }
}

/** A product row for Leo.BackendApi.Areas.Api.Models.Analytics.ShopPurchaseEvent. */
export interface IShopPurchaseEventProduct {
    /** The name of the product. */
    name: string;
    /** The article number/sku for the product. */
    sku: string;
    /** The category for the product. */
    category: string;
    /** The total price for the row. */
    price: number;
    /** The quantity for the product. */
    quantity: number;
}

/** Model for adding a new child to the system. */
export class CreateChildModel implements ICreateChildModel {
    firstName!: string;
    lastName!: string | null;
    birthDate!: Date;

    constructor(data?: ICreateChildModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): CreateChildModel {
        data = typeof data === 'object' ? data : {};
        let result = new CreateChildModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        return data;
    }
}

/** Model for adding a new child to the system. */
export interface ICreateChildModel {
    firstName: string;
    lastName: string | null;
    birthDate: Date;
}

export class ApplicationUserDto implements IApplicationUserDto {
    guid!: string | null;
    username!: string | null;
    email!: string | null;
    emailconfirmed!: boolean;
    firstname!: string | null;
    lastname!: string | null;
    /** The country code for the phone.
E.g. 46 for Sweden.
Will be 0 if no phone number could be parsed for the user. */
    countrycode!: number;
    /** The phone or the user, without the country code.
E.g. "720000000" */
    phone!: string | null;
    /** True if the Leo.BackendApi.Areas.Api.Models.Dto.ApplicationUserDto.Phone has been confirmed to belong to the user. */
    phoneconfirmed!: boolean;
    comment!: string | null;
    culture!: string | null;
    memberid!: string | null;
    membercardid!: string | null;
    gdprallowinformation!: boolean;
    gdprallowsms!: boolean;
    gdprallowpartnerinformation!: boolean;
    gdprallowpartnersms!: boolean;
    npsallowcommunication!: boolean;
    preferredplaycenterid!: string | null;
    roles!: string[] | null;

    constructor(data?: IApplicationUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.username = _data["username"] !== undefined ? _data["username"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.emailconfirmed = _data["emailconfirmed"] !== undefined ? _data["emailconfirmed"] : null as any;
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.countrycode = _data["countrycode"] !== undefined ? _data["countrycode"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.phoneconfirmed = _data["phoneconfirmed"] !== undefined ? _data["phoneconfirmed"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : null as any;
            this.memberid = _data["memberid"] !== undefined ? _data["memberid"] : null as any;
            this.membercardid = _data["membercardid"] !== undefined ? _data["membercardid"] : null as any;
            this.gdprallowinformation = _data["gdprallowinformation"] !== undefined ? _data["gdprallowinformation"] : null as any;
            this.gdprallowsms = _data["gdprallowsms"] !== undefined ? _data["gdprallowsms"] : null as any;
            this.gdprallowpartnerinformation = _data["gdprallowpartnerinformation"] !== undefined ? _data["gdprallowpartnerinformation"] : null as any;
            this.gdprallowpartnersms = _data["gdprallowpartnersms"] !== undefined ? _data["gdprallowpartnersms"] : null as any;
            this.npsallowcommunication = _data["npsallowcommunication"] !== undefined ? _data["npsallowcommunication"] : null as any;
            this.preferredplaycenterid = _data["preferredplaycenterid"] !== undefined ? _data["preferredplaycenterid"] : null as any;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = null as any;
            }
        }
    }

    static fromJS(data: any): ApplicationUserDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["username"] = this.username !== undefined ? this.username : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["emailconfirmed"] = this.emailconfirmed !== undefined ? this.emailconfirmed : null as any;
        data["firstname"] = this.firstname !== undefined ? this.firstname : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["countrycode"] = this.countrycode !== undefined ? this.countrycode : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["phoneconfirmed"] = this.phoneconfirmed !== undefined ? this.phoneconfirmed : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["culture"] = this.culture !== undefined ? this.culture : null as any;
        data["memberid"] = this.memberid !== undefined ? this.memberid : null as any;
        data["membercardid"] = this.membercardid !== undefined ? this.membercardid : null as any;
        data["gdprallowinformation"] = this.gdprallowinformation !== undefined ? this.gdprallowinformation : null as any;
        data["gdprallowsms"] = this.gdprallowsms !== undefined ? this.gdprallowsms : null as any;
        data["gdprallowpartnerinformation"] = this.gdprallowpartnerinformation !== undefined ? this.gdprallowpartnerinformation : null as any;
        data["gdprallowpartnersms"] = this.gdprallowpartnersms !== undefined ? this.gdprallowpartnersms : null as any;
        data["npsallowcommunication"] = this.npsallowcommunication !== undefined ? this.npsallowcommunication : null as any;
        data["preferredplaycenterid"] = this.preferredplaycenterid !== undefined ? this.preferredplaycenterid : null as any;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IApplicationUserDto {
    guid: string | null;
    username: string | null;
    email: string | null;
    emailconfirmed: boolean;
    firstname: string | null;
    lastname: string | null;
    /** The country code for the phone.
E.g. 46 for Sweden.
Will be 0 if no phone number could be parsed for the user. */
    countrycode: number;
    /** The phone or the user, without the country code.
E.g. "720000000" */
    phone: string | null;
    /** True if the Leo.BackendApi.Areas.Api.Models.Dto.ApplicationUserDto.Phone has been confirmed to belong to the user. */
    phoneconfirmed: boolean;
    comment: string | null;
    culture: string | null;
    memberid: string | null;
    membercardid: string | null;
    gdprallowinformation: boolean;
    gdprallowsms: boolean;
    gdprallowpartnerinformation: boolean;
    gdprallowpartnersms: boolean;
    npsallowcommunication: boolean;
    preferredplaycenterid: string | null;
    roles: string[] | null;
}

export class AreaDto implements IAreaDto {
    name!: string | null;
    guid!: string | null;
    areatype!: string | null;
    playground!: PlaygroundDto | null;
    playgroundid!: string | null;
    rooms!: RoomDto[] | null;

    constructor(data?: IAreaDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.areatype = _data["areatype"] !== undefined ? _data["areatype"] : null as any;
            this.playground = _data["playground"] ? PlaygroundDto.fromJS(_data["playground"]) : null as any;
            this.playgroundid = _data["playgroundid"] !== undefined ? _data["playgroundid"] : null as any;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(RoomDto.fromJS(item));
            }
            else {
                this.rooms = null as any;
            }
        }
    }

    static fromJS(data: any): AreaDto {
        data = typeof data === 'object' ? data : {};
        let result = new AreaDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["areatype"] = this.areatype !== undefined ? this.areatype : null as any;
        data["playground"] = this.playground ? this.playground.toJSON() : null as any;
        data["playgroundid"] = this.playgroundid !== undefined ? this.playgroundid : null as any;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IAreaDto {
    name: string | null;
    guid: string | null;
    areatype: string | null;
    playground: PlaygroundDto | null;
    playgroundid: string | null;
    rooms: RoomDto[] | null;
}

export class BookingArticleDto implements IBookingArticleDto {
    originalarticleid!: string | null;
    name!: string | null;
    packagearticleguid!: string;
    guid!: string;
    artno!: string | null;
    itemtype!: string | null;
    amount!: number;
    price!: number;
    fixedamount!: number | null;

    constructor(data?: IBookingArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.originalarticleid = _data["originalarticleid"] !== undefined ? _data["originalarticleid"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.packagearticleguid = _data["packagearticleguid"] !== undefined ? _data["packagearticleguid"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.artno = _data["artno"] !== undefined ? _data["artno"] : null as any;
            this.itemtype = _data["itemtype"] !== undefined ? _data["itemtype"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.fixedamount = _data["fixedamount"] !== undefined ? _data["fixedamount"] : null as any;
        }
    }

    static fromJS(data: any): BookingArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["originalarticleid"] = this.originalarticleid !== undefined ? this.originalarticleid : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["packagearticleguid"] = this.packagearticleguid !== undefined ? this.packagearticleguid : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["artno"] = this.artno !== undefined ? this.artno : null as any;
        data["itemtype"] = this.itemtype !== undefined ? this.itemtype : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["fixedamount"] = this.fixedamount !== undefined ? this.fixedamount : null as any;
        return data;
    }
}

export interface IBookingArticleDto {
    originalarticleid: string | null;
    name: string | null;
    packagearticleguid: string;
    guid: string;
    artno: string | null;
    itemtype: string | null;
    amount: number;
    price: number;
    fixedamount: number | null;
}

export class BookingArticlesPriceDto implements IBookingArticlesPriceDto {
    pricevalue!: number | null;
    currency!: string | null;

    constructor(data?: IBookingArticlesPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricevalue = _data["pricevalue"] !== undefined ? _data["pricevalue"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
        }
    }

    static fromJS(data: any): BookingArticlesPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingArticlesPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricevalue"] = this.pricevalue !== undefined ? this.pricevalue : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        return data;
    }
}

export interface IBookingArticlesPriceDto {
    pricevalue: number | null;
    currency: string | null;
}

export class BookingArticlesRequestDto implements IBookingArticlesRequestDto {
    selectedarticles!: string[] | null;
    bookingguid!: string;

    constructor(data?: IBookingArticlesRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["selectedarticles"])) {
                this.selectedarticles = [] as any;
                for (let item of _data["selectedarticles"])
                    this.selectedarticles!.push(item);
            }
            else {
                this.selectedarticles = null as any;
            }
            this.bookingguid = _data["bookingguid"] !== undefined ? _data["bookingguid"] : null as any;
        }
    }

    static fromJS(data: any): BookingArticlesRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingArticlesRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.selectedarticles)) {
            data["selectedarticles"] = [];
            for (let item of this.selectedarticles)
                data["selectedarticles"].push(item);
        }
        data["bookingguid"] = this.bookingguid !== undefined ? this.bookingguid : null as any;
        return data;
    }
}

export interface IBookingArticlesRequestDto {
    selectedarticles: string[] | null;
    bookingguid: string;
}

export class BookingArticlesResponseDto implements IBookingArticlesResponseDto {
    price!: BookingArticlesPriceDto | null;
    bookingarticles!: BookingArticleDto[] | null;
    bookingguid!: string;

    constructor(data?: IBookingArticlesResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.price = _data["price"] ? BookingArticlesPriceDto.fromJS(_data["price"]) : null as any;
            if (Array.isArray(_data["bookingarticles"])) {
                this.bookingarticles = [] as any;
                for (let item of _data["bookingarticles"])
                    this.bookingarticles!.push(BookingArticleDto.fromJS(item));
            }
            else {
                this.bookingarticles = null as any;
            }
            this.bookingguid = _data["bookingguid"] !== undefined ? _data["bookingguid"] : null as any;
        }
    }

    static fromJS(data: any): BookingArticlesResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new BookingArticlesResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["price"] = this.price ? this.price.toJSON() : null as any;
        if (Array.isArray(this.bookingarticles)) {
            data["bookingarticles"] = [];
            for (let item of this.bookingarticles)
                data["bookingarticles"].push(item ? item.toJSON() : null as any);
        }
        data["bookingguid"] = this.bookingguid !== undefined ? this.bookingguid : null as any;
        return data;
    }
}

export interface IBookingArticlesResponseDto {
    price: BookingArticlesPriceDto | null;
    bookingarticles: BookingArticleDto[] | null;
    bookingguid: string;
}

/** A DTO for Leo.Database.Entities.Invitation.InvitationBackground. */
export class InvitationBackgroundDto implements IInvitationBackgroundDto {
    /** The Guid of the invitation background. */
    guid!: string;
    /** The name of the invitation background. */
    name!: string | null;
    /** The image of the invitation background. */
    image!: ImageDto | null;

    constructor(data?: IInvitationBackgroundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : null as any;
        }
    }

    static fromJS(data: any): InvitationBackgroundDto {
        data = typeof data === 'object' ? data : {};
        let result = new InvitationBackgroundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["image"] = this.image ? this.image.toJSON() : null as any;
        return data;
    }
}

/** A DTO for Leo.Database.Entities.Invitation.InvitationBackground. */
export interface IInvitationBackgroundDto {
    /** The Guid of the invitation background. */
    guid: string;
    /** The name of the invitation background. */
    name: string | null;
    /** The image of the invitation background. */
    image: ImageDto | null;
}

export class InviteAnswerDto implements IInviteAnswerDto {
    invitationkey!: string | null;
    invitationid!: string;
    status!: string | null;
    message!: string | null;
    allergymessage!: string | null;

    constructor(data?: IInviteAnswerDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invitationkey = _data["invitationkey"] !== undefined ? _data["invitationkey"] : null as any;
            this.invitationid = _data["invitationid"] !== undefined ? _data["invitationid"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.allergymessage = _data["allergymessage"] !== undefined ? _data["allergymessage"] : null as any;
        }
    }

    static fromJS(data: any): InviteAnswerDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteAnswerDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invitationkey"] = this.invitationkey !== undefined ? this.invitationkey : null as any;
        data["invitationid"] = this.invitationid !== undefined ? this.invitationid : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["allergymessage"] = this.allergymessage !== undefined ? this.allergymessage : null as any;
        return data;
    }
}

export interface IInviteAnswerDto {
    invitationkey: string | null;
    invitationid: string;
    status: string | null;
    message: string | null;
    allergymessage: string | null;
}

export class InviteCreateNewDto implements IInviteCreateNewDto {
    bookingid!: string;

    constructor(data?: IInviteCreateNewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : null as any;
        }
    }

    static fromJS(data: any): InviteCreateNewDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteCreateNewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : null as any;
        return data;
    }
}

export interface IInviteCreateNewDto {
    bookingid: string;
}

export class InviteDto implements IInviteDto {
    guid!: string;
    bookingid!: string;
    status!: string | null;
    playgroundname!: string | null;
    room!: RoomDto | null;
    partydate!: string | null;
    starttime!: string | null;
    streetadress!: string | null;
    companyname!: string | null;
    invitiationkey!: string | null;
    guestmessage!: string | null;
    /** Allergy information supplied by the guest when answering an invitation. */
    guestallergymessage!: string | null;
    invitemessage!: string | null;
    guestinfo!: InviteGuestDto | null;
    host!: InviteInviterDto | null;
    userexists!: boolean;
    /** Invitation background image, selected by the booker.
Null if the booker did not select a background. */
    backgroundimage!: ImageDto | null;
    stopdate!: string | null;
    invitationmessage!: string | null;

    constructor(data?: IInviteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.playgroundname = _data["playgroundname"] !== undefined ? _data["playgroundname"] : null as any;
            this.room = _data["room"] ? RoomDto.fromJS(_data["room"]) : null as any;
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : null as any;
            this.starttime = _data["starttime"] !== undefined ? _data["starttime"] : null as any;
            this.streetadress = _data["streetadress"] !== undefined ? _data["streetadress"] : null as any;
            this.companyname = _data["companyname"] !== undefined ? _data["companyname"] : null as any;
            this.invitiationkey = _data["invitiationkey"] !== undefined ? _data["invitiationkey"] : null as any;
            this.guestmessage = _data["guestmessage"] !== undefined ? _data["guestmessage"] : null as any;
            this.guestallergymessage = _data["guestallergymessage"] !== undefined ? _data["guestallergymessage"] : null as any;
            this.invitemessage = _data["invitemessage"] !== undefined ? _data["invitemessage"] : null as any;
            this.guestinfo = _data["guestinfo"] ? InviteGuestDto.fromJS(_data["guestinfo"]) : null as any;
            this.host = _data["host"] ? InviteInviterDto.fromJS(_data["host"]) : null as any;
            this.userexists = _data["userexists"] !== undefined ? _data["userexists"] : null as any;
            this.backgroundimage = _data["backgroundimage"] ? ImageDto.fromJS(_data["backgroundimage"]) : null as any;
            this.stopdate = _data["stopdate"] !== undefined ? _data["stopdate"] : null as any;
            this.invitationmessage = _data["invitationmessage"] !== undefined ? _data["invitationmessage"] : null as any;
        }
    }

    static fromJS(data: any): InviteDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["playgroundname"] = this.playgroundname !== undefined ? this.playgroundname : null as any;
        data["room"] = this.room ? this.room.toJSON() : null as any;
        data["partydate"] = this.partydate !== undefined ? this.partydate : null as any;
        data["starttime"] = this.starttime !== undefined ? this.starttime : null as any;
        data["streetadress"] = this.streetadress !== undefined ? this.streetadress : null as any;
        data["companyname"] = this.companyname !== undefined ? this.companyname : null as any;
        data["invitiationkey"] = this.invitiationkey !== undefined ? this.invitiationkey : null as any;
        data["guestmessage"] = this.guestmessage !== undefined ? this.guestmessage : null as any;
        data["guestallergymessage"] = this.guestallergymessage !== undefined ? this.guestallergymessage : null as any;
        data["invitemessage"] = this.invitemessage !== undefined ? this.invitemessage : null as any;
        data["guestinfo"] = this.guestinfo ? this.guestinfo.toJSON() : null as any;
        data["host"] = this.host ? this.host.toJSON() : null as any;
        data["userexists"] = this.userexists !== undefined ? this.userexists : null as any;
        data["backgroundimage"] = this.backgroundimage ? this.backgroundimage.toJSON() : null as any;
        data["stopdate"] = this.stopdate !== undefined ? this.stopdate : null as any;
        data["invitationmessage"] = this.invitationmessage !== undefined ? this.invitationmessage : null as any;
        return data;
    }
}

export interface IInviteDto {
    guid: string;
    bookingid: string;
    status: string | null;
    playgroundname: string | null;
    room: RoomDto | null;
    partydate: string | null;
    starttime: string | null;
    streetadress: string | null;
    companyname: string | null;
    invitiationkey: string | null;
    guestmessage: string | null;
    /** Allergy information supplied by the guest when answering an invitation. */
    guestallergymessage: string | null;
    invitemessage: string | null;
    guestinfo: InviteGuestDto | null;
    host: InviteInviterDto | null;
    userexists: boolean;
    /** Invitation background image, selected by the booker.
Null if the booker did not select a background. */
    backgroundimage: ImageDto | null;
    stopdate: string | null;
    invitationmessage: string | null;
}

export class InviteGuestDto implements IInviteGuestDto {
    name!: string | null;
    parentname!: string | null;
    birthdayage!: number | null;
    age!: number;
    birthdaydate!: string | null;
    phonecountrycode!: number;
    phone!: string | null;
    email!: string | null;
    gender!: string | null;
    birthday!: boolean;
    /** True if the guest is one of the birthday children (may be multiple). */
    ismainguest!: boolean;
    childId!: string;

    constructor(data?: IInviteGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.parentname = _data["parentname"] !== undefined ? _data["parentname"] : null as any;
            this.birthdayage = _data["birthdayage"] !== undefined ? _data["birthdayage"] : null as any;
            this.age = _data["age"] !== undefined ? _data["age"] : null as any;
            this.birthdaydate = _data["birthdaydate"] !== undefined ? _data["birthdaydate"] : null as any;
            this.phonecountrycode = _data["phonecountrycode"] !== undefined ? _data["phonecountrycode"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            this.birthday = _data["birthday"] !== undefined ? _data["birthday"] : null as any;
            this.ismainguest = _data["ismainguest"] !== undefined ? _data["ismainguest"] : null as any;
            this.childId = _data["childId"] !== undefined ? _data["childId"] : null as any;
        }
    }

    static fromJS(data: any): InviteGuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["parentname"] = this.parentname !== undefined ? this.parentname : null as any;
        data["birthdayage"] = this.birthdayage !== undefined ? this.birthdayage : null as any;
        data["age"] = this.age !== undefined ? this.age : null as any;
        data["birthdaydate"] = this.birthdaydate !== undefined ? this.birthdaydate : null as any;
        data["phonecountrycode"] = this.phonecountrycode !== undefined ? this.phonecountrycode : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        data["birthday"] = this.birthday !== undefined ? this.birthday : null as any;
        data["ismainguest"] = this.ismainguest !== undefined ? this.ismainguest : null as any;
        data["childId"] = this.childId !== undefined ? this.childId : null as any;
        return data;
    }
}

export interface IInviteGuestDto {
    name: string | null;
    parentname: string | null;
    birthdayage: number | null;
    age: number;
    birthdaydate: string | null;
    phonecountrycode: number;
    phone: string | null;
    email: string | null;
    gender: string | null;
    birthday: boolean;
    /** True if the guest is one of the birthday children (may be multiple). */
    ismainguest: boolean;
    childId: string;
}

export class InviteInviterChildDto implements IInviteInviterChildDto {
    name!: string | null;
    age!: number | null;
    birthdayage!: number | null;

    constructor(data?: IInviteInviterChildDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.age = _data["age"] !== undefined ? _data["age"] : null as any;
            this.birthdayage = _data["birthdayage"] !== undefined ? _data["birthdayage"] : null as any;
        }
    }

    static fromJS(data: any): InviteInviterChildDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteInviterChildDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["age"] = this.age !== undefined ? this.age : null as any;
        data["birthdayage"] = this.birthdayage !== undefined ? this.birthdayage : null as any;
        return data;
    }
}

export interface IInviteInviterChildDto {
    name: string | null;
    age: number | null;
    birthdayage: number | null;
}

export class InviteInviterDto implements IInviteInviterDto {
    parentfirstname!: string | null;
    parentlastname!: string | null;
    children!: InviteInviterChildDto[] | null;

    constructor(data?: IInviteInviterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.parentfirstname = _data["parentfirstname"] !== undefined ? _data["parentfirstname"] : null as any;
            this.parentlastname = _data["parentlastname"] !== undefined ? _data["parentlastname"] : null as any;
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(InviteInviterChildDto.fromJS(item));
            }
            else {
                this.children = null as any;
            }
        }
    }

    static fromJS(data: any): InviteInviterDto {
        data = typeof data === 'object' ? data : {};
        let result = new InviteInviterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["parentfirstname"] = this.parentfirstname !== undefined ? this.parentfirstname : null as any;
        data["parentlastname"] = this.parentlastname !== undefined ? this.parentlastname : null as any;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IInviteInviterDto {
    parentfirstname: string | null;
    parentlastname: string | null;
    children: InviteInviterChildDto[] | null;
}

export class FreeDatesCollectionCampaignDto implements IFreeDatesCollectionCampaignDto {
    title!: string | null;

    constructor(data?: IFreeDatesCollectionCampaignDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
        }
    }

    static fromJS(data: any): FreeDatesCollectionCampaignDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeDatesCollectionCampaignDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        return data;
    }
}

export interface IFreeDatesCollectionCampaignDto {
    title: string | null;
}

export class FreeDatesCollectionDto implements IFreeDatesCollectionDto {
    duration!: number;
    dates!: FreeDatesCollectionFreeDateDto[] | null;

    constructor(data?: IFreeDatesCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"] !== undefined ? _data["duration"] : null as any;
            if (Array.isArray(_data["dates"])) {
                this.dates = [] as any;
                for (let item of _data["dates"])
                    this.dates!.push(FreeDatesCollectionFreeDateDto.fromJS(item));
            }
            else {
                this.dates = null as any;
            }
        }
    }

    static fromJS(data: any): FreeDatesCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeDatesCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration !== undefined ? this.duration : null as any;
        if (Array.isArray(this.dates)) {
            data["dates"] = [];
            for (let item of this.dates)
                data["dates"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFreeDatesCollectionDto {
    duration: number;
    dates: FreeDatesCollectionFreeDateDto[] | null;
}

export class FreeDatesCollectionFreeDateDto implements IFreeDatesCollectionFreeDateDto {
    date!: string | null;
    rooms!: FreeDatesCollectionFreeRoomDto[] | null;
    campaigns!: FreeDatesCollectionCampaignDto[] | null;

    constructor(data?: IFreeDatesCollectionFreeDateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] !== undefined ? _data["date"] : null as any;
            if (Array.isArray(_data["rooms"])) {
                this.rooms = [] as any;
                for (let item of _data["rooms"])
                    this.rooms!.push(FreeDatesCollectionFreeRoomDto.fromJS(item));
            }
            else {
                this.rooms = null as any;
            }
            if (Array.isArray(_data["campaigns"])) {
                this.campaigns = [] as any;
                for (let item of _data["campaigns"])
                    this.campaigns!.push(FreeDatesCollectionCampaignDto.fromJS(item));
            }
            else {
                this.campaigns = null as any;
            }
        }
    }

    static fromJS(data: any): FreeDatesCollectionFreeDateDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeDatesCollectionFreeDateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date !== undefined ? this.date : null as any;
        if (Array.isArray(this.rooms)) {
            data["rooms"] = [];
            for (let item of this.rooms)
                data["rooms"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.campaigns)) {
            data["campaigns"] = [];
            for (let item of this.campaigns)
                data["campaigns"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFreeDatesCollectionFreeDateDto {
    date: string | null;
    rooms: FreeDatesCollectionFreeRoomDto[] | null;
    campaigns: FreeDatesCollectionCampaignDto[] | null;
}

export class FreeDatesCollectionFreeRoomDto implements IFreeDatesCollectionFreeRoomDto {
    name!: string | null;
    guid!: string;
    timeslots!: TimeSlotDto[] | null;

    constructor(data?: IFreeDatesCollectionFreeRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            if (Array.isArray(_data["timeslots"])) {
                this.timeslots = [] as any;
                for (let item of _data["timeslots"])
                    this.timeslots!.push(TimeSlotDto.fromJS(item));
            }
            else {
                this.timeslots = null as any;
            }
        }
    }

    static fromJS(data: any): FreeDatesCollectionFreeRoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new FreeDatesCollectionFreeRoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        if (Array.isArray(this.timeslots)) {
            data["timeslots"] = [];
            for (let item of this.timeslots)
                data["timeslots"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IFreeDatesCollectionFreeRoomDto {
    name: string | null;
    guid: string;
    timeslots: TimeSlotDto[] | null;
}

/** Unconfirmed article changes on a booking. These will replace the current package and articles when the changes are confirmed. */
export class PartyBookingChangeArticleChangesDto implements IPartyBookingChangeArticleChangesDto {
    /** List of new booking articles. */
    bookingarticles!: BookingArticleDto[] | null;
    /** Guid of the new party package. */
    packageguid!: string;
    /** Name of the new party package. */
    packagename!: string | null;

    constructor(data?: IPartyBookingChangeArticleChangesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bookingarticles"])) {
                this.bookingarticles = [] as any;
                for (let item of _data["bookingarticles"])
                    this.bookingarticles!.push(BookingArticleDto.fromJS(item));
            }
            else {
                this.bookingarticles = null as any;
            }
            this.packageguid = _data["packageguid"] !== undefined ? _data["packageguid"] : null as any;
            this.packagename = _data["packagename"] !== undefined ? _data["packagename"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingChangeArticleChangesDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingChangeArticleChangesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bookingarticles)) {
            data["bookingarticles"] = [];
            for (let item of this.bookingarticles)
                data["bookingarticles"].push(item ? item.toJSON() : null as any);
        }
        data["packageguid"] = this.packageguid !== undefined ? this.packageguid : null as any;
        data["packagename"] = this.packagename !== undefined ? this.packagename : null as any;
        return data;
    }
}

/** Unconfirmed article changes on a booking. These will replace the current package and articles when the changes are confirmed. */
export interface IPartyBookingChangeArticleChangesDto {
    /** List of new booking articles. */
    bookingarticles: BookingArticleDto[] | null;
    /** Guid of the new party package. */
    packageguid: string;
    /** Name of the new party package. */
    packagename: string | null;
}

export class PartyBookingChangeBackgroundDto implements IPartyBookingChangeBackgroundDto {
    guid!: string;
    imageid!: string;
    stopdate!: string | null;
    invitationmessage!: string | null;
    staffmessage!: string | null;
    allergymessage!: string | null;
    invitemessage!: string | null;

    constructor(data?: IPartyBookingChangeBackgroundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.imageid = _data["imageid"] !== undefined ? _data["imageid"] : null as any;
            this.stopdate = _data["stopdate"] !== undefined ? _data["stopdate"] : null as any;
            this.invitationmessage = _data["invitationmessage"] !== undefined ? _data["invitationmessage"] : null as any;
            this.staffmessage = _data["staffmessage"] !== undefined ? _data["staffmessage"] : null as any;
            this.allergymessage = _data["allergymessage"] !== undefined ? _data["allergymessage"] : null as any;
            this.invitemessage = _data["invitemessage"] !== undefined ? _data["invitemessage"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingChangeBackgroundDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingChangeBackgroundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["imageid"] = this.imageid !== undefined ? this.imageid : null as any;
        data["stopdate"] = this.stopdate !== undefined ? this.stopdate : null as any;
        data["invitationmessage"] = this.invitationmessage !== undefined ? this.invitationmessage : null as any;
        data["staffmessage"] = this.staffmessage !== undefined ? this.staffmessage : null as any;
        data["allergymessage"] = this.allergymessage !== undefined ? this.allergymessage : null as any;
        data["invitemessage"] = this.invitemessage !== undefined ? this.invitemessage : null as any;
        return data;
    }
}

export interface IPartyBookingChangeBackgroundDto {
    guid: string;
    imageid: string;
    stopdate: string | null;
    invitationmessage: string | null;
    staffmessage: string | null;
    allergymessage: string | null;
    invitemessage: string | null;
}

export class PartyBookingChangeDto implements IPartyBookingChangeDto {
    /** Unconfirmed article changes on a booking. These will replace the current package and articles when the
changes are confirmed. */
    articles!: PartyBookingChangeArticleChangesDto | null;
    guestcount!: number;
    price!: PriceDto | null;

    constructor(data?: IPartyBookingChangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.articles = _data["articles"] ? PartyBookingChangeArticleChangesDto.fromJS(_data["articles"]) : null as any;
            this.guestcount = _data["guestcount"] !== undefined ? _data["guestcount"] : null as any;
            this.price = _data["price"] ? PriceDto.fromJS(_data["price"]) : null as any;
        }
    }

    static fromJS(data: any): PartyBookingChangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingChangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["articles"] = this.articles ? this.articles.toJSON() : null as any;
        data["guestcount"] = this.guestcount !== undefined ? this.guestcount : null as any;
        data["price"] = this.price ? this.price.toJSON() : null as any;
        return data;
    }
}

export interface IPartyBookingChangeDto {
    /** Unconfirmed article changes on a booking. These will replace the current package and articles when the
changes are confirmed. */
    articles: PartyBookingChangeArticleChangesDto | null;
    guestcount: number;
    price: PriceDto | null;
}

export class PartyBookingChangeRequestDto implements IPartyBookingChangeRequestDto {
    guid!: string;
    changemessage!: string | null;
    reservationid!: string;
    staffmessage!: string | null;
    allergymessage!: string | null;
    invitemessage!: string | null;

    constructor(data?: IPartyBookingChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.changemessage = _data["changemessage"] !== undefined ? _data["changemessage"] : null as any;
            this.reservationid = _data["reservationid"] !== undefined ? _data["reservationid"] : null as any;
            this.staffmessage = _data["staffmessage"] !== undefined ? _data["staffmessage"] : null as any;
            this.allergymessage = _data["allergymessage"] !== undefined ? _data["allergymessage"] : null as any;
            this.invitemessage = _data["invitemessage"] !== undefined ? _data["invitemessage"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["changemessage"] = this.changemessage !== undefined ? this.changemessage : null as any;
        data["reservationid"] = this.reservationid !== undefined ? this.reservationid : null as any;
        data["staffmessage"] = this.staffmessage !== undefined ? this.staffmessage : null as any;
        data["allergymessage"] = this.allergymessage !== undefined ? this.allergymessage : null as any;
        data["invitemessage"] = this.invitemessage !== undefined ? this.invitemessage : null as any;
        return data;
    }
}

export interface IPartyBookingChangeRequestDto {
    guid: string;
    changemessage: string | null;
    reservationid: string;
    staffmessage: string | null;
    allergymessage: string | null;
    invitemessage: string | null;
}

export class PartyBookingConfirmRequestDto implements IPartyBookingConfirmRequestDto {
    bookingid!: string;

    constructor(data?: IPartyBookingConfirmRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingConfirmRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingConfirmRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : null as any;
        return data;
    }
}

export interface IPartyBookingConfirmRequestDto {
    bookingid: string;
}

/** Content for the "party booking for playground xxx will open in xxx" screen in the party booking. */
export class PartyBookingOpeningInfoContentDto implements IPartyBookingOpeningInfoContentDto {
    /** Displayed in the title of the page. */
    pageTitle!: string;
    /** Displayed below the countdown. */
    pageSubtitle!: string;
    /** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
    cardImage!: MediaItemDto;
    /** The card title. */
    cardTitle!: string;
    /** The card text. */
    cardText!: string;
    /** The text for the small alert at the bottom of the page. */
    alertText!: string | null;
    /** Title for the calendar event. */
    calendarEventTitle!: string;
    /** Text for the calendar event. */
    calendarEventText!: string;
    /** Text for the add to calendar button. */
    addToCalenderButtonText!: string;

    constructor(data?: IPartyBookingOpeningInfoContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.cardImage = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageTitle = _data["pageTitle"] !== undefined ? _data["pageTitle"] : null as any;
            this.pageSubtitle = _data["pageSubtitle"] !== undefined ? _data["pageSubtitle"] : null as any;
            this.cardImage = _data["cardImage"] ? MediaItemDto.fromJS(_data["cardImage"]) : new MediaItemDto();
            this.cardTitle = _data["cardTitle"] !== undefined ? _data["cardTitle"] : null as any;
            this.cardText = _data["cardText"] !== undefined ? _data["cardText"] : null as any;
            this.alertText = _data["alertText"] !== undefined ? _data["alertText"] : null as any;
            this.calendarEventTitle = _data["calendarEventTitle"] !== undefined ? _data["calendarEventTitle"] : null as any;
            this.calendarEventText = _data["calendarEventText"] !== undefined ? _data["calendarEventText"] : null as any;
            this.addToCalenderButtonText = _data["addToCalenderButtonText"] !== undefined ? _data["addToCalenderButtonText"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingOpeningInfoContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingOpeningInfoContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageTitle"] = this.pageTitle !== undefined ? this.pageTitle : null as any;
        data["pageSubtitle"] = this.pageSubtitle !== undefined ? this.pageSubtitle : null as any;
        data["cardImage"] = this.cardImage ? this.cardImage.toJSON() : null as any;
        data["cardTitle"] = this.cardTitle !== undefined ? this.cardTitle : null as any;
        data["cardText"] = this.cardText !== undefined ? this.cardText : null as any;
        data["alertText"] = this.alertText !== undefined ? this.alertText : null as any;
        data["calendarEventTitle"] = this.calendarEventTitle !== undefined ? this.calendarEventTitle : null as any;
        data["calendarEventText"] = this.calendarEventText !== undefined ? this.calendarEventText : null as any;
        data["addToCalenderButtonText"] = this.addToCalenderButtonText !== undefined ? this.addToCalenderButtonText : null as any;
        return data;
    }
}

/** Content for the "party booking for playground xxx will open in xxx" screen in the party booking. */
export interface IPartyBookingOpeningInfoContentDto {
    /** Displayed in the title of the page. */
    pageTitle: string;
    /** Displayed below the countdown. */
    pageSubtitle: string;
    /** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
    cardImage: MediaItemDto;
    /** The card title. */
    cardTitle: string;
    /** The card text. */
    cardText: string;
    /** The text for the small alert at the bottom of the page. */
    alertText: string | null;
    /** Title for the calendar event. */
    calendarEventTitle: string;
    /** Text for the calendar event. */
    calendarEventText: string;
    /** Text for the add to calendar button. */
    addToCalenderButtonText: string;
}

/** Information for when the party booking opens up for new bookings. */
export class PartyBookingOpeningInfoDto implements IPartyBookingOpeningInfoDto {
    /** The date when the party booking opens up for new bookings. */
    date!: Date;
    /** Content to display for the user, null if the playground is open. */
    content!: PartyBookingOpeningInfoContentDto | null;

    constructor(data?: IPartyBookingOpeningInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? new Date(_data["date"].toString()) : null as any;
            this.content = _data["content"] ? PartyBookingOpeningInfoContentDto.fromJS(_data["content"]) : null as any;
        }
    }

    static fromJS(data: any): PartyBookingOpeningInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingOpeningInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : null as any;
        data["content"] = this.content ? this.content.toJSON() : null as any;
        return data;
    }
}

/** Information for when the party booking opens up for new bookings. */
export interface IPartyBookingOpeningInfoDto {
    /** The date when the party booking opens up for new bookings. */
    date: Date;
    /** Content to display for the user, null if the playground is open. */
    content: PartyBookingOpeningInfoContentDto | null;
}

export class PartyBookingPriceDto implements IPartyBookingPriceDto {
    pricevalue!: number | null;
    currency!: string | null;

    constructor(data?: IPartyBookingPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricevalue = _data["pricevalue"] !== undefined ? _data["pricevalue"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingPriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingPriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricevalue"] = this.pricevalue !== undefined ? this.pricevalue : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        return data;
    }
}

export interface IPartyBookingPriceDto {
    pricevalue: number | null;
    currency: string | null;
}

export class PartyBookingResponseDto implements IPartyBookingResponseDto {
    guid!: string;
    maxguests!: number;
    minguests!: number;
    price!: PartyBookingPriceDto | null;
    orderreference!: string | null;
    status!: string | null;
    cancancel!: boolean;
    canchangedate!: boolean;
    canchangearticles!: boolean;
    canchangeguests!: boolean;
    canconfirm!: boolean;
    playgroundid!: string;
    startdate!: string | null;
    stopdate!: string | null;
    partylength!: number | null;
    /** The currently selected invitation background guid. Null if none is selected. */
    invitationbackgroundguid!: string | null;
    invitationmessage!: string | null;
    reservation!: PartyReservationResponseDto | null;
    changereservation!: PartyReservationResponseDto | null;
    bookingchanges!: PartyBookingChangeDto | null;
    packagename!: string | null;
    packageguid!: string | null;
    guests!: GuestResponseDto[] | null;
    invites!: InviteDto[] | null;
    bookingarticles!: BookingArticleDto[] | null;
    /** The price per extra birthday child. The first birthday child is always included in the price. */
    priceextrabirthdaychild!: PartyBookingPriceDto | null;
    artnoextrabirthdaychild!: string | null;
    /** The date the booking was created. */
    createddate!: string | null;
    staffmessage!: string | null;
    allergymessage!: string | null;
    invitemessage!: string | null;

    constructor(data?: IPartyBookingResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.maxguests = _data["maxguests"] !== undefined ? _data["maxguests"] : null as any;
            this.minguests = _data["minguests"] !== undefined ? _data["minguests"] : null as any;
            this.price = _data["price"] ? PartyBookingPriceDto.fromJS(_data["price"]) : null as any;
            this.orderreference = _data["orderreference"] !== undefined ? _data["orderreference"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.cancancel = _data["cancancel"] !== undefined ? _data["cancancel"] : null as any;
            this.canchangedate = _data["canchangedate"] !== undefined ? _data["canchangedate"] : null as any;
            this.canchangearticles = _data["canchangearticles"] !== undefined ? _data["canchangearticles"] : null as any;
            this.canchangeguests = _data["canchangeguests"] !== undefined ? _data["canchangeguests"] : null as any;
            this.canconfirm = _data["canconfirm"] !== undefined ? _data["canconfirm"] : null as any;
            this.playgroundid = _data["playgroundid"] !== undefined ? _data["playgroundid"] : null as any;
            this.startdate = _data["startdate"] !== undefined ? _data["startdate"] : null as any;
            this.stopdate = _data["stopdate"] !== undefined ? _data["stopdate"] : null as any;
            this.partylength = _data["partylength"] !== undefined ? _data["partylength"] : null as any;
            this.invitationbackgroundguid = _data["invitationbackgroundguid"] !== undefined ? _data["invitationbackgroundguid"] : null as any;
            this.invitationmessage = _data["invitationmessage"] !== undefined ? _data["invitationmessage"] : null as any;
            this.reservation = _data["reservation"] ? PartyReservationResponseDto.fromJS(_data["reservation"]) : null as any;
            this.changereservation = _data["changereservation"] ? PartyReservationResponseDto.fromJS(_data["changereservation"]) : null as any;
            this.bookingchanges = _data["bookingchanges"] ? PartyBookingChangeDto.fromJS(_data["bookingchanges"]) : null as any;
            this.packagename = _data["packagename"] !== undefined ? _data["packagename"] : null as any;
            this.packageguid = _data["packageguid"] !== undefined ? _data["packageguid"] : null as any;
            if (Array.isArray(_data["guests"])) {
                this.guests = [] as any;
                for (let item of _data["guests"])
                    this.guests!.push(GuestResponseDto.fromJS(item));
            }
            else {
                this.guests = null as any;
            }
            if (Array.isArray(_data["invites"])) {
                this.invites = [] as any;
                for (let item of _data["invites"])
                    this.invites!.push(InviteDto.fromJS(item));
            }
            else {
                this.invites = null as any;
            }
            if (Array.isArray(_data["bookingarticles"])) {
                this.bookingarticles = [] as any;
                for (let item of _data["bookingarticles"])
                    this.bookingarticles!.push(BookingArticleDto.fromJS(item));
            }
            else {
                this.bookingarticles = null as any;
            }
            this.priceextrabirthdaychild = _data["priceextrabirthdaychild"] ? PartyBookingPriceDto.fromJS(_data["priceextrabirthdaychild"]) : null as any;
            this.artnoextrabirthdaychild = _data["artnoextrabirthdaychild"] !== undefined ? _data["artnoextrabirthdaychild"] : null as any;
            this.createddate = _data["createddate"] !== undefined ? _data["createddate"] : null as any;
            this.staffmessage = _data["staffmessage"] !== undefined ? _data["staffmessage"] : null as any;
            this.allergymessage = _data["allergymessage"] !== undefined ? _data["allergymessage"] : null as any;
            this.invitemessage = _data["invitemessage"] !== undefined ? _data["invitemessage"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["maxguests"] = this.maxguests !== undefined ? this.maxguests : null as any;
        data["minguests"] = this.minguests !== undefined ? this.minguests : null as any;
        data["price"] = this.price ? this.price.toJSON() : null as any;
        data["orderreference"] = this.orderreference !== undefined ? this.orderreference : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["cancancel"] = this.cancancel !== undefined ? this.cancancel : null as any;
        data["canchangedate"] = this.canchangedate !== undefined ? this.canchangedate : null as any;
        data["canchangearticles"] = this.canchangearticles !== undefined ? this.canchangearticles : null as any;
        data["canchangeguests"] = this.canchangeguests !== undefined ? this.canchangeguests : null as any;
        data["canconfirm"] = this.canconfirm !== undefined ? this.canconfirm : null as any;
        data["playgroundid"] = this.playgroundid !== undefined ? this.playgroundid : null as any;
        data["startdate"] = this.startdate !== undefined ? this.startdate : null as any;
        data["stopdate"] = this.stopdate !== undefined ? this.stopdate : null as any;
        data["partylength"] = this.partylength !== undefined ? this.partylength : null as any;
        data["invitationbackgroundguid"] = this.invitationbackgroundguid !== undefined ? this.invitationbackgroundguid : null as any;
        data["invitationmessage"] = this.invitationmessage !== undefined ? this.invitationmessage : null as any;
        data["reservation"] = this.reservation ? this.reservation.toJSON() : null as any;
        data["changereservation"] = this.changereservation ? this.changereservation.toJSON() : null as any;
        data["bookingchanges"] = this.bookingchanges ? this.bookingchanges.toJSON() : null as any;
        data["packagename"] = this.packagename !== undefined ? this.packagename : null as any;
        data["packageguid"] = this.packageguid !== undefined ? this.packageguid : null as any;
        if (Array.isArray(this.guests)) {
            data["guests"] = [];
            for (let item of this.guests)
                data["guests"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.invites)) {
            data["invites"] = [];
            for (let item of this.invites)
                data["invites"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.bookingarticles)) {
            data["bookingarticles"] = [];
            for (let item of this.bookingarticles)
                data["bookingarticles"].push(item ? item.toJSON() : null as any);
        }
        data["priceextrabirthdaychild"] = this.priceextrabirthdaychild ? this.priceextrabirthdaychild.toJSON() : null as any;
        data["artnoextrabirthdaychild"] = this.artnoextrabirthdaychild !== undefined ? this.artnoextrabirthdaychild : null as any;
        data["createddate"] = this.createddate !== undefined ? this.createddate : null as any;
        data["staffmessage"] = this.staffmessage !== undefined ? this.staffmessage : null as any;
        data["allergymessage"] = this.allergymessage !== undefined ? this.allergymessage : null as any;
        data["invitemessage"] = this.invitemessage !== undefined ? this.invitemessage : null as any;
        return data;
    }
}

export interface IPartyBookingResponseDto {
    guid: string;
    maxguests: number;
    minguests: number;
    price: PartyBookingPriceDto | null;
    orderreference: string | null;
    status: string | null;
    cancancel: boolean;
    canchangedate: boolean;
    canchangearticles: boolean;
    canchangeguests: boolean;
    canconfirm: boolean;
    playgroundid: string;
    startdate: string | null;
    stopdate: string | null;
    partylength: number | null;
    /** The currently selected invitation background guid. Null if none is selected. */
    invitationbackgroundguid: string | null;
    invitationmessage: string | null;
    reservation: PartyReservationResponseDto | null;
    changereservation: PartyReservationResponseDto | null;
    bookingchanges: PartyBookingChangeDto | null;
    packagename: string | null;
    packageguid: string | null;
    guests: GuestResponseDto[] | null;
    invites: InviteDto[] | null;
    bookingarticles: BookingArticleDto[] | null;
    /** The price per extra birthday child. The first birthday child is always included in the price. */
    priceextrabirthdaychild: PartyBookingPriceDto | null;
    artnoextrabirthdaychild: string | null;
    /** The date the booking was created. */
    createddate: string | null;
    staffmessage: string | null;
    allergymessage: string | null;
    invitemessage: string | null;
}

export class PartyPackageArticleCollectionDto implements IPartyPackageArticleCollectionDto {
    name!: string | null;
    notice!: string | null;
    iscampaign!: boolean;
    guid!: string;
    status!: PublishStatus;
    sortorder!: number;
    defaultpriceperguest!: number;
    locations!: LocationListItem[] | null;
    /** Warning: Criterias should not be visible in public */
    daytypecriterias!: string[] | null;
    /** Warning: Criterias should not be visible in public */
    datecriterias!: DateCriteriaDto[] | null;
    packageid!: string;
    defaultarticles!: PartyPackageArticleDto[] | null;
    addonarticles!: PartyPackageArticleDto[] | null;

    constructor(data?: IPartyPackageArticleCollectionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.notice = _data["notice"] !== undefined ? _data["notice"] : null as any;
            this.iscampaign = _data["iscampaign"] !== undefined ? _data["iscampaign"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.sortorder = _data["sortorder"] !== undefined ? _data["sortorder"] : null as any;
            this.defaultpriceperguest = _data["defaultpriceperguest"] !== undefined ? _data["defaultpriceperguest"] : null as any;
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(LocationListItem.fromJS(item));
            }
            else {
                this.locations = null as any;
            }
            if (Array.isArray(_data["daytypecriterias"])) {
                this.daytypecriterias = [] as any;
                for (let item of _data["daytypecriterias"])
                    this.daytypecriterias!.push(item);
            }
            else {
                this.daytypecriterias = null as any;
            }
            if (Array.isArray(_data["datecriterias"])) {
                this.datecriterias = [] as any;
                for (let item of _data["datecriterias"])
                    this.datecriterias!.push(DateCriteriaDto.fromJS(item));
            }
            else {
                this.datecriterias = null as any;
            }
            this.packageid = _data["packageid"] !== undefined ? _data["packageid"] : null as any;
            if (Array.isArray(_data["defaultarticles"])) {
                this.defaultarticles = [] as any;
                for (let item of _data["defaultarticles"])
                    this.defaultarticles!.push(PartyPackageArticleDto.fromJS(item));
            }
            else {
                this.defaultarticles = null as any;
            }
            if (Array.isArray(_data["addonarticles"])) {
                this.addonarticles = [] as any;
                for (let item of _data["addonarticles"])
                    this.addonarticles!.push(PartyPackageArticleDto.fromJS(item));
            }
            else {
                this.addonarticles = null as any;
            }
        }
    }

    static fromJS(data: any): PartyPackageArticleCollectionDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyPackageArticleCollectionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["notice"] = this.notice !== undefined ? this.notice : null as any;
        data["iscampaign"] = this.iscampaign !== undefined ? this.iscampaign : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["sortorder"] = this.sortorder !== undefined ? this.sortorder : null as any;
        data["defaultpriceperguest"] = this.defaultpriceperguest !== undefined ? this.defaultpriceperguest : null as any;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.daytypecriterias)) {
            data["daytypecriterias"] = [];
            for (let item of this.daytypecriterias)
                data["daytypecriterias"].push(item);
        }
        if (Array.isArray(this.datecriterias)) {
            data["datecriterias"] = [];
            for (let item of this.datecriterias)
                data["datecriterias"].push(item ? item.toJSON() : null as any);
        }
        data["packageid"] = this.packageid !== undefined ? this.packageid : null as any;
        if (Array.isArray(this.defaultarticles)) {
            data["defaultarticles"] = [];
            for (let item of this.defaultarticles)
                data["defaultarticles"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.addonarticles)) {
            data["addonarticles"] = [];
            for (let item of this.addonarticles)
                data["addonarticles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPartyPackageArticleCollectionDto {
    name: string | null;
    notice: string | null;
    iscampaign: boolean;
    guid: string;
    status: PublishStatus;
    sortorder: number;
    defaultpriceperguest: number;
    locations: LocationListItem[] | null;
    /** Warning: Criterias should not be visible in public */
    daytypecriterias: string[] | null;
    /** Warning: Criterias should not be visible in public */
    datecriterias: DateCriteriaDto[] | null;
    packageid: string;
    defaultarticles: PartyPackageArticleDto[] | null;
    addonarticles: PartyPackageArticleDto[] | null;
}

export class PartyPackageArticleDto implements IPartyPackageArticleDto {
    name!: string | null;
    translatednames!: { [key: string]: string; } | null;
    guid!: string;
    webarticleid!: string;
    artno!: string | null;
    navartno!: string | null;
    articlegroup!: string | null;
    price!: number;
    vat!: number | null;
    originalprice!: number | null;
    itemtype!: PackageItemType;
    image!: ImageDto | null;
    fixedamount!: number | null;
    sortorder!: number;
    isdefaultvisible!: boolean;
    exchangeable!: PartyPackageArticleDto[] | null;

    constructor(data?: IPartyPackageArticleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (_data["translatednames"]) {
                this.translatednames = {} as any;
                for (let key in _data["translatednames"]) {
                    if (_data["translatednames"].hasOwnProperty(key))
                        (this.translatednames as any)![key] = _data["translatednames"][key] !== undefined ? _data["translatednames"][key] : null as any;
                }
            }
            else {
                this.translatednames = null as any;
            }
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.webarticleid = _data["webarticleid"] !== undefined ? _data["webarticleid"] : null as any;
            this.artno = _data["artno"] !== undefined ? _data["artno"] : null as any;
            this.navartno = _data["navartno"] !== undefined ? _data["navartno"] : null as any;
            this.articlegroup = _data["articlegroup"] !== undefined ? _data["articlegroup"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : null as any;
            this.originalprice = _data["originalprice"] !== undefined ? _data["originalprice"] : null as any;
            this.itemtype = _data["itemtype"] !== undefined ? _data["itemtype"] : null as any;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : null as any;
            this.fixedamount = _data["fixedamount"] !== undefined ? _data["fixedamount"] : null as any;
            this.sortorder = _data["sortorder"] !== undefined ? _data["sortorder"] : null as any;
            this.isdefaultvisible = _data["isdefaultvisible"] !== undefined ? _data["isdefaultvisible"] : null as any;
            if (Array.isArray(_data["exchangeable"])) {
                this.exchangeable = [] as any;
                for (let item of _data["exchangeable"])
                    this.exchangeable!.push(PartyPackageArticleDto.fromJS(item));
            }
            else {
                this.exchangeable = null as any;
            }
        }
    }

    static fromJS(data: any): PartyPackageArticleDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyPackageArticleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (this.translatednames) {
            data["translatednames"] = {};
            for (let key in this.translatednames) {
                if (this.translatednames.hasOwnProperty(key))
                    (data["translatednames"] as any)[key] = this.translatednames[key] !== undefined ? this.translatednames[key] : null as any;
            }
        }
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["webarticleid"] = this.webarticleid !== undefined ? this.webarticleid : null as any;
        data["artno"] = this.artno !== undefined ? this.artno : null as any;
        data["navartno"] = this.navartno !== undefined ? this.navartno : null as any;
        data["articlegroup"] = this.articlegroup !== undefined ? this.articlegroup : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["vat"] = this.vat !== undefined ? this.vat : null as any;
        data["originalprice"] = this.originalprice !== undefined ? this.originalprice : null as any;
        data["itemtype"] = this.itemtype !== undefined ? this.itemtype : null as any;
        data["image"] = this.image ? this.image.toJSON() : null as any;
        data["fixedamount"] = this.fixedamount !== undefined ? this.fixedamount : null as any;
        data["sortorder"] = this.sortorder !== undefined ? this.sortorder : null as any;
        data["isdefaultvisible"] = this.isdefaultvisible !== undefined ? this.isdefaultvisible : null as any;
        if (Array.isArray(this.exchangeable)) {
            data["exchangeable"] = [];
            for (let item of this.exchangeable)
                data["exchangeable"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IPartyPackageArticleDto {
    name: string | null;
    translatednames: { [key: string]: string; } | null;
    guid: string;
    webarticleid: string;
    artno: string | null;
    navartno: string | null;
    articlegroup: string | null;
    price: number;
    vat: number | null;
    originalprice: number | null;
    itemtype: PackageItemType;
    image: ImageDto | null;
    fixedamount: number | null;
    sortorder: number;
    isdefaultvisible: boolean;
    exchangeable: PartyPackageArticleDto[] | null;
}

export class PartyPackageDto implements IPartyPackageDto {
    guid!: string | null;
    name!: string | null;
    shortname!: string | null;
    price!: PriceDto | null;
    shortdescription!: string | null;
    description!: string | null;
    status!: PublishStatus;
    preselected!: boolean;
    displayprice!: PriceDto | null;
    country!: CountryDto | null;
    articles!: PartyPackageArticleCollectionDto | null;
    image!: ImageDto | null;

    constructor(data?: IPartyPackageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortname = _data["shortname"] !== undefined ? _data["shortname"] : null as any;
            this.price = _data["price"] ? PriceDto.fromJS(_data["price"]) : null as any;
            this.shortdescription = _data["shortdescription"] !== undefined ? _data["shortdescription"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.preselected = _data["preselected"] !== undefined ? _data["preselected"] : null as any;
            this.displayprice = _data["displayprice"] ? PriceDto.fromJS(_data["displayprice"]) : null as any;
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : null as any;
            this.articles = _data["articles"] ? PartyPackageArticleCollectionDto.fromJS(_data["articles"]) : null as any;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : null as any;
        }
    }

    static fromJS(data: any): PartyPackageDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyPackageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortname"] = this.shortname !== undefined ? this.shortname : null as any;
        data["price"] = this.price ? this.price.toJSON() : null as any;
        data["shortdescription"] = this.shortdescription !== undefined ? this.shortdescription : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["preselected"] = this.preselected !== undefined ? this.preselected : null as any;
        data["displayprice"] = this.displayprice ? this.displayprice.toJSON() : null as any;
        data["country"] = this.country ? this.country.toJSON() : null as any;
        data["articles"] = this.articles ? this.articles.toJSON() : null as any;
        data["image"] = this.image ? this.image.toJSON() : null as any;
        return data;
    }
}

export interface IPartyPackageDto {
    guid: string | null;
    name: string | null;
    shortname: string | null;
    price: PriceDto | null;
    shortdescription: string | null;
    description: string | null;
    status: PublishStatus;
    preselected: boolean;
    displayprice: PriceDto | null;
    country: CountryDto | null;
    articles: PartyPackageArticleCollectionDto | null;
    image: ImageDto | null;
}

export class PartyReservationChangeRequestDto implements IPartyReservationChangeRequestDto {
    reservationid!: string;
    timeslotid!: string;
    /** Time when the party guests should arrive. Clock string (HH:MM) in local time. */
    arrivaltime!: string | null;
    /** The length of the party in minutes (play time + party room) */
    partylengthminutes!: number | null;
    readyforconfirm!: boolean;
    partydate!: string | null;
    roomid!: string;

    constructor(data?: IPartyReservationChangeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationid = _data["reservationid"] !== undefined ? _data["reservationid"] : null as any;
            this.timeslotid = _data["timeslotid"] !== undefined ? _data["timeslotid"] : null as any;
            this.arrivaltime = _data["arrivaltime"] !== undefined ? _data["arrivaltime"] : null as any;
            this.partylengthminutes = _data["partylengthminutes"] !== undefined ? _data["partylengthminutes"] : null as any;
            this.readyforconfirm = _data["readyforconfirm"] !== undefined ? _data["readyforconfirm"] : null as any;
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : null as any;
            this.roomid = _data["roomid"] !== undefined ? _data["roomid"] : null as any;
        }
    }

    static fromJS(data: any): PartyReservationChangeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyReservationChangeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationid"] = this.reservationid !== undefined ? this.reservationid : null as any;
        data["timeslotid"] = this.timeslotid !== undefined ? this.timeslotid : null as any;
        data["arrivaltime"] = this.arrivaltime !== undefined ? this.arrivaltime : null as any;
        data["partylengthminutes"] = this.partylengthminutes !== undefined ? this.partylengthminutes : null as any;
        data["readyforconfirm"] = this.readyforconfirm !== undefined ? this.readyforconfirm : null as any;
        data["partydate"] = this.partydate !== undefined ? this.partydate : null as any;
        data["roomid"] = this.roomid !== undefined ? this.roomid : null as any;
        return data;
    }
}

export interface IPartyReservationChangeRequestDto {
    reservationid: string;
    timeslotid: string;
    /** Time when the party guests should arrive. Clock string (HH:MM) in local time. */
    arrivaltime: string | null;
    /** The length of the party in minutes (play time + party room) */
    partylengthminutes: number | null;
    readyforconfirm: boolean;
    partydate: string | null;
    roomid: string;
}

export class PartyReservationMakeRequestDto implements IPartyReservationMakeRequestDto {
    timeslotid!: string;
    arrivaltime!: string | null;
    partylengthminutes!: number | null;
    partydate!: string | null;
    roomid!: string;

    constructor(data?: IPartyReservationMakeRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeslotid = _data["timeslotid"] !== undefined ? _data["timeslotid"] : null as any;
            this.arrivaltime = _data["arrivaltime"] !== undefined ? _data["arrivaltime"] : null as any;
            this.partylengthminutes = _data["partylengthminutes"] !== undefined ? _data["partylengthminutes"] : null as any;
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : null as any;
            this.roomid = _data["roomid"] !== undefined ? _data["roomid"] : null as any;
        }
    }

    static fromJS(data: any): PartyReservationMakeRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyReservationMakeRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeslotid"] = this.timeslotid !== undefined ? this.timeslotid : null as any;
        data["arrivaltime"] = this.arrivaltime !== undefined ? this.arrivaltime : null as any;
        data["partylengthminutes"] = this.partylengthminutes !== undefined ? this.partylengthminutes : null as any;
        data["partydate"] = this.partydate !== undefined ? this.partydate : null as any;
        data["roomid"] = this.roomid !== undefined ? this.roomid : null as any;
        return data;
    }
}

export interface IPartyReservationMakeRequestDto {
    timeslotid: string;
    arrivaltime: string | null;
    partylengthminutes: number | null;
    partydate: string | null;
    roomid: string;
}

export class PartyReservationResponseDto implements IPartyReservationResponseDto {
    reservationid!: string;
    guid!: string;
    bookingid!: string;
    starttime!: string | null;
    displaystarttime!: string | null;
    slotcomment!: string | null;
    endtime!: string | null;
    status!: string | null;
    timeslot!: TimeSlotDto | null;
    partydate!: string | null;
    roomid!: string;

    constructor(data?: IPartyReservationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reservationid = _data["reservationid"] !== undefined ? _data["reservationid"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.bookingid = _data["bookingid"] !== undefined ? _data["bookingid"] : null as any;
            this.starttime = _data["starttime"] !== undefined ? _data["starttime"] : null as any;
            this.displaystarttime = _data["displaystarttime"] !== undefined ? _data["displaystarttime"] : null as any;
            this.slotcomment = _data["slotcomment"] !== undefined ? _data["slotcomment"] : null as any;
            this.endtime = _data["endtime"] !== undefined ? _data["endtime"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.timeslot = _data["timeslot"] ? TimeSlotDto.fromJS(_data["timeslot"]) : null as any;
            this.partydate = _data["partydate"] !== undefined ? _data["partydate"] : null as any;
            this.roomid = _data["roomid"] !== undefined ? _data["roomid"] : null as any;
        }
    }

    static fromJS(data: any): PartyReservationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyReservationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reservationid"] = this.reservationid !== undefined ? this.reservationid : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["bookingid"] = this.bookingid !== undefined ? this.bookingid : null as any;
        data["starttime"] = this.starttime !== undefined ? this.starttime : null as any;
        data["displaystarttime"] = this.displaystarttime !== undefined ? this.displaystarttime : null as any;
        data["slotcomment"] = this.slotcomment !== undefined ? this.slotcomment : null as any;
        data["endtime"] = this.endtime !== undefined ? this.endtime : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["timeslot"] = this.timeslot ? this.timeslot.toJSON() : null as any;
        data["partydate"] = this.partydate !== undefined ? this.partydate : null as any;
        data["roomid"] = this.roomid !== undefined ? this.roomid : null as any;
        return data;
    }
}

export interface IPartyReservationResponseDto {
    reservationid: string;
    guid: string;
    bookingid: string;
    starttime: string | null;
    displaystarttime: string | null;
    slotcomment: string | null;
    endtime: string | null;
    status: string | null;
    timeslot: TimeSlotDto | null;
    partydate: string | null;
    roomid: string;
}

export class BoolResultDto implements IBoolResultDto {
    success!: boolean;
    message!: string | null;
    relatedobject!: string;
    errors!: string[] | null;
    notices!: NoticeDto[] | null;

    constructor(data?: IBoolResultDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : null as any;
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.relatedobject = _data["relatedobject"] !== undefined ? _data["relatedobject"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
            else {
                this.errors = null as any;
            }
            if (Array.isArray(_data["notices"])) {
                this.notices = [] as any;
                for (let item of _data["notices"])
                    this.notices!.push(NoticeDto.fromJS(item));
            }
            else {
                this.notices = null as any;
            }
        }
    }

    static fromJS(data: any): BoolResultDto {
        data = typeof data === 'object' ? data : {};
        let result = new BoolResultDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : null as any;
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["relatedobject"] = this.relatedobject !== undefined ? this.relatedobject : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        if (Array.isArray(this.notices)) {
            data["notices"] = [];
            for (let item of this.notices)
                data["notices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IBoolResultDto {
    success: boolean;
    message: string | null;
    relatedobject: string;
    errors: string[] | null;
    notices: NoticeDto[] | null;
}

export class ChangeNumberOfGuestsDto implements IChangeNumberOfGuestsDto {
    partybookingid!: string;
    numberofguests!: number;

    constructor(data?: IChangeNumberOfGuestsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.partybookingid = _data["partybookingid"] !== undefined ? _data["partybookingid"] : null as any;
            this.numberofguests = _data["numberofguests"] !== undefined ? _data["numberofguests"] : null as any;
        }
    }

    static fromJS(data: any): ChangeNumberOfGuestsDto {
        data = typeof data === 'object' ? data : {};
        let result = new ChangeNumberOfGuestsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["partybookingid"] = this.partybookingid !== undefined ? this.partybookingid : null as any;
        data["numberofguests"] = this.numberofguests !== undefined ? this.numberofguests : null as any;
        return data;
    }
}

export interface IChangeNumberOfGuestsDto {
    partybookingid: string;
    numberofguests: number;
}

export class CountryDto implements ICountryDto {
    name!: string | null;
    culture!: string | null;
    currency!: string | null;
    timezone!: string | null;
    companyname!: string | null;
    companyorgno!: string | null;
    guid!: string;
    /** The countrys sms sender display name */
    smsfrom!: string | null;
    /** The countrys mail sender display name */
    mailfrom!: string | null;
    /** URL to the public start page. */
    sitebaseaddress!: string | null;
    /** URL to the entrance booking and child class booking start page. */
    orderbaseaddress!: string | null;
    /** URL to party booking site. */
    partybaseaddress!: string | null;
    regions!: RegionDto[] | null;
    companyaddress!: string | null;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.culture = _data["culture"] !== undefined ? _data["culture"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.timezone = _data["timezone"] !== undefined ? _data["timezone"] : null as any;
            this.companyname = _data["companyname"] !== undefined ? _data["companyname"] : null as any;
            this.companyorgno = _data["companyorgno"] !== undefined ? _data["companyorgno"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.smsfrom = _data["smsfrom"] !== undefined ? _data["smsfrom"] : null as any;
            this.mailfrom = _data["mailfrom"] !== undefined ? _data["mailfrom"] : null as any;
            this.sitebaseaddress = _data["sitebaseaddress"] !== undefined ? _data["sitebaseaddress"] : null as any;
            this.orderbaseaddress = _data["orderbaseaddress"] !== undefined ? _data["orderbaseaddress"] : null as any;
            this.partybaseaddress = _data["partybaseaddress"] !== undefined ? _data["partybaseaddress"] : null as any;
            if (Array.isArray(_data["regions"])) {
                this.regions = [] as any;
                for (let item of _data["regions"])
                    this.regions!.push(RegionDto.fromJS(item));
            }
            else {
                this.regions = null as any;
            }
            this.companyaddress = _data["companyaddress"] !== undefined ? _data["companyaddress"] : null as any;
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["culture"] = this.culture !== undefined ? this.culture : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["timezone"] = this.timezone !== undefined ? this.timezone : null as any;
        data["companyname"] = this.companyname !== undefined ? this.companyname : null as any;
        data["companyorgno"] = this.companyorgno !== undefined ? this.companyorgno : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["smsfrom"] = this.smsfrom !== undefined ? this.smsfrom : null as any;
        data["mailfrom"] = this.mailfrom !== undefined ? this.mailfrom : null as any;
        data["sitebaseaddress"] = this.sitebaseaddress !== undefined ? this.sitebaseaddress : null as any;
        data["orderbaseaddress"] = this.orderbaseaddress !== undefined ? this.orderbaseaddress : null as any;
        data["partybaseaddress"] = this.partybaseaddress !== undefined ? this.partybaseaddress : null as any;
        if (Array.isArray(this.regions)) {
            data["regions"] = [];
            for (let item of this.regions)
                data["regions"].push(item ? item.toJSON() : null as any);
        }
        data["companyaddress"] = this.companyaddress !== undefined ? this.companyaddress : null as any;
        return data;
    }
}

export interface ICountryDto {
    name: string | null;
    culture: string | null;
    currency: string | null;
    timezone: string | null;
    companyname: string | null;
    companyorgno: string | null;
    guid: string;
    /** The countrys sms sender display name */
    smsfrom: string | null;
    /** The countrys mail sender display name */
    mailfrom: string | null;
    /** URL to the public start page. */
    sitebaseaddress: string | null;
    /** URL to the entrance booking and child class booking start page. */
    orderbaseaddress: string | null;
    /** URL to party booking site. */
    partybaseaddress: string | null;
    regions: RegionDto[] | null;
    companyaddress: string | null;
}

/** Meta data for countries */
export class CountryMetadataDto implements ICountryMetadataDto {
    /** Available country phone number codes
E.g. 46 for Sweden.
Sorted in countries where Leo's are active and then by increasing country code. */
    readonly countryPhoneNumberCodes!: number[];
    /** Available cultures -> phone number codes.
E.g. "sv-SE" -> 46. */
    readonly cultureToCountryCodes!: { [key: string]: number; };

    constructor(data?: ICountryMetadataDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.countryPhoneNumberCodes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countryPhoneNumberCodes"])) {
                (this as any).countryPhoneNumberCodes = [] as any;
                for (let item of _data["countryPhoneNumberCodes"])
                    (this as any).countryPhoneNumberCodes!.push(item);
            }
            else {
                (this as any).countryPhoneNumberCodes = null as any;
            }
            if (_data["cultureToCountryCodes"]) {
                (this as any).cultureToCountryCodes = {} as any;
                for (let key in _data["cultureToCountryCodes"]) {
                    if (_data["cultureToCountryCodes"].hasOwnProperty(key))
                        ((this as any).cultureToCountryCodes as any)![key] = _data["cultureToCountryCodes"][key] !== undefined ? _data["cultureToCountryCodes"][key] : null as any;
                }
            }
            else {
                (this as any).cultureToCountryCodes = null as any;
            }
        }
    }

    static fromJS(data: any): CountryMetadataDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryMetadataDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryPhoneNumberCodes)) {
            data["countryPhoneNumberCodes"] = [];
            for (let item of this.countryPhoneNumberCodes)
                data["countryPhoneNumberCodes"].push(item);
        }
        if (this.cultureToCountryCodes) {
            data["cultureToCountryCodes"] = {};
            for (let key in this.cultureToCountryCodes) {
                if (this.cultureToCountryCodes.hasOwnProperty(key))
                    (data["cultureToCountryCodes"] as any)[key] = this.cultureToCountryCodes[key] !== undefined ? this.cultureToCountryCodes[key] : null as any;
            }
        }
        return data;
    }
}

/** Meta data for countries */
export interface ICountryMetadataDto {
    /** Available country phone number codes
E.g. 46 for Sweden.
Sorted in countries where Leo's are active and then by increasing country code. */
    countryPhoneNumberCodes: number[];
    /** Available cultures -> phone number codes.
E.g. "sv-SE" -> 46. */
    cultureToCountryCodes: { [key: string]: number; };
}

export class GuestAttendenceDto implements IGuestAttendenceDto {
    bookingId!: string;
    inviteId!: string;
    isAttending!: boolean;

    constructor(data?: IGuestAttendenceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.bookingId = _data["bookingId"] !== undefined ? _data["bookingId"] : null as any;
            this.inviteId = _data["inviteId"] !== undefined ? _data["inviteId"] : null as any;
            this.isAttending = _data["isAttending"] !== undefined ? _data["isAttending"] : null as any;
        }
    }

    static fromJS(data: any): GuestAttendenceDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestAttendenceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId !== undefined ? this.bookingId : null as any;
        data["inviteId"] = this.inviteId !== undefined ? this.inviteId : null as any;
        data["isAttending"] = this.isAttending !== undefined ? this.isAttending : null as any;
        return data;
    }
}

export interface IGuestAttendenceDto {
    bookingId: string;
    inviteId: string;
    isAttending: boolean;
}

export class GuestDto implements IGuestDto {
    guestname!: string | null;
    parentname!: string | null;
    age!: number | null;
    birthdaydate!: string | null;
    birthday!: boolean;
    ismainguest!: boolean;
    phonecountrycode!: number;
    phone!: string | null;
    email!: string | null;
    gender!: string | null;
    otherinfo!: string | null;
    guestid!: string;
    inviteid!: string;
    partybookingid!: string;
    disableconfirmation!: boolean;
    disablesendinvite!: boolean;
    notices!: NoticeDto[] | null;

    constructor(data?: IGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guestname = _data["guestname"] !== undefined ? _data["guestname"] : null as any;
            this.parentname = _data["parentname"] !== undefined ? _data["parentname"] : null as any;
            this.age = _data["age"] !== undefined ? _data["age"] : null as any;
            this.birthdaydate = _data["birthdaydate"] !== undefined ? _data["birthdaydate"] : null as any;
            this.birthday = _data["birthday"] !== undefined ? _data["birthday"] : null as any;
            this.ismainguest = _data["ismainguest"] !== undefined ? _data["ismainguest"] : null as any;
            this.phonecountrycode = _data["phonecountrycode"] !== undefined ? _data["phonecountrycode"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            this.otherinfo = _data["otherinfo"] !== undefined ? _data["otherinfo"] : null as any;
            this.guestid = _data["guestid"] !== undefined ? _data["guestid"] : null as any;
            this.inviteid = _data["inviteid"] !== undefined ? _data["inviteid"] : null as any;
            this.partybookingid = _data["partybookingid"] !== undefined ? _data["partybookingid"] : null as any;
            this.disableconfirmation = _data["disableconfirmation"] !== undefined ? _data["disableconfirmation"] : null as any;
            this.disablesendinvite = _data["disablesendinvite"] !== undefined ? _data["disablesendinvite"] : null as any;
            if (Array.isArray(_data["notices"])) {
                this.notices = [] as any;
                for (let item of _data["notices"])
                    this.notices!.push(NoticeDto.fromJS(item));
            }
            else {
                this.notices = null as any;
            }
        }
    }

    static fromJS(data: any): GuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guestname"] = this.guestname !== undefined ? this.guestname : null as any;
        data["parentname"] = this.parentname !== undefined ? this.parentname : null as any;
        data["age"] = this.age !== undefined ? this.age : null as any;
        data["birthdaydate"] = this.birthdaydate !== undefined ? this.birthdaydate : null as any;
        data["birthday"] = this.birthday !== undefined ? this.birthday : null as any;
        data["ismainguest"] = this.ismainguest !== undefined ? this.ismainguest : null as any;
        data["phonecountrycode"] = this.phonecountrycode !== undefined ? this.phonecountrycode : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        data["otherinfo"] = this.otherinfo !== undefined ? this.otherinfo : null as any;
        data["guestid"] = this.guestid !== undefined ? this.guestid : null as any;
        data["inviteid"] = this.inviteid !== undefined ? this.inviteid : null as any;
        data["partybookingid"] = this.partybookingid !== undefined ? this.partybookingid : null as any;
        data["disableconfirmation"] = this.disableconfirmation !== undefined ? this.disableconfirmation : null as any;
        data["disablesendinvite"] = this.disablesendinvite !== undefined ? this.disablesendinvite : null as any;
        if (Array.isArray(this.notices)) {
            data["notices"] = [];
            for (let item of this.notices)
                data["notices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGuestDto {
    guestname: string | null;
    parentname: string | null;
    age: number | null;
    birthdaydate: string | null;
    birthday: boolean;
    ismainguest: boolean;
    phonecountrycode: number;
    phone: string | null;
    email: string | null;
    gender: string | null;
    otherinfo: string | null;
    guestid: string;
    inviteid: string;
    partybookingid: string;
    disableconfirmation: boolean;
    disablesendinvite: boolean;
    notices: NoticeDto[] | null;
}

export class GuestResponseDto implements IGuestResponseDto {
    status!: string | null;
    guestmessage!: string | null;
    /** Allergy information supplied by the guest when answering an invitation. */
    guestallergymessage!: string | null;
    guestname!: string | null;
    parentname!: string | null;
    age!: number | null;
    birthdaydate!: string | null;
    birthday!: boolean;
    ismainguest!: boolean;
    phonecountrycode!: number;
    phone!: string | null;
    email!: string | null;
    gender!: string | null;
    otherinfo!: string | null;
    guestid!: string;
    inviteid!: string;
    partybookingid!: string;
    disableconfirmation!: boolean;
    disablesendinvite!: boolean;
    notices!: NoticeDto[] | null;

    constructor(data?: IGuestResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.guestmessage = _data["guestmessage"] !== undefined ? _data["guestmessage"] : null as any;
            this.guestallergymessage = _data["guestallergymessage"] !== undefined ? _data["guestallergymessage"] : null as any;
            this.guestname = _data["guestname"] !== undefined ? _data["guestname"] : null as any;
            this.parentname = _data["parentname"] !== undefined ? _data["parentname"] : null as any;
            this.age = _data["age"] !== undefined ? _data["age"] : null as any;
            this.birthdaydate = _data["birthdaydate"] !== undefined ? _data["birthdaydate"] : null as any;
            this.birthday = _data["birthday"] !== undefined ? _data["birthday"] : null as any;
            this.ismainguest = _data["ismainguest"] !== undefined ? _data["ismainguest"] : null as any;
            this.phonecountrycode = _data["phonecountrycode"] !== undefined ? _data["phonecountrycode"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.gender = _data["gender"] !== undefined ? _data["gender"] : null as any;
            this.otherinfo = _data["otherinfo"] !== undefined ? _data["otherinfo"] : null as any;
            this.guestid = _data["guestid"] !== undefined ? _data["guestid"] : null as any;
            this.inviteid = _data["inviteid"] !== undefined ? _data["inviteid"] : null as any;
            this.partybookingid = _data["partybookingid"] !== undefined ? _data["partybookingid"] : null as any;
            this.disableconfirmation = _data["disableconfirmation"] !== undefined ? _data["disableconfirmation"] : null as any;
            this.disablesendinvite = _data["disablesendinvite"] !== undefined ? _data["disablesendinvite"] : null as any;
            if (Array.isArray(_data["notices"])) {
                this.notices = [] as any;
                for (let item of _data["notices"])
                    this.notices!.push(NoticeDto.fromJS(item));
            }
            else {
                this.notices = null as any;
            }
        }
    }

    static fromJS(data: any): GuestResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new GuestResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["guestmessage"] = this.guestmessage !== undefined ? this.guestmessage : null as any;
        data["guestallergymessage"] = this.guestallergymessage !== undefined ? this.guestallergymessage : null as any;
        data["guestname"] = this.guestname !== undefined ? this.guestname : null as any;
        data["parentname"] = this.parentname !== undefined ? this.parentname : null as any;
        data["age"] = this.age !== undefined ? this.age : null as any;
        data["birthdaydate"] = this.birthdaydate !== undefined ? this.birthdaydate : null as any;
        data["birthday"] = this.birthday !== undefined ? this.birthday : null as any;
        data["ismainguest"] = this.ismainguest !== undefined ? this.ismainguest : null as any;
        data["phonecountrycode"] = this.phonecountrycode !== undefined ? this.phonecountrycode : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["gender"] = this.gender !== undefined ? this.gender : null as any;
        data["otherinfo"] = this.otherinfo !== undefined ? this.otherinfo : null as any;
        data["guestid"] = this.guestid !== undefined ? this.guestid : null as any;
        data["inviteid"] = this.inviteid !== undefined ? this.inviteid : null as any;
        data["partybookingid"] = this.partybookingid !== undefined ? this.partybookingid : null as any;
        data["disableconfirmation"] = this.disableconfirmation !== undefined ? this.disableconfirmation : null as any;
        data["disablesendinvite"] = this.disablesendinvite !== undefined ? this.disablesendinvite : null as any;
        if (Array.isArray(this.notices)) {
            data["notices"] = [];
            for (let item of this.notices)
                data["notices"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IGuestResponseDto {
    status: string | null;
    guestmessage: string | null;
    /** Allergy information supplied by the guest when answering an invitation. */
    guestallergymessage: string | null;
    guestname: string | null;
    parentname: string | null;
    age: number | null;
    birthdaydate: string | null;
    birthday: boolean;
    ismainguest: boolean;
    phonecountrycode: number;
    phone: string | null;
    email: string | null;
    gender: string | null;
    otherinfo: string | null;
    guestid: string;
    inviteid: string;
    partybookingid: string;
    disableconfirmation: boolean;
    disablesendinvite: boolean;
    notices: NoticeDto[] | null;
}

export class ImageDto implements IImageDto {
    guid!: string;
    name!: string | null;
    urlname!: string | null;
    created!: string | null;
    extension!: string | null;
    description!: string | null;
    width!: number;
    height!: number;

    constructor(data?: IImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.urlname = _data["urlname"] !== undefined ? _data["urlname"] : null as any;
            this.created = _data["created"] !== undefined ? _data["created"] : null as any;
            this.extension = _data["extension"] !== undefined ? _data["extension"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
        }
    }

    static fromJS(data: any): ImageDto {
        data = typeof data === 'object' ? data : {};
        let result = new ImageDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["urlname"] = this.urlname !== undefined ? this.urlname : null as any;
        data["created"] = this.created !== undefined ? this.created : null as any;
        data["extension"] = this.extension !== undefined ? this.extension : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        return data;
    }
}

export interface IImageDto {
    guid: string;
    name: string | null;
    urlname: string | null;
    created: string | null;
    extension: string | null;
    description: string | null;
    width: number;
    height: number;
}

export class NoticeDto implements INoticeDto {
    message!: string | null;
    level!: NoticeNoticeLevelDto;

    constructor(data?: INoticeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
            this.level = _data["level"] !== undefined ? _data["level"] : null as any;
        }
    }

    static fromJS(data: any): NoticeDto {
        data = typeof data === 'object' ? data : {};
        let result = new NoticeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        data["level"] = this.level !== undefined ? this.level : null as any;
        return data;
    }
}

export interface INoticeDto {
    message: string | null;
    level: NoticeNoticeLevelDto;
}

export enum NoticeNoticeLevelDto {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}

export class PlaygroundDto implements IPlaygroundDto {
    name!: string | null;
    shortname!: string | null;
    translatednames!: { [key: string]: string; } | null;
    slug!: string | null;
    guid!: string | null;
    streetadress!: string | null;
    postalcode!: string | null;
    city!: string | null;
    phone!: string | null;
    adminemail!: string | null;
    contactemailchildclass!: string | null;
    contactemailpartybooking!: string | null;
    contactemailgroupbooking!: string | null;
    region!: RegionDto | null;
    regionid!: string | null;
    maplink!: string | null;
    costcenter!: string | null;
    priceextrabirthdaychild!: number;
    artnoextrabirthdaychild!: string | null;
    navartnoextrabirthdaychild!: string | null;
    disabled!: boolean;
    usenavdynamics!: boolean;
    partybookingopeningdatetime!: string | null;
    entrancebookingopeningdate!: string | null;
    /** Content to display for the user on the party opening screen, in all the markets languages. */
    partybookingopeningcontent!: { [key: string]: PartyBookingOpeningContentDto; };
    areas!: AreaDto[] | null;
    blockreservationsminutes!: number;
    usefoodexport!: boolean;

    constructor(data?: IPlaygroundDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.partybookingopeningcontent = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.shortname = _data["shortname"] !== undefined ? _data["shortname"] : null as any;
            if (_data["translatednames"]) {
                this.translatednames = {} as any;
                for (let key in _data["translatednames"]) {
                    if (_data["translatednames"].hasOwnProperty(key))
                        (this.translatednames as any)![key] = _data["translatednames"][key] !== undefined ? _data["translatednames"][key] : null as any;
                }
            }
            else {
                this.translatednames = null as any;
            }
            this.slug = _data["slug"] !== undefined ? _data["slug"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.streetadress = _data["streetadress"] !== undefined ? _data["streetadress"] : null as any;
            this.postalcode = _data["postalcode"] !== undefined ? _data["postalcode"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.adminemail = _data["adminemail"] !== undefined ? _data["adminemail"] : null as any;
            this.contactemailchildclass = _data["contactemailchildclass"] !== undefined ? _data["contactemailchildclass"] : null as any;
            this.contactemailpartybooking = _data["contactemailpartybooking"] !== undefined ? _data["contactemailpartybooking"] : null as any;
            this.contactemailgroupbooking = _data["contactemailgroupbooking"] !== undefined ? _data["contactemailgroupbooking"] : null as any;
            this.region = _data["region"] ? RegionDto.fromJS(_data["region"]) : null as any;
            this.regionid = _data["regionid"] !== undefined ? _data["regionid"] : null as any;
            this.maplink = _data["maplink"] !== undefined ? _data["maplink"] : null as any;
            this.costcenter = _data["costcenter"] !== undefined ? _data["costcenter"] : null as any;
            this.priceextrabirthdaychild = _data["priceextrabirthdaychild"] !== undefined ? _data["priceextrabirthdaychild"] : null as any;
            this.artnoextrabirthdaychild = _data["artnoextrabirthdaychild"] !== undefined ? _data["artnoextrabirthdaychild"] : null as any;
            this.navartnoextrabirthdaychild = _data["navartnoextrabirthdaychild"] !== undefined ? _data["navartnoextrabirthdaychild"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.usenavdynamics = _data["usenavdynamics"] !== undefined ? _data["usenavdynamics"] : null as any;
            this.partybookingopeningdatetime = _data["partybookingopeningdatetime"] !== undefined ? _data["partybookingopeningdatetime"] : null as any;
            this.entrancebookingopeningdate = _data["entrancebookingopeningdate"] !== undefined ? _data["entrancebookingopeningdate"] : null as any;
            if (_data["partybookingopeningcontent"]) {
                this.partybookingopeningcontent = {} as any;
                for (let key in _data["partybookingopeningcontent"]) {
                    if (_data["partybookingopeningcontent"].hasOwnProperty(key))
                        (this.partybookingopeningcontent as any)![key] = _data["partybookingopeningcontent"][key] ? PartyBookingOpeningContentDto.fromJS(_data["partybookingopeningcontent"][key]) : new PartyBookingOpeningContentDto();
                }
            }
            else {
                this.partybookingopeningcontent = null as any;
            }
            if (Array.isArray(_data["areas"])) {
                this.areas = [] as any;
                for (let item of _data["areas"])
                    this.areas!.push(AreaDto.fromJS(item));
            }
            else {
                this.areas = null as any;
            }
            this.blockreservationsminutes = _data["blockreservationsminutes"] !== undefined ? _data["blockreservationsminutes"] : null as any;
            this.usefoodexport = _data["usefoodexport"] !== undefined ? _data["usefoodexport"] : null as any;
        }
    }

    static fromJS(data: any): PlaygroundDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaygroundDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["shortname"] = this.shortname !== undefined ? this.shortname : null as any;
        if (this.translatednames) {
            data["translatednames"] = {};
            for (let key in this.translatednames) {
                if (this.translatednames.hasOwnProperty(key))
                    (data["translatednames"] as any)[key] = this.translatednames[key] !== undefined ? this.translatednames[key] : null as any;
            }
        }
        data["slug"] = this.slug !== undefined ? this.slug : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["streetadress"] = this.streetadress !== undefined ? this.streetadress : null as any;
        data["postalcode"] = this.postalcode !== undefined ? this.postalcode : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["adminemail"] = this.adminemail !== undefined ? this.adminemail : null as any;
        data["contactemailchildclass"] = this.contactemailchildclass !== undefined ? this.contactemailchildclass : null as any;
        data["contactemailpartybooking"] = this.contactemailpartybooking !== undefined ? this.contactemailpartybooking : null as any;
        data["contactemailgroupbooking"] = this.contactemailgroupbooking !== undefined ? this.contactemailgroupbooking : null as any;
        data["region"] = this.region ? this.region.toJSON() : null as any;
        data["regionid"] = this.regionid !== undefined ? this.regionid : null as any;
        data["maplink"] = this.maplink !== undefined ? this.maplink : null as any;
        data["costcenter"] = this.costcenter !== undefined ? this.costcenter : null as any;
        data["priceextrabirthdaychild"] = this.priceextrabirthdaychild !== undefined ? this.priceextrabirthdaychild : null as any;
        data["artnoextrabirthdaychild"] = this.artnoextrabirthdaychild !== undefined ? this.artnoextrabirthdaychild : null as any;
        data["navartnoextrabirthdaychild"] = this.navartnoextrabirthdaychild !== undefined ? this.navartnoextrabirthdaychild : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["usenavdynamics"] = this.usenavdynamics !== undefined ? this.usenavdynamics : null as any;
        data["partybookingopeningdatetime"] = this.partybookingopeningdatetime !== undefined ? this.partybookingopeningdatetime : null as any;
        data["entrancebookingopeningdate"] = this.entrancebookingopeningdate !== undefined ? this.entrancebookingopeningdate : null as any;
        if (this.partybookingopeningcontent) {
            data["partybookingopeningcontent"] = {};
            for (let key in this.partybookingopeningcontent) {
                if (this.partybookingopeningcontent.hasOwnProperty(key))
                    (data["partybookingopeningcontent"] as any)[key] = this.partybookingopeningcontent[key] ? this.partybookingopeningcontent[key].toJSON() : null as any;
            }
        }
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item ? item.toJSON() : null as any);
        }
        data["blockreservationsminutes"] = this.blockreservationsminutes !== undefined ? this.blockreservationsminutes : null as any;
        data["usefoodexport"] = this.usefoodexport !== undefined ? this.usefoodexport : null as any;
        return data;
    }
}

export interface IPlaygroundDto {
    name: string | null;
    shortname: string | null;
    translatednames: { [key: string]: string; } | null;
    slug: string | null;
    guid: string | null;
    streetadress: string | null;
    postalcode: string | null;
    city: string | null;
    phone: string | null;
    adminemail: string | null;
    contactemailchildclass: string | null;
    contactemailpartybooking: string | null;
    contactemailgroupbooking: string | null;
    region: RegionDto | null;
    regionid: string | null;
    maplink: string | null;
    costcenter: string | null;
    priceextrabirthdaychild: number;
    artnoextrabirthdaychild: string | null;
    navartnoextrabirthdaychild: string | null;
    disabled: boolean;
    usenavdynamics: boolean;
    partybookingopeningdatetime: string | null;
    entrancebookingopeningdate: string | null;
    /** Content to display for the user on the party opening screen, in all the markets languages. */
    partybookingopeningcontent: { [key: string]: PartyBookingOpeningContentDto; };
    areas: AreaDto[] | null;
    blockreservationsminutes: number;
    usefoodexport: boolean;
}

/** Time-zone information about a playground. */
export class PlaygroundTimeZoneInformationDto implements IPlaygroundTimeZoneInformationDto {
    /** The id of the playground. */
    playgroundId!: string;
    /** The Iana time-zone (can be used for momentjs). */
    ianaTimeZone!: string;
    /** The Windows time-zone. */
    windowsTimeZone!: string;

    constructor(data?: IPlaygroundTimeZoneInformationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.playgroundId = _data["playgroundId"] !== undefined ? _data["playgroundId"] : null as any;
            this.ianaTimeZone = _data["ianaTimeZone"] !== undefined ? _data["ianaTimeZone"] : null as any;
            this.windowsTimeZone = _data["windowsTimeZone"] !== undefined ? _data["windowsTimeZone"] : null as any;
        }
    }

    static fromJS(data: any): PlaygroundTimeZoneInformationDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlaygroundTimeZoneInformationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["playgroundId"] = this.playgroundId !== undefined ? this.playgroundId : null as any;
        data["ianaTimeZone"] = this.ianaTimeZone !== undefined ? this.ianaTimeZone : null as any;
        data["windowsTimeZone"] = this.windowsTimeZone !== undefined ? this.windowsTimeZone : null as any;
        return data;
    }
}

/** Time-zone information about a playground. */
export interface IPlaygroundTimeZoneInformationDto {
    /** The id of the playground. */
    playgroundId: string;
    /** The Iana time-zone (can be used for momentjs). */
    ianaTimeZone: string;
    /** The Windows time-zone. */
    windowsTimeZone: string;
}

export class PriceDto implements IPriceDto {
    pricevalue!: number | null;
    vat!: number;
    currency!: string | null;
    locationid!: string | null;
    locationname!: string | null;

    constructor(data?: IPriceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pricevalue = _data["pricevalue"] !== undefined ? _data["pricevalue"] : null as any;
            this.vat = _data["vat"] !== undefined ? _data["vat"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.locationid = _data["locationid"] !== undefined ? _data["locationid"] : null as any;
            this.locationname = _data["locationname"] !== undefined ? _data["locationname"] : null as any;
        }
    }

    static fromJS(data: any): PriceDto {
        data = typeof data === 'object' ? data : {};
        let result = new PriceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pricevalue"] = this.pricevalue !== undefined ? this.pricevalue : null as any;
        data["vat"] = this.vat !== undefined ? this.vat : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["locationid"] = this.locationid !== undefined ? this.locationid : null as any;
        data["locationname"] = this.locationname !== undefined ? this.locationname : null as any;
        return data;
    }
}

export interface IPriceDto {
    pricevalue: number | null;
    vat: number;
    currency: string | null;
    locationid: string | null;
    locationname: string | null;
}

export class RegionDto implements IRegionDto {
    name!: string | null;
    guid!: string;
    country!: CountryDto | null;
    countryid!: string | null;
    playgrounds!: PlaygroundDto[] | null;

    constructor(data?: IRegionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.country = _data["country"] ? CountryDto.fromJS(_data["country"]) : null as any;
            this.countryid = _data["countryid"] !== undefined ? _data["countryid"] : null as any;
            if (Array.isArray(_data["playgrounds"])) {
                this.playgrounds = [] as any;
                for (let item of _data["playgrounds"])
                    this.playgrounds!.push(PlaygroundDto.fromJS(item));
            }
            else {
                this.playgrounds = null as any;
            }
        }
    }

    static fromJS(data: any): RegionDto {
        data = typeof data === 'object' ? data : {};
        let result = new RegionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["country"] = this.country ? this.country.toJSON() : null as any;
        data["countryid"] = this.countryid !== undefined ? this.countryid : null as any;
        if (Array.isArray(this.playgrounds)) {
            data["playgrounds"] = [];
            for (let item of this.playgrounds)
                data["playgrounds"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface IRegionDto {
    name: string | null;
    guid: string;
    country: CountryDto | null;
    countryid: string | null;
    playgrounds: PlaygroundDto[] | null;
}

export class RemindGuestDto implements IRemindGuestDto {
    invitationids!: string[] | null;
    partybookingid!: string;

    constructor(data?: IRemindGuestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["invitationids"])) {
                this.invitationids = [] as any;
                for (let item of _data["invitationids"])
                    this.invitationids!.push(item);
            }
            else {
                this.invitationids = null as any;
            }
            this.partybookingid = _data["partybookingid"] !== undefined ? _data["partybookingid"] : null as any;
        }
    }

    static fromJS(data: any): RemindGuestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RemindGuestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.invitationids)) {
            data["invitationids"] = [];
            for (let item of this.invitationids)
                data["invitationids"].push(item);
        }
        data["partybookingid"] = this.partybookingid !== undefined ? this.partybookingid : null as any;
        return data;
    }
}

export interface IRemindGuestDto {
    invitationids: string[] | null;
    partybookingid: string;
}

export class RoomDto implements IRoomDto {
    name!: string | null;
    translatednames!: { [key: string]: string; } | null;
    translateddescriptions!: { [key: string]: string; } | null;
    description!: string | null;
    guid!: string | null;
    size!: number;
    maxguests!: number;
    recommendedmaxguests!: number;
    blockid!: string;
    block!: string | null;
    area!: AreaDto | null;
    areaid!: string | null;
    disabled!: boolean;
    image!: ImageDto | null;
    images!: ImageDto[] | null;
    theme!: RoomThemeDto | null;
    themeid!: string | null;

    constructor(data?: IRoomDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (_data["translatednames"]) {
                this.translatednames = {} as any;
                for (let key in _data["translatednames"]) {
                    if (_data["translatednames"].hasOwnProperty(key))
                        (this.translatednames as any)![key] = _data["translatednames"][key] !== undefined ? _data["translatednames"][key] : null as any;
                }
            }
            else {
                this.translatednames = null as any;
            }
            if (_data["translateddescriptions"]) {
                this.translateddescriptions = {} as any;
                for (let key in _data["translateddescriptions"]) {
                    if (_data["translateddescriptions"].hasOwnProperty(key))
                        (this.translateddescriptions as any)![key] = _data["translateddescriptions"][key] !== undefined ? _data["translateddescriptions"][key] : null as any;
                }
            }
            else {
                this.translateddescriptions = null as any;
            }
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.size = _data["size"] !== undefined ? _data["size"] : null as any;
            this.maxguests = _data["maxguests"] !== undefined ? _data["maxguests"] : null as any;
            this.recommendedmaxguests = _data["recommendedmaxguests"] !== undefined ? _data["recommendedmaxguests"] : null as any;
            this.blockid = _data["blockid"] !== undefined ? _data["blockid"] : null as any;
            this.block = _data["block"] !== undefined ? _data["block"] : null as any;
            this.area = _data["area"] ? AreaDto.fromJS(_data["area"]) : null as any;
            this.areaid = _data["areaid"] !== undefined ? _data["areaid"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : null as any;
            if (Array.isArray(_data["images"])) {
                this.images = [] as any;
                for (let item of _data["images"])
                    this.images!.push(ImageDto.fromJS(item));
            }
            else {
                this.images = null as any;
            }
            this.theme = _data["theme"] ? RoomThemeDto.fromJS(_data["theme"]) : null as any;
            this.themeid = _data["themeid"] !== undefined ? _data["themeid"] : null as any;
        }
    }

    static fromJS(data: any): RoomDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (this.translatednames) {
            data["translatednames"] = {};
            for (let key in this.translatednames) {
                if (this.translatednames.hasOwnProperty(key))
                    (data["translatednames"] as any)[key] = this.translatednames[key] !== undefined ? this.translatednames[key] : null as any;
            }
        }
        if (this.translateddescriptions) {
            data["translateddescriptions"] = {};
            for (let key in this.translateddescriptions) {
                if (this.translateddescriptions.hasOwnProperty(key))
                    (data["translateddescriptions"] as any)[key] = this.translateddescriptions[key] !== undefined ? this.translateddescriptions[key] : null as any;
            }
        }
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["size"] = this.size !== undefined ? this.size : null as any;
        data["maxguests"] = this.maxguests !== undefined ? this.maxguests : null as any;
        data["recommendedmaxguests"] = this.recommendedmaxguests !== undefined ? this.recommendedmaxguests : null as any;
        data["blockid"] = this.blockid !== undefined ? this.blockid : null as any;
        data["block"] = this.block !== undefined ? this.block : null as any;
        data["area"] = this.area ? this.area.toJSON() : null as any;
        data["areaid"] = this.areaid !== undefined ? this.areaid : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["image"] = this.image ? this.image.toJSON() : null as any;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item ? item.toJSON() : null as any);
        }
        data["theme"] = this.theme ? this.theme.toJSON() : null as any;
        data["themeid"] = this.themeid !== undefined ? this.themeid : null as any;
        return data;
    }
}

export interface IRoomDto {
    name: string | null;
    translatednames: { [key: string]: string; } | null;
    translateddescriptions: { [key: string]: string; } | null;
    description: string | null;
    guid: string | null;
    size: number;
    maxguests: number;
    recommendedmaxguests: number;
    blockid: string;
    block: string | null;
    area: AreaDto | null;
    areaid: string | null;
    disabled: boolean;
    image: ImageDto | null;
    images: ImageDto[] | null;
    theme: RoomThemeDto | null;
    themeid: string | null;
}

export class RoomThemeDto implements IRoomThemeDto {
    name!: string | null;
    guid!: string | null;
    image!: ImageDto | null;

    constructor(data?: IRoomThemeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.image = _data["image"] ? ImageDto.fromJS(_data["image"]) : null as any;
        }
    }

    static fromJS(data: any): RoomThemeDto {
        data = typeof data === 'object' ? data : {};
        let result = new RoomThemeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["image"] = this.image ? this.image.toJSON() : null as any;
        return data;
    }
}

export interface IRoomThemeDto {
    name: string | null;
    guid: string | null;
    image: ImageDto | null;
}

export class TimeSlotDto implements ITimeSlotDto {
    starttime!: string;
    displaystarttime!: string;
    comment!: string | null;
    endtime!: string;
    guid!: string;
    usealternativemailtemplate!: boolean | null;
    openbydefault!: boolean | null;
    status!: string | null;
    partysettingid!: string | null;
    blockid!: string | null;
    playcenter!: string | null;

    constructor(data?: ITimeSlotDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.starttime = _data["starttime"] !== undefined ? _data["starttime"] : null as any;
            this.displaystarttime = _data["displaystarttime"] !== undefined ? _data["displaystarttime"] : null as any;
            this.comment = _data["comment"] !== undefined ? _data["comment"] : null as any;
            this.endtime = _data["endtime"] !== undefined ? _data["endtime"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.usealternativemailtemplate = _data["usealternativemailtemplate"] !== undefined ? _data["usealternativemailtemplate"] : null as any;
            this.openbydefault = _data["openbydefault"] !== undefined ? _data["openbydefault"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.partysettingid = _data["partysettingid"] !== undefined ? _data["partysettingid"] : null as any;
            this.blockid = _data["blockid"] !== undefined ? _data["blockid"] : null as any;
            this.playcenter = _data["playcenter"] !== undefined ? _data["playcenter"] : null as any;
        }
    }

    static fromJS(data: any): TimeSlotDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeSlotDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["starttime"] = this.starttime !== undefined ? this.starttime : null as any;
        data["displaystarttime"] = this.displaystarttime !== undefined ? this.displaystarttime : null as any;
        data["comment"] = this.comment !== undefined ? this.comment : null as any;
        data["endtime"] = this.endtime !== undefined ? this.endtime : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["usealternativemailtemplate"] = this.usealternativemailtemplate !== undefined ? this.usealternativemailtemplate : null as any;
        data["openbydefault"] = this.openbydefault !== undefined ? this.openbydefault : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["partysettingid"] = this.partysettingid !== undefined ? this.partysettingid : null as any;
        data["blockid"] = this.blockid !== undefined ? this.blockid : null as any;
        data["playcenter"] = this.playcenter !== undefined ? this.playcenter : null as any;
        return data;
    }
}

export interface ITimeSlotDto {
    starttime: string;
    displaystarttime: string;
    comment: string | null;
    endtime: string;
    guid: string;
    usealternativemailtemplate: boolean | null;
    openbydefault: boolean | null;
    status: string | null;
    partysettingid: string | null;
    blockid: string | null;
    playcenter: string | null;
}

/** Model for updating an user. */
export class UpdateProfileModel implements IUpdateProfileModel {
    firstname!: string | null;
    lastname!: string | null;
    phone!: string | null;
    countrycode!: number | null;
    email!: string | null;
    preferredplaycenterid!: string | null;
    /** GDPR If the users disallow notifications on emails for newsletters, offers. */
    gdprdisallowinformation!: boolean | null;
    /** GDPR If the users disallow notifications on sms for newsletters, offers. */
    gdprdisallowsms!: boolean | null;
    /** GDPR If the users allow notifications on sms for newsletters, offers from partners. */
    gdprallowpartnerinformation!: boolean | null;
    /** GDPR If the users disallow notifications on sms for newsletters, offers from partners. */
    gdprallowpartnersms!: boolean | null;

    constructor(data?: IUpdateProfileModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstname = _data["firstname"] !== undefined ? _data["firstname"] : null as any;
            this.lastname = _data["lastname"] !== undefined ? _data["lastname"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.countrycode = _data["countrycode"] !== undefined ? _data["countrycode"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.preferredplaycenterid = _data["preferredplaycenterid"] !== undefined ? _data["preferredplaycenterid"] : null as any;
            this.gdprdisallowinformation = _data["gdprdisallowinformation"] !== undefined ? _data["gdprdisallowinformation"] : null as any;
            this.gdprdisallowsms = _data["gdprdisallowsms"] !== undefined ? _data["gdprdisallowsms"] : null as any;
            this.gdprallowpartnerinformation = _data["gdprallowpartnerinformation"] !== undefined ? _data["gdprallowpartnerinformation"] : null as any;
            this.gdprallowpartnersms = _data["gdprallowpartnersms"] !== undefined ? _data["gdprallowpartnersms"] : null as any;
        }
    }

    static fromJS(data: any): UpdateProfileModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProfileModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname !== undefined ? this.firstname : null as any;
        data["lastname"] = this.lastname !== undefined ? this.lastname : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["countrycode"] = this.countrycode !== undefined ? this.countrycode : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["preferredplaycenterid"] = this.preferredplaycenterid !== undefined ? this.preferredplaycenterid : null as any;
        data["gdprdisallowinformation"] = this.gdprdisallowinformation !== undefined ? this.gdprdisallowinformation : null as any;
        data["gdprdisallowsms"] = this.gdprdisallowsms !== undefined ? this.gdprdisallowsms : null as any;
        data["gdprallowpartnerinformation"] = this.gdprallowpartnerinformation !== undefined ? this.gdprallowpartnerinformation : null as any;
        data["gdprallowpartnersms"] = this.gdprallowpartnersms !== undefined ? this.gdprallowpartnersms : null as any;
        return data;
    }
}

/** Model for updating an user. */
export interface IUpdateProfileModel {
    firstname: string | null;
    lastname: string | null;
    phone: string | null;
    countrycode: number | null;
    email: string | null;
    preferredplaycenterid: string | null;
    /** GDPR If the users disallow notifications on emails for newsletters, offers. */
    gdprdisallowinformation: boolean | null;
    /** GDPR If the users disallow notifications on sms for newsletters, offers. */
    gdprdisallowsms: boolean | null;
    /** GDPR If the users allow notifications on sms for newsletters, offers from partners. */
    gdprallowpartnerinformation: boolean | null;
    /** GDPR If the users disallow notifications on sms for newsletters, offers from partners. */
    gdprallowpartnersms: boolean | null;
}

export class LocationListItem implements ILocationListItem {
    name!: string | null;
    streetadress!: string | null;
    slug!: string | null;
    translatednames!: { [key: string]: string; } | null;
    parentid!: string | null;
    guid!: string;
    disabled!: boolean;
    datatypename!: string | null;
    objecttype!: string | null;
    namepath!: string[] | null;
    path!: string[] | null;
    children!: LocationListItem[] | null;

    constructor(data?: ILocationListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.streetadress = _data["streetadress"] !== undefined ? _data["streetadress"] : null as any;
            this.slug = _data["slug"] !== undefined ? _data["slug"] : null as any;
            if (_data["translatednames"]) {
                this.translatednames = {} as any;
                for (let key in _data["translatednames"]) {
                    if (_data["translatednames"].hasOwnProperty(key))
                        (this.translatednames as any)![key] = _data["translatednames"][key] !== undefined ? _data["translatednames"][key] : null as any;
                }
            }
            else {
                this.translatednames = null as any;
            }
            this.parentid = _data["parentid"] !== undefined ? _data["parentid"] : null as any;
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : null as any;
            this.datatypename = _data["datatypename"] !== undefined ? _data["datatypename"] : null as any;
            this.objecttype = _data["objecttype"] !== undefined ? _data["objecttype"] : null as any;
            if (Array.isArray(_data["namepath"])) {
                this.namepath = [] as any;
                for (let item of _data["namepath"])
                    this.namepath!.push(item);
            }
            else {
                this.namepath = null as any;
            }
            if (Array.isArray(_data["path"])) {
                this.path = [] as any;
                for (let item of _data["path"])
                    this.path!.push(item);
            }
            else {
                this.path = null as any;
            }
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(LocationListItem.fromJS(item));
            }
            else {
                this.children = null as any;
            }
        }
    }

    static fromJS(data: any): LocationListItem {
        data = typeof data === 'object' ? data : {};
        let result = new LocationListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["streetadress"] = this.streetadress !== undefined ? this.streetadress : null as any;
        data["slug"] = this.slug !== undefined ? this.slug : null as any;
        if (this.translatednames) {
            data["translatednames"] = {};
            for (let key in this.translatednames) {
                if (this.translatednames.hasOwnProperty(key))
                    (data["translatednames"] as any)[key] = this.translatednames[key] !== undefined ? this.translatednames[key] : null as any;
            }
        }
        data["parentid"] = this.parentid !== undefined ? this.parentid : null as any;
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["disabled"] = this.disabled !== undefined ? this.disabled : null as any;
        data["datatypename"] = this.datatypename !== undefined ? this.datatypename : null as any;
        data["objecttype"] = this.objecttype !== undefined ? this.objecttype : null as any;
        if (Array.isArray(this.namepath)) {
            data["namepath"] = [];
            for (let item of this.namepath)
                data["namepath"].push(item);
        }
        if (Array.isArray(this.path)) {
            data["path"] = [];
            for (let item of this.path)
                data["path"].push(item);
        }
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }
}

export interface ILocationListItem {
    name: string | null;
    streetadress: string | null;
    slug: string | null;
    translatednames: { [key: string]: string; } | null;
    parentid: string | null;
    guid: string;
    disabled: boolean;
    datatypename: string | null;
    objecttype: string | null;
    namepath: string[] | null;
    path: string[] | null;
    children: LocationListItem[] | null;
}

export class PartyBookingOpeningContentDto implements IPartyBookingOpeningContentDto {
    pageTitle!: string;
    pageSubtitle!: string;
    cardImageId!: string;
    cardTitle!: string;
    cardText!: string;
    alertText!: string | null;
    calendarEventTitle!: string;
    calendarEventText!: string;
    addToCalenderButtonText!: string;

    constructor(data?: IPartyBookingOpeningContentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageTitle = _data["pageTitle"] !== undefined ? _data["pageTitle"] : null as any;
            this.pageSubtitle = _data["pageSubtitle"] !== undefined ? _data["pageSubtitle"] : null as any;
            this.cardImageId = _data["cardImageId"] !== undefined ? _data["cardImageId"] : null as any;
            this.cardTitle = _data["cardTitle"] !== undefined ? _data["cardTitle"] : null as any;
            this.cardText = _data["cardText"] !== undefined ? _data["cardText"] : null as any;
            this.alertText = _data["alertText"] !== undefined ? _data["alertText"] : null as any;
            this.calendarEventTitle = _data["calendarEventTitle"] !== undefined ? _data["calendarEventTitle"] : null as any;
            this.calendarEventText = _data["calendarEventText"] !== undefined ? _data["calendarEventText"] : null as any;
            this.addToCalenderButtonText = _data["addToCalenderButtonText"] !== undefined ? _data["addToCalenderButtonText"] : null as any;
        }
    }

    static fromJS(data: any): PartyBookingOpeningContentDto {
        data = typeof data === 'object' ? data : {};
        let result = new PartyBookingOpeningContentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageTitle"] = this.pageTitle !== undefined ? this.pageTitle : null as any;
        data["pageSubtitle"] = this.pageSubtitle !== undefined ? this.pageSubtitle : null as any;
        data["cardImageId"] = this.cardImageId !== undefined ? this.cardImageId : null as any;
        data["cardTitle"] = this.cardTitle !== undefined ? this.cardTitle : null as any;
        data["cardText"] = this.cardText !== undefined ? this.cardText : null as any;
        data["alertText"] = this.alertText !== undefined ? this.alertText : null as any;
        data["calendarEventTitle"] = this.calendarEventTitle !== undefined ? this.calendarEventTitle : null as any;
        data["calendarEventText"] = this.calendarEventText !== undefined ? this.calendarEventText : null as any;
        data["addToCalenderButtonText"] = this.addToCalenderButtonText !== undefined ? this.addToCalenderButtonText : null as any;
        return data;
    }
}

export interface IPartyBookingOpeningContentDto {
    pageTitle: string;
    pageSubtitle: string;
    cardImageId: string;
    cardTitle: string;
    cardText: string;
    alertText: string | null;
    calendarEventTitle: string;
    calendarEventText: string;
    addToCalenderButtonText: string;
}

export enum ApplicationNoticeType {
    EntranceBooking = "EntranceBooking",
    ChildClassBooking = "ChildClassBooking",
    PartyBooking = "PartyBooking",
}

export enum DateCriteriaComparable {
    NotSet = "NotSet",
    PartyDate = "PartyDate",
    BookDate = "BookDate",
    EventDate = "EventDate",
}

export enum ChildClassBookingPaymentStatus {
    Pending = "Pending",
    Paid = "Paid",
    Refunded = "Refunded",
}

export enum ChildClassClassType {
    SportKidz = "SportKidz",
    SportKidzTrial = "SportKidzTrial",
    LeoCamp = "LeoCamp",
}

export enum ChildClassTransactionLineType {
    Default = "Default",
    Credit = "Credit",
}

export enum ChildClassTransactionType {
    Capture = "Capture",
    Credit = "Credit",
    AwaitingPayment = "AwaitingPayment",
}

export enum CriteriaLessEqualMore {
    LessThan = "LessThan",
    Equal = "Equal",
    MoreThan = "MoreThan",
    NotEqual = "NotEqual",
}

export enum GiftCardOrderPaymentStatus {
    AwaitingPayment = "AwaitingPayment",
    Paid = "Paid",
    PaymentFailed = "PaymentFailed",
}

export enum PackageItemType {
    Default = "Default",
    Addon = "Addon",
    Exchange = "Exchange",
}

export enum PublishStatus {
    Draft = "Draft",
    Published = "Published",
    Unpublished = "Unpublished",
}

export enum PassOrderPaymentStatus {
    AwaitingPayment = "AwaitingPayment",
    Paid = "Paid",
    PaymentFailed = "PaymentFailed",
}

export enum DurationType {
    Day = "Day",
    Month = "Month",
    Year = "Year",
}

export enum DurationType2 {
    Days = "Days",
    Months = "Months",
    Years = "Years",
}

export enum SerialTicketArticleInactiveReason {
    None = "None",
    SoldOut = "SoldOut",
    PosArticle = "PosArticle",
}

export enum SerialTicketOrderPaymentStatus {
    AwaitingPayment = "AwaitingPayment",
    Paid = "Paid",
    PaymentFailed = "PaymentFailed",
    Refunded = "Refunded",
}

export enum PassArticleType {
    Period = "Period",
    OpenEndDate = "OpenEndDate",
}

/** A summary model containing information about a child that can or can't be selected for a pass. */
export class PassArticleChildSummaryDto implements IPassArticleChildSummaryDto {
    guid!: string;
    firstName!: string;
    lastName!: string | null;
    /** A warning message if the child can't be selected for the article. */
    warning!: string | null;
    birthDate!: Date;
    /** True if the child is selected for the article requested.
False otherwise. */
    readonly selectable!: boolean;

    constructor(data?: IPassArticleChildSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"] !== undefined ? _data["guid"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.warning = _data["warning"] !== undefined ? _data["warning"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            (this as any).selectable = _data["selectable"] !== undefined ? _data["selectable"] : null as any;
        }
    }

    static fromJS(data: any): PassArticleChildSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassArticleChildSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid !== undefined ? this.guid : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["warning"] = this.warning !== undefined ? this.warning : null as any;
        data["birthDate"] = this.birthDate ? formatDate(this.birthDate) : null as any;
        data["selectable"] = this.selectable !== undefined ? this.selectable : null as any;
        return data;
    }
}

/** A summary model containing information about a child that can or can't be selected for a pass. */
export interface IPassArticleChildSummaryDto {
    guid: string;
    firstName: string;
    lastName: string | null;
    /** A warning message if the child can't be selected for the article. */
    warning: string | null;
    birthDate: Date;
    /** True if the child is selected for the article requested.
False otherwise. */
    selectable: boolean;
}

/** The reason the article has been inactivated. */
export enum PassArticleInactiveReason {
    None = "None",
    SoldOut = "SoldOut",
    PosArticle = "PosArticle",
}

/** A summary model for the Leo.Database.Entities.Shop.Passes.PassArticleEntity. */
export class PassArticleSummaryDto implements IPassArticleSummaryDto {
    id!: number;
    name!: string;
    /** The subscription card types that are available. */
    type!: PassArticleType2;
    description!: string;
    price!: number;
    /** The currency for the price. */
    currency!: string;
    sellablePeriodStartDate!: Date | null;
    sellablePeriodEndDate!: Date | null;
    /** Properties for a Leo.Database.Enums.Shop.Passes.PassArticleType.Period card article. */
    periodCardProperties!: PassPeriodDto | null;
    /** Properties set if the Leo.PublicApi.Controllers.V1.PassArticles.Models.PassArticleSummaryDto.Type is set to Leo.PublicApi.Controllers.V1.PassArticles.Enums.PassArticleType.OpenEndDate. */
    openEndDateCardProperties!: PassLengthDto | null;
    locationId!: string;
    /** The name of the Leo.PublicApi.Controllers.V1.PassArticles.Models.PassArticleSummaryDto.LocationId. */
    locationName!: string;
    /** True if the article currently is actively sellable. */
    isActive!: boolean;
    /** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
    media!: MediaItemDto;
    inactiveReason!: PassArticleInactiveReason | null;

    constructor(data?: IPassArticleSummaryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.currency = _data["currency"] !== undefined ? _data["currency"] : null as any;
            this.sellablePeriodStartDate = _data["sellablePeriodStartDate"] ? new Date(_data["sellablePeriodStartDate"].toString()) : null as any;
            this.sellablePeriodEndDate = _data["sellablePeriodEndDate"] ? new Date(_data["sellablePeriodEndDate"].toString()) : null as any;
            this.periodCardProperties = _data["periodCardProperties"] ? PassPeriodDto.fromJS(_data["periodCardProperties"]) : null as any;
            this.openEndDateCardProperties = _data["openEndDateCardProperties"] ? PassLengthDto.fromJS(_data["openEndDateCardProperties"]) : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.locationName = _data["locationName"] !== undefined ? _data["locationName"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
            this.inactiveReason = _data["inactiveReason"] !== undefined ? _data["inactiveReason"] : null as any;
        }
    }

    static fromJS(data: any): PassArticleSummaryDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassArticleSummaryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["currency"] = this.currency !== undefined ? this.currency : null as any;
        data["sellablePeriodStartDate"] = this.sellablePeriodStartDate ? formatDate(this.sellablePeriodStartDate) : null as any;
        data["sellablePeriodEndDate"] = this.sellablePeriodEndDate ? formatDate(this.sellablePeriodEndDate) : null as any;
        data["periodCardProperties"] = this.periodCardProperties ? this.periodCardProperties.toJSON() : null as any;
        data["openEndDateCardProperties"] = this.openEndDateCardProperties ? this.openEndDateCardProperties.toJSON() : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        data["media"] = this.media ? this.media.toJSON() : null as any;
        data["inactiveReason"] = this.inactiveReason !== undefined ? this.inactiveReason : null as any;
        return data;
    }
}

/** A summary model for the Leo.Database.Entities.Shop.Passes.PassArticleEntity. */
export interface IPassArticleSummaryDto {
    id: number;
    name: string;
    /** The subscription card types that are available. */
    type: PassArticleType2;
    description: string;
    price: number;
    /** The currency for the price. */
    currency: string;
    sellablePeriodStartDate: Date | null;
    sellablePeriodEndDate: Date | null;
    /** Properties for a Leo.Database.Enums.Shop.Passes.PassArticleType.Period card article. */
    periodCardProperties: PassPeriodDto | null;
    /** Properties set if the Leo.PublicApi.Controllers.V1.PassArticles.Models.PassArticleSummaryDto.Type is set to Leo.PublicApi.Controllers.V1.PassArticles.Enums.PassArticleType.OpenEndDate. */
    openEndDateCardProperties: PassLengthDto | null;
    locationId: string;
    /** The name of the Leo.PublicApi.Controllers.V1.PassArticles.Models.PassArticleSummaryDto.LocationId. */
    locationName: string;
    /** True if the article currently is actively sellable. */
    isActive: boolean;
    /** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
    media: MediaItemDto;
    inactiveReason: PassArticleInactiveReason | null;
}

/** The subscription card types that are available. */
export enum PassArticleType2 {
    Period = "Period",
    OpenEndDate = "OpenEndDate",
}

/** Properties for a Leo.Database.Enums.Shop.Passes.PassArticleType.OpenEndDate card article. */
export class PassLengthDto implements IPassLengthDto {
    /** The length of the Leo.Database.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    length!: number;
    /** The type of Leo.PublicApi.Controllers.V1.PassArticles.Models.PassLengthDto.Length. */
    type!: DurationType;

    constructor(data?: IPassLengthDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.length = _data["length"] !== undefined ? _data["length"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): PassLengthDto {
        data = typeof data === 'object' ? data : {};
        let result = new PassLengthDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["length"] = this.length !== undefined ? this.length : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }
}

/** Properties for a Leo.Database.Enums.Shop.Passes.PassArticleType.OpenEndDate card article. */
export interface IPassLengthDto {
    /** The length of the Leo.Database.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    length: number;
    /** The type of Leo.PublicApi.Controllers.V1.PassArticles.Models.PassLengthDto.Length. */
    type: DurationType;
}

export class PasswordOptions implements IPasswordOptions {
    requiredLength!: number;
    requiredUniqueChars!: number;
    requireNonAlphanumeric!: boolean;
    requireLowercase!: boolean;
    requireUppercase!: boolean;
    requireDigit!: boolean;

    constructor(data?: IPasswordOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requiredLength = _data["requiredLength"] !== undefined ? _data["requiredLength"] : null as any;
            this.requiredUniqueChars = _data["requiredUniqueChars"] !== undefined ? _data["requiredUniqueChars"] : null as any;
            this.requireNonAlphanumeric = _data["requireNonAlphanumeric"] !== undefined ? _data["requireNonAlphanumeric"] : null as any;
            this.requireLowercase = _data["requireLowercase"] !== undefined ? _data["requireLowercase"] : null as any;
            this.requireUppercase = _data["requireUppercase"] !== undefined ? _data["requireUppercase"] : null as any;
            this.requireDigit = _data["requireDigit"] !== undefined ? _data["requireDigit"] : null as any;
        }
    }

    static fromJS(data: any): PasswordOptions {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requiredLength"] = this.requiredLength !== undefined ? this.requiredLength : null as any;
        data["requiredUniqueChars"] = this.requiredUniqueChars !== undefined ? this.requiredUniqueChars : null as any;
        data["requireNonAlphanumeric"] = this.requireNonAlphanumeric !== undefined ? this.requireNonAlphanumeric : null as any;
        data["requireLowercase"] = this.requireLowercase !== undefined ? this.requireLowercase : null as any;
        data["requireUppercase"] = this.requireUppercase !== undefined ? this.requireUppercase : null as any;
        data["requireDigit"] = this.requireDigit !== undefined ? this.requireDigit : null as any;
        return data;
    }
}

export interface IPasswordOptions {
    requiredLength: number;
    requiredUniqueChars: number;
    requireNonAlphanumeric: boolean;
    requireLowercase: boolean;
    requireUppercase: boolean;
    requireDigit: boolean;
}

/** A sellable shop card article. */
export class SellablePassArticleModel implements ISellablePassArticleModel {
    id!: number;
    name!: string;
    type!: PassArticleType;
    description!: string;
    /** The price of the article, in the location currency. */
    price!: number;
    locationId!: string;
    /** Properties for a Leo.Database.Enums.Shop.Passes.PassArticleType.Period card article. */
    periodCardProperties!: PassPeriodDto | null;
    /** Properties set if the Leo.PublicApi.Controllers.V1.PassArticles.Models.SellablePassArticleModel.Type is set to Leo.Database.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    openEndDateCardProperties!: PassLengthDto | null;
    /** The name of the location. */
    locationName!: string;
    rules!: string;
    /** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
    media!: MediaItemDto;

    constructor(data?: ISellablePassArticleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
        if (!data) {
            this.media = new MediaItemDto();
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
            this.price = _data["price"] !== undefined ? _data["price"] : null as any;
            this.locationId = _data["locationId"] !== undefined ? _data["locationId"] : null as any;
            this.periodCardProperties = _data["periodCardProperties"] ? PassPeriodDto.fromJS(_data["periodCardProperties"]) : null as any;
            this.openEndDateCardProperties = _data["openEndDateCardProperties"] ? PassLengthDto.fromJS(_data["openEndDateCardProperties"]) : null as any;
            this.locationName = _data["locationName"] !== undefined ? _data["locationName"] : null as any;
            this.rules = _data["rules"] !== undefined ? _data["rules"] : null as any;
            this.media = _data["media"] ? MediaItemDto.fromJS(_data["media"]) : new MediaItemDto();
        }
    }

    static fromJS(data: any): SellablePassArticleModel {
        data = typeof data === 'object' ? data : {};
        let result = new SellablePassArticleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        data["price"] = this.price !== undefined ? this.price : null as any;
        data["locationId"] = this.locationId !== undefined ? this.locationId : null as any;
        data["periodCardProperties"] = this.periodCardProperties ? this.periodCardProperties.toJSON() : null as any;
        data["openEndDateCardProperties"] = this.openEndDateCardProperties ? this.openEndDateCardProperties.toJSON() : null as any;
        data["locationName"] = this.locationName !== undefined ? this.locationName : null as any;
        data["rules"] = this.rules !== undefined ? this.rules : null as any;
        data["media"] = this.media ? this.media.toJSON() : null as any;
        return data;
    }
}

/** A sellable shop card article. */
export interface ISellablePassArticleModel {
    id: number;
    name: string;
    type: PassArticleType;
    description: string;
    /** The price of the article, in the location currency. */
    price: number;
    locationId: string;
    /** Properties for a Leo.Database.Enums.Shop.Passes.PassArticleType.Period card article. */
    periodCardProperties: PassPeriodDto | null;
    /** Properties set if the Leo.PublicApi.Controllers.V1.PassArticles.Models.SellablePassArticleModel.Type is set to Leo.Database.Enums.Shop.Passes.PassArticleType.OpenEndDate. */
    openEndDateCardProperties: PassLengthDto | null;
    /** The name of the location. */
    locationName: string;
    rules: string;
    /** Dto object for the Leo.Database.Entities.Media.MediaItemEntity object. */
    media: MediaItemDto;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' + 
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export class SwaggerApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerApiException = true;

    static isSwaggerApiException(obj: any): obj is SwaggerApiException {
        return obj.isSwaggerApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerApiException(message, status, response, headers, result);
}